/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateUserInput = {
  id?: string | null,
  email: string,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  address?: AddressInput | null,
  avatar?: string | null,
  userBio?: string | null,
  age?: number | null,
  dateOfBirth?: string | null,
  genderId?: string | null,
  createdAt?: string | null,
  status: UserStatusEnum,
  lastSeen?: number | null,
  referralSource: string,
  roles: Array< RolesEnum >,
  stage?: FunnelStageEnum | null,
  metadata: UserMetadataInput,
};

export type AddressInput = {
  houseNumber?: string | null,
  street?: string | null,
  streetType?: string | null,
  address1: string,
  address2?: string | null,
  address3?: string | null,
  city: string,
  state: string,
  postalCode: string,
  county?: string | null,
  country?: string | null,
  latLng?: LocationPointInput | null,
};

export type LocationPointInput = {
  lat?: number | null,
  lon?: number | null,
};

export enum UserStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  SUSPENDED = "SUSPENDED",
  DELETED = "DELETED",
}


export enum RolesEnum {
  TRIAL_MEMBER = "TRIAL_MEMBER",
  MEMBER = "MEMBER",
  ADMIN = "ADMIN",
  COACH = "COACH",
  SUPERADMIN = "SUPERADMIN",
  EDITOR = "EDITOR",
  APPROVER = "APPROVER",
  REVIEWER = "REVIEWER",
}


export enum FunnelStageEnum {
  ACCOUNT_CREATED = "ACCOUNT_CREATED",
  INTAKE_COMPLETED = "INTAKE_COMPLETED",
  ISS_BOOKED = "ISS_BOOKED",
  ISS_CONFIRMED = "ISS_CONFIRMED",
  ISS_COMPLETED = "ISS_COMPLETED",
  ISS_CANCELLED = "ISS_CANCELLED",
  ISS_NO_SHOW = "ISS_NO_SHOW",
  VERBAL_CONVERSION_COMMITTMENT = "VERBAL_CONVERSION_COMMITTMENT",
  NON_CONVERTED = "NON_CONVERTED",
  MEMBERSHIP_CREATED = "MEMBERSHIP_CREATED",
  MEMBERSHIP_PAUSED = "MEMBERSHIP_PAUSED",
  MEMBERSHIP_CANCELLED = "MEMBERSHIP_CANCELLED",
  MEMBERSIP_GRADUATED = "MEMBERSIP_GRADUATED",
}


export type UserMetadataInput = {
  lastLogin: number,
  trialStartDate?: string | null,
  trialEndDate?: string | null,
  subscriptionStatus?: SubscriptionStatusEnum | null,
  deviceId?: string | null,
  deviceOS?: string | null,
  deviceOSVersion?: string | null,
  allowAccountNotifications?: boolean | null,
  allowMarketingNotifications?: boolean | null,
  allowCoachingNotifications?: boolean | null,
  initialAssessmentCompletedDate?: string | null,
  lastWeeklyCheckinDate?: string | null,
  lastGrowthStageAssessmentDate?: string | null,
  primaryFocusCategoryId?: string | null,
  primaryFocusGoalId?: string | null,
  secondaryFocusCategoryId?: string | null,
  secondaryFocusGoalId?: string | null,
  tertiaryFocusCategoryId?: string | null,
  tertiaryFocusGoalId?: string | null,
  preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
  preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
  primaryCoachId?: string | null,
  userIPAddress?: string | null,
  intakeCompleted?: BoolEnum | null,
  onboardingCompleted?: BoolEnum | null,
  issCompleted?: BoolEnum | null,
  stipeCustomerId?: string | null,
  lastActive?: number | null,
};

export enum SubscriptionStatusEnum {
  SUBSCRIPTION_CURRENT = "SUBSCRIPTION_CURRENT",
  SUBSCRIPTION_CARD_ERROR = "SUBSCRIPTION_CARD_ERROR",
  SUBSCRIPTION_DELINQUENT = "SUBSCRIPTION_DELINQUENT",
  SUBSCRIPTION_INACTIVE = "SUBSCRIPTION_INACTIVE",
  SUBSCRIPTION_FROZEN = "SUBSCRIPTION_FROZEN",
}


export enum TimeOfDayEnum {
  MORNING = "MORNING",
  MIDDAY = "MIDDAY",
  EVENING = "EVENING",
}


export enum DaysOfWeekEnum {
  M = "M",
  T = "T",
  W = "W",
  TH = "TH",
  F = "F",
}


export enum BoolEnum {
  TRUE = "TRUE",
  FALSE = "FALSE",
}


export type ModelUserConditionInput = {
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  avatar?: ModelStringInput | null,
  userBio?: ModelStringInput | null,
  age?: ModelIntInput | null,
  dateOfBirth?: ModelStringInput | null,
  genderId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  status?: ModelUserStatusEnumInput | null,
  lastSeen?: ModelIntInput | null,
  referralSource?: ModelStringInput | null,
  roles?: ModelRolesEnumInput | null,
  stage?: ModelFunnelStageEnumInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelUserStatusEnumInput = {
  eq?: UserStatusEnum | null,
  ne?: UserStatusEnum | null,
};

export type ModelRolesEnumInput = {
  eq?: RolesEnum | null,
  ne?: RolesEnum | null,
};

export type ModelFunnelStageEnumInput = {
  eq?: FunnelStageEnum | null,
  ne?: FunnelStageEnum | null,
};

export type User = {
  __typename: "User",
  id: string,
  email: string,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  address?: Address | null,
  avatar?: string | null,
  userBio?: string | null,
  age?: number | null,
  dateOfBirth?: string | null,
  genderId?: string | null,
  createdAt: string,
  status: UserStatusEnum,
  lastSeen?: number | null,
  referralSource: string,
  roles: Array< RolesEnum >,
  stage?: FunnelStageEnum | null,
  plans?: ModelUserPlanConnection | null,
  appointments?: ModelUserAppointmentsConnection | null,
  coaches?: ModelUserCoachConnection | null,
  growthPaths?: ModelUserGrowthPathItemConnection | null,
  metadata: UserMetadata,
  updatedAt: string,
};

export type Address = {
  __typename: "Address",
  houseNumber?: string | null,
  street?: string | null,
  streetType?: string | null,
  address1: string,
  address2?: string | null,
  address3?: string | null,
  city: string,
  state: string,
  postalCode: string,
  county?: string | null,
  country?: string | null,
  latLng?: LocationPoint | null,
};

export type LocationPoint = {
  __typename: "LocationPoint",
  lat?: number | null,
  lon?: number | null,
};

export type ModelUserPlanConnection = {
  __typename: "ModelUserPlanConnection",
  items:  Array<UserPlan | null >,
  nextToken?: string | null,
};

export type UserPlan = {
  __typename: "UserPlan",
  id: string,
  userId: string,
  planId: string,
  plan?: Plan | null,
  planGroupId: string,
  planGroup?: PlanGroup | null,
  planPricingSlug: string,
  planPricing?: PlanPricing | null,
  startDate: string,
  endDate?: string | null,
  cancelled?: BoolEnum | null,
  cancellationReason?: string | null,
  createdAt: string,
  active: BoolEnum,
  metadata?: UserPlanMetadata | null,
  updatedAt: string,
};

export type Plan = {
  __typename: "Plan",
  id: string,
  planGroupId: string,
  planGroup?: PlanGroup | null,
  name: string,
  description?: string | null,
  active: BoolEnum,
  defaultPrice: number,
  defaultPlanPriceId?: string | null,
  discountsAllowed?: boolean | null,
  display?: boolean | null,
  isTrial?: boolean | null,
  upgradeable?: boolean | null,
  downgradeable?: boolean | null,
  features: Array< string >,
  createdAt: string,
  level: number,
  pricing?: ModelPlanPricingConnection | null,
  metadata?: PlanMetadata | null,
  updatedAt: string,
};

export type PlanGroup = {
  __typename: "PlanGroup",
  id: string,
  name: string,
  startDate: string,
  endDate: string,
  trialPeriod: number,
  createdAt: string,
  active: BoolEnum,
  plans?: ModelPlanConnection | null,
  updatedAt: string,
};

export type ModelPlanConnection = {
  __typename: "ModelPlanConnection",
  items:  Array<Plan | null >,
  nextToken?: string | null,
};

export type ModelPlanPricingConnection = {
  __typename: "ModelPlanPricingConnection",
  items:  Array<PlanPricing | null >,
  nextToken?: string | null,
};

export type PlanPricing = {
  __typename: "PlanPricing",
  planId: string,
  plan?: Plan | null,
  slug: string,
  default: boolean,
  activationCodes?: Array< string | null > | null,
  downgradePricingIds?: Array< string | null > | null,
  upgradePricingIds?: Array< string | null > | null,
  price: number,
  metadata?: PlanPricingMetada | null,
  createdAt: string,
  updatedAt: string,
};

export type PlanPricingMetada = {
  __typename: "PlanPricingMetada",
  stripePriceId?: string | null,
};

export type PlanMetadata = {
  __typename: "PlanMetadata",
  coachingSessionsAllocated: number,
  stripeProductId?: string | null,
};

export type UserPlanMetadata = {
  __typename: "UserPlanMetadata",
  stripeSubscriptionId?: string | null,
  stripeCustomerId?: string | null,
};

export type ModelUserAppointmentsConnection = {
  __typename: "ModelUserAppointmentsConnection",
  items:  Array<UserAppointments | null >,
  nextToken?: string | null,
};

export type UserAppointments = {
  __typename: "UserAppointments",
  id: string,
  userId: string,
  user?: User | null,
  coachId: string,
  coach?: Coach | null,
  appointmentStartTime: number,
  appointmentEndTime: number,
  appointmentDurationMins: number,
  appointmentTimezone: string,
  appointmentType: AppointmentTypeEnum,
  cancelled?: BoolEnum | null,
  cancelDate?: number | null,
  cancelReason?: string | null,
  cancelNote?: string | null,
  metadata: UserAppointementMetadata,
  createdAt: string,
  updatedAt: string,
};

export type Coach = {
  __typename: "Coach",
  id: string,
  firstName: string,
  lastName: string,
  email: string,
  title?: string | null,
  coachType?: Array< CoachTypeEnum | null > | null,
  avatarUrl?: string | null,
  description?: string | null,
  metadata?: CoachMetaData | null,
  focusAreas?: ModelCoachFocusAreaConnection | null,
  members?: ModelUserCoachConnection | null,
  active: BoolEnum,
  createdAt: string,
  updatedAt: string,
};

export enum CoachTypeEnum {
  NUTRITION = "NUTRITION",
  MINDSET = "MINDSET",
  BODY_IMAGE = "BODY_IMAGE",
}


export type CoachMetaData = {
  __typename: "CoachMetaData",
  introVideoUrl?: string | null,
  gcalId?: string | null,
  calendlyId?: string | null,
  acuityCalendarId?: string | null,
  acuityUserId?: string | null,
  acuityKey?: string | null,
  acuityIssAppointmentId?: string | null,
  acuityRegularAppointmentId?: string | null,
  streamChatId?: string | null,
  slackId?: string | null,
  lastCoachNote?: number | null,
  lastChatMessage?: number | null,
};

export type ModelCoachFocusAreaConnection = {
  __typename: "ModelCoachFocusAreaConnection",
  items:  Array<CoachFocusArea | null >,
  nextToken?: string | null,
};

export type CoachFocusArea = {
  __typename: "CoachFocusArea",
  id: string,
  coachId: string,
  coach?: Coach | null,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  createdAt: string,
  updatedAt: string,
};

export type FocusArea = {
  __typename: "FocusArea",
  id: string,
  name: string,
  slug: string,
  description?: string | null,
  focusAreaGoals?: ModelFocusAreaGoalConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelFocusAreaGoalConnection = {
  __typename: "ModelFocusAreaGoalConnection",
  items:  Array<FocusAreaGoal | null >,
  nextToken?: string | null,
};

export type FocusAreaGoal = {
  __typename: "FocusAreaGoal",
  id: string,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  focusAreaGoalHabits?: ModelFocusAreaGoalHabitsConnection | null,
  name: string,
  slug: string,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelFocusAreaGoalHabitsConnection = {
  __typename: "ModelFocusAreaGoalHabitsConnection",
  items:  Array<FocusAreaGoalHabits | null >,
  nextToken?: string | null,
};

export type FocusAreaGoalHabits = {
  __typename: "FocusAreaGoalHabits",
  id: string,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  focusAreaGoalId: string,
  focusAreaGoal?: FocusAreaGoal | null,
  name: string,
  slug: string,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelUserCoachConnection = {
  __typename: "ModelUserCoachConnection",
  items:  Array<UserCoach | null >,
  nextToken?: string | null,
};

export type UserCoach = {
  __typename: "UserCoach",
  userId: string,
  user?: User | null,
  coachId: string,
  coach?: Coach | null,
  isPrimary: BoolEnum,
  active: BoolEnum,
  coachingStartDate: string,
  coachingEndDate?: string | null,
  ratings?: ModelUserCoachRatingConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelUserCoachRatingConnection = {
  __typename: "ModelUserCoachRatingConnection",
  items:  Array<UserCoachRating | null >,
  nextToken?: string | null,
};

export type UserCoachRating = {
  __typename: "UserCoachRating",
  userId: string,
  user?: User | null,
  coachId: string,
  coach?: Coach | null,
  rating: number,
  comment?: string | null,
  ratingTimestamp: number,
  createdAt: string,
  updatedAt: string,
};

export enum AppointmentTypeEnum {
  INITIAL_STRATEGY = "INITIAL_STRATEGY",
  ONE_ON_ONE = "ONE_ON_ONE",
  GROUP = "GROUP",
}


export type UserAppointementMetadata = {
  __typename: "UserAppointementMetadata",
  acuityAppointmentId?: string | null,
  acuityAppointmentTypeId?: string | null,
  acuityConfirmationPageUrl?: string | null,
};

export type ModelUserGrowthPathItemConnection = {
  __typename: "ModelUserGrowthPathItemConnection",
  items:  Array<UserGrowthPathItem | null >,
  nextToken?: string | null,
};

export type UserGrowthPathItem = {
  __typename: "UserGrowthPathItem",
  id: string,
  growthPathItemId: string,
  growthPathItem?: GrowthPathItem | null,
  userId: string,
  order?: number | null,
  user?: User | null,
  dateTimeAdded: number,
  completed: BoolEnum,
  dismissed: BoolEnum,
  completedTimestamp?: number | null,
  expirationDate?: string | null,
  locked: BoolEnum,
  hidden: BoolEnum,
  isScheduled: BoolEnum,
  visibleDate: string,
  visibleTimestamp?: number | null,
  growthPathJourneyId?: string | null,
  growthPathJourneyStep?: number | null,
  growthPathJourney?: GrowthPathJourney | null,
  coachId?: string | null,
  coach?: Coach | null,
  source?: UserGrowthPathItemSourceEnum | null,
  lastActivityTimestamp?: number | null,
  dependsOnGrowthPathItems?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type GrowthPathItem = {
  __typename: "GrowthPathItem",
  id: string,
  type: GrowthPathCardTypeEnum,
  title: string,
  subtitle?: string | null,
  avatarUrl?: string | null,
  description: string,
  categoryName?: string | null,
  categoryId?: string | null,
  estimatedCompletionTimeInMins?: number | null,
  actionTitle: string,
  actionDestination: string,
  actionPayload?: string | null,
  createdAt: string,
  expirationDate?: string | null,
  lessonId?: string | null,
  lesson?: Lesson | null,
  tags?: Array< string | null > | null,
  isArchived: BoolEnum,
  updatedAt: string,
};

export enum GrowthPathCardTypeEnum {
  COACH = "COACH",
  ASSESSMENT = "ASSESSMENT",
  GENERAL = "GENERAL",
  VIDEO = "VIDEO",
  ACTIVITY = "ACTIVITY",
  AUDIO = "AUDIO",
  LESSON = "LESSON",
  ARTICLE = "ARTICLE",
  WEBSITE = "WEBSITE",
}


export type Lesson = {
  __typename: "Lesson",
  id: string,
  programId: string,
  program?: Program | null,
  name: string,
  order: number,
  durationInMins: number,
  description?: string | null,
  transcript?: string | null,
  focusAreas?: ModelLessonFocusAreaConnection | null,
  tags?: Array< string | null > | null,
  lessonType: LessonTypeEnum,
  metadata?: LessonMetadata | null,
  coverImageUrl?: string | null,
  isPremium: BoolEnum,
  active: BoolEnum,
  createdAt: string,
  updatedAt: string,
};

export type Program = {
  __typename: "Program",
  id: string,
  name: string,
  description?: string | null,
  level: number,
  lessons?: ModelLessonConnection | null,
  active: BoolEnum,
  createdAt: string,
  updatedAt: string,
};

export type ModelLessonConnection = {
  __typename: "ModelLessonConnection",
  items:  Array<Lesson | null >,
  nextToken?: string | null,
};

export type ModelLessonFocusAreaConnection = {
  __typename: "ModelLessonFocusAreaConnection",
  items:  Array<LessonFocusArea | null >,
  nextToken?: string | null,
};

export type LessonFocusArea = {
  __typename: "LessonFocusArea",
  lessonId: string,
  lesson?: Lesson | null,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  createdAt: string,
  updatedAt: string,
};

export enum LessonTypeEnum {
  VIDEOS = "VIDEOS",
  FORM = "FORM",
  ARTICLE = "ARTICLE",
  EVENT = "EVENT",
  MISC = "MISC",
}


export type LessonMetadata = {
  __typename: "LessonMetadata",
  videoUrl?: string | null,
  videoStreamUrl?: string | null,
  videoExternalId?: string | null,
  videoDistributionPage?: string | null,
  formUrl?: string | null,
  formExternalId?: string | null,
};

export type GrowthPathJourney = {
  __typename: "GrowthPathJourney",
  id: string,
  title: string,
  description?: string | null,
  growthPathItems:  Array<GrowthPathJourneyGrowthPathItem >,
  focusAreaId: string,
  focusArea: FocusArea,
  active: BoolEnum,
  createdAt: string,
  updatedAt: string,
};

export type GrowthPathJourneyGrowthPathItem = {
  __typename: "GrowthPathJourneyGrowthPathItem",
  step: number,
  growthPathItemId: string,
  rules?:  Array<GrowthPathItemDependencies > | null,
};

export type GrowthPathItemDependencies = {
  __typename: "GrowthPathItemDependencies",
  ruleType: DependencyTypeEnum,
  dependencyGrowthPathItemId: string,
  scheduleDaysFromNow?: number | null,
};

export enum DependencyTypeEnum {
  BLOCKED_BY = "BLOCKED_BY",
  DEPENDS_ON = "DEPENDS_ON",
  CAUSES = "CAUSES",
  SCHEDULED = "SCHEDULED",
}


export enum UserGrowthPathItemSourceEnum {
  COACH = "COACH",
  JOURNEY = "JOURNEY",
  SYSTEM = "SYSTEM",
  AI = "AI",
}


export type UserMetadata = {
  __typename: "UserMetadata",
  lastLogin: number,
  trialStartDate?: string | null,
  trialEndDate?: string | null,
  subscriptionStatus?: SubscriptionStatusEnum | null,
  deviceId?: string | null,
  deviceOS?: string | null,
  deviceOSVersion?: string | null,
  allowAccountNotifications?: boolean | null,
  allowMarketingNotifications?: boolean | null,
  allowCoachingNotifications?: boolean | null,
  initialAssessmentCompletedDate?: string | null,
  lastWeeklyCheckinDate?: string | null,
  lastGrowthStageAssessmentDate?: string | null,
  primaryFocusCategoryId?: string | null,
  primaryFocusGoalId?: string | null,
  secondaryFocusCategoryId?: string | null,
  secondaryFocusGoalId?: string | null,
  tertiaryFocusCategoryId?: string | null,
  tertiaryFocusGoalId?: string | null,
  preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
  preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
  primaryCoachId?: string | null,
  userIPAddress?: string | null,
  intakeCompleted?: BoolEnum | null,
  onboardingCompleted?: BoolEnum | null,
  issCompleted?: BoolEnum | null,
  stipeCustomerId?: string | null,
  lastActive?: number | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelUserGrowthPathItemFilterInput = {
  id?: ModelIDInput | null,
  growthPathItemId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  dateTimeAdded?: ModelIntInput | null,
  completed?: ModelBoolEnumInput | null,
  dismissed?: ModelBoolEnumInput | null,
  completedTimestamp?: ModelIntInput | null,
  expirationDate?: ModelStringInput | null,
  locked?: ModelBoolEnumInput | null,
  hidden?: ModelBoolEnumInput | null,
  isScheduled?: ModelBoolEnumInput | null,
  visibleDate?: ModelStringInput | null,
  visibleTimestamp?: ModelIntInput | null,
  growthPathJourneyId?: ModelIDInput | null,
  growthPathJourneyStep?: ModelIntInput | null,
  coachId?: ModelIDInput | null,
  source?: ModelUserGrowthPathItemSourceEnumInput | null,
  lastActivityTimestamp?: ModelIntInput | null,
  dependsOnGrowthPathItems?: ModelStringInput | null,
  and?: Array< ModelUserGrowthPathItemFilterInput | null > | null,
  or?: Array< ModelUserGrowthPathItemFilterInput | null > | null,
  not?: ModelUserGrowthPathItemFilterInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelBoolEnumInput = {
  eq?: BoolEnum | null,
  ne?: BoolEnum | null,
};

export type ModelUserGrowthPathItemSourceEnumInput = {
  eq?: UserGrowthPathItemSourceEnum | null,
  ne?: UserGrowthPathItemSourceEnum | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  avatar?: ModelStringInput | null,
  userBio?: ModelStringInput | null,
  age?: ModelIntInput | null,
  dateOfBirth?: ModelStringInput | null,
  genderId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  status?: ModelUserStatusEnumInput | null,
  lastSeen?: ModelIntInput | null,
  referralSource?: ModelStringInput | null,
  roles?: ModelRolesEnumInput | null,
  stage?: ModelFunnelStageEnumInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type Event = {
  __typename: "Event",
  id: string,
  name: string,
  title: string,
  description?: string | null,
  features?:  Array<EventFeature > | null,
  startDate: string,
  endDate: string,
  startTimestamp: number,
  endTimestamp: number,
  timezone: string,
  hostFirstName: string,
  hostLastName: string,
  hostEmail?: string | null,
  hostWebsite?: string | null,
  hostAvatar?: string | null,
  allowFreeMembers: BoolEnum,
  allowSprout: BoolEnum,
  allowBloom: BoolEnum,
  eventType: EventTypeEnum,
  attendeeLimit: number,
  attendees?: ModelEventSessionAttendeesConnection | null,
  times?: ModelEventTimeConnection | null,
  sessions?: ModelEventSessionConnection | null,
  price: number,
  featureImageUrl?: string | null,
  metadata?: EventMetadata | null,
  createdAt: string,
  updatedAt: string,
};

export type EventFeature = {
  __typename: "EventFeature",
  title: string,
  description?: string | null,
};

export enum EventTypeEnum {
  SMALL_GROUP = "SMALL_GROUP",
  OPEN_TOPIC = "OPEN_TOPIC",
  GENERAL = "GENERAL",
}


export type ModelEventSessionAttendeesConnection = {
  __typename: "ModelEventSessionAttendeesConnection",
  items:  Array<EventSessionAttendees | null >,
  nextToken?: string | null,
};

export type EventSessionAttendees = {
  __typename: "EventSessionAttendees",
  eventSessionId: string,
  eventSession?: EventSession | null,
  userId: string,
  user?: User | null,
  eventId: string,
  event?: Event | null,
  confirmed: BoolEnum,
  confirmationTimestamp?: number | null,
  metadata?: EventSessionAttendeeMetadata | null,
  createdAt: string,
  updatedAt: string,
};

export type EventSession = {
  __typename: "EventSession",
  id: string,
  eventId: string,
  event?: Event | null,
  sessionTitle?: string | null,
  sessionDescription?: string | null,
  startDate: string,
  endDate: string,
  startTimestamp: number,
  endTimestamp: number,
  timezone: string,
  isRecurring: BoolEnum,
  allowFreeMembers: BoolEnum,
  allowSprout: BoolEnum,
  allowBloom: BoolEnum,
  attendeeLimit: number,
  facilitators?: ModelEventSessionFacilitatorConnection | null,
  eventSessionAttendees?: ModelEventSessionAttendeesConnection | null,
  times?: ModelEventSessionTimeConnection | null,
  eventSessionFocusAreaId?: string | null,
  eventSessionFocusArea?: FocusArea | null,
  featureImageUrl?: string | null,
  metadata?: EventSessionMetadata | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelEventSessionFacilitatorConnection = {
  __typename: "ModelEventSessionFacilitatorConnection",
  items:  Array<EventSessionFacilitator | null >,
  nextToken?: string | null,
};

export type EventSessionFacilitator = {
  __typename: "EventSessionFacilitator",
  eventSessionId: string,
  coachId: string,
  coach?: Coach | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelEventSessionTimeConnection = {
  __typename: "ModelEventSessionTimeConnection",
  items:  Array<EventSessionTime | null >,
  nextToken?: string | null,
};

export type EventSessionTime = {
  __typename: "EventSessionTime",
  eventSessionId: string,
  eventSession?: EventSession | null,
  eventId: string,
  event?: Event | null,
  name: string,
  title: string,
  type: EventTimeTypeEnum,
  description?: string | null,
  startDate: string,
  endDate: string,
  timezone?: string | null,
  metadata?: EventSessionTimeMetadata | null,
  createdAt: string,
  updatedAt: string,
};

export enum EventTimeTypeEnum {
  WORKSHOP = "WORKSHOP",
  DISCUSSION = "DISCUSSION",
  GENERAL = "GENERAL",
}


export type EventSessionTimeMetadata = {
  __typename: "EventSessionTimeMetadata",
  acuityCalendarId?: string | null,
  acuityAppointmentTypeId?: string | null,
  meetingLinkVideo?: string | null,
  meetingLinkAudio?: string | null,
  recordingLink?: string | null,
};

export type EventSessionMetadata = {
  __typename: "EventSessionMetadata",
  chatChannelId?: string | null,
  eventSessionLandingPageUrl?: string | null,
  eventSessionMeetingLink?: string | null,
  actuityAppointmentTypeId?: string | null,
  acuityCalendarId?: string | null,
  activeCampaignTagId?: number | null,
};

export type EventSessionAttendeeMetadata = {
  __typename: "EventSessionAttendeeMetadata",
  paymentTimestamp?: number | null,
  stripeInvoiceId?: string | null,
  rawPaymentLog?: string | null,
};

export type ModelEventTimeConnection = {
  __typename: "ModelEventTimeConnection",
  items:  Array<EventTime | null >,
  nextToken?: string | null,
};

export type EventTime = {
  __typename: "EventTime",
  eventId: string,
  event?: Event | null,
  name: string,
  title: string,
  type: EventTimeTypeEnum,
  description?: string | null,
  startDate: string,
  endDate: string,
  timezone?: string | null,
  allowFreeMembers: BoolEnum,
  allowSprout: BoolEnum,
  allowBloom: BoolEnum,
  metadata?: EventTimeMetadata | null,
  createdAt: string,
  updatedAt: string,
};

export type EventTimeMetadata = {
  __typename: "EventTimeMetadata",
  acuityCalendarId?: string | null,
  acuityAppointmentTypeId?: string | null,
  meetingLinkVideo?: string | null,
  meetingLinkAudio?: string | null,
  recordingLink?: string | null,
};

export type ModelEventSessionConnection = {
  __typename: "ModelEventSessionConnection",
  items:  Array<EventSession | null >,
  nextToken?: string | null,
};

export type EventMetadata = {
  __typename: "EventMetadata",
  stripeProductId?: string | null,
  stripePriceId?: string | null,
  eventLandingPageUrl?: string | null,
  eventMeetingLink?: string | null,
  activeCampaignTagId?: number | null,
  totalSessions?: number | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelEventFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startTimestamp?: ModelIntInput | null,
  endTimestamp?: ModelIntInput | null,
  timezone?: ModelStringInput | null,
  hostFirstName?: ModelStringInput | null,
  hostLastName?: ModelStringInput | null,
  hostEmail?: ModelStringInput | null,
  hostWebsite?: ModelStringInput | null,
  hostAvatar?: ModelStringInput | null,
  allowFreeMembers?: ModelBoolEnumInput | null,
  allowSprout?: ModelBoolEnumInput | null,
  allowBloom?: ModelBoolEnumInput | null,
  eventType?: ModelEventTypeEnumInput | null,
  attendeeLimit?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  featureImageUrl?: ModelStringInput | null,
  and?: Array< ModelEventFilterInput | null > | null,
  or?: Array< ModelEventFilterInput | null > | null,
  not?: ModelEventFilterInput | null,
};

export type ModelEventTypeEnumInput = {
  eq?: EventTypeEnum | null,
  ne?: EventTypeEnum | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelEventConnection = {
  __typename: "ModelEventConnection",
  items:  Array<Event | null >,
  nextToken?: string | null,
};

export type AppointmentInput = {
  userId: string,
  coachId: string,
  appointmentType: AppointmentTypeEnum,
  appointmentStartTime: number,
  appointmentEndTime?: number | null,
  appointmentDurationMins?: number | null,
  appointmentTimezone?: string | null,
};

export type AcuityAppointmentInput = {
  calendarID: number,
  appointmentTypeID: number,
  datetime: string,
  firstName: string,
  lastName: string,
  email: string,
  phone?: string | null,
};

export type ACUserInput = {
  firstName: string,
  lastName: string,
  email: string,
  phone: string,
};

export type UpdateUserInput = {
  id: string,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  address?: AddressInput | null,
  avatar?: string | null,
  userBio?: string | null,
  age?: number | null,
  dateOfBirth?: string | null,
  genderId?: string | null,
  createdAt?: string | null,
  status?: UserStatusEnum | null,
  lastSeen?: number | null,
  referralSource?: string | null,
  roles?: Array< RolesEnum > | null,
  stage?: FunnelStageEnum | null,
  metadata?: UserMetadataInput | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateUserCoachInput = {
  userId: string,
  coachId: string,
  isPrimary: BoolEnum,
  active: BoolEnum,
  coachingStartDate: string,
  coachingEndDate?: string | null,
};

export type ModelUserCoachConditionInput = {
  isPrimary?: ModelBoolEnumInput | null,
  active?: ModelBoolEnumInput | null,
  coachingStartDate?: ModelStringInput | null,
  coachingEndDate?: ModelStringInput | null,
  and?: Array< ModelUserCoachConditionInput | null > | null,
  or?: Array< ModelUserCoachConditionInput | null > | null,
  not?: ModelUserCoachConditionInput | null,
};

export type UpdateUserCoachInput = {
  userId: string,
  coachId: string,
  isPrimary?: BoolEnum | null,
  active?: BoolEnum | null,
  coachingStartDate?: string | null,
  coachingEndDate?: string | null,
};

export type DeleteUserCoachInput = {
  userId: string,
  coachId: string,
};

export type CreateUserCoachRatingInput = {
  userId: string,
  coachId: string,
  rating: number,
  comment?: string | null,
  ratingTimestamp: number,
};

export type ModelUserCoachRatingConditionInput = {
  rating?: ModelFloatInput | null,
  comment?: ModelStringInput | null,
  ratingTimestamp?: ModelIntInput | null,
  and?: Array< ModelUserCoachRatingConditionInput | null > | null,
  or?: Array< ModelUserCoachRatingConditionInput | null > | null,
  not?: ModelUserCoachRatingConditionInput | null,
};

export type UpdateUserCoachRatingInput = {
  userId: string,
  coachId: string,
  rating?: number | null,
  comment?: string | null,
  ratingTimestamp?: number | null,
};

export type DeleteUserCoachRatingInput = {
  userId: string,
  coachId: string,
};

export type CreateUserCoachingNoteInput = {
  id?: string | null,
  userId: string,
  coachId: string,
  appointmentId?: string | null,
  note: string,
  visibleToUser: BoolEnum,
  createdAt?: string | null,
};

export type ModelUserCoachingNoteConditionInput = {
  userId?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  appointmentId?: ModelIDInput | null,
  note?: ModelStringInput | null,
  visibleToUser?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserCoachingNoteConditionInput | null > | null,
  or?: Array< ModelUserCoachingNoteConditionInput | null > | null,
  not?: ModelUserCoachingNoteConditionInput | null,
};

export type UserCoachingNote = {
  __typename: "UserCoachingNote",
  id: string,
  userId: string,
  coachId: string,
  appointmentId?: string | null,
  appointment?: UserAppointments | null,
  note: string,
  visibleToUser: BoolEnum,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserCoachingNoteInput = {
  id: string,
  userId?: string | null,
  coachId?: string | null,
  appointmentId?: string | null,
  note?: string | null,
  visibleToUser?: BoolEnum | null,
  createdAt?: string | null,
};

export type DeleteUserCoachingNoteInput = {
  id: string,
};

export type CreateUserStatsInput = {
  userId: string,
  totalHabitLogged?: number | null,
  totalAppointmentsScheduled?: number | null,
  totalLessonsWatched?: number | null,
  totalLogins?: number | null,
  totalMessages?: number | null,
};

export type ModelUserStatsConditionInput = {
  totalHabitLogged?: ModelIntInput | null,
  totalAppointmentsScheduled?: ModelIntInput | null,
  totalLessonsWatched?: ModelIntInput | null,
  totalLogins?: ModelIntInput | null,
  totalMessages?: ModelIntInput | null,
  and?: Array< ModelUserStatsConditionInput | null > | null,
  or?: Array< ModelUserStatsConditionInput | null > | null,
  not?: ModelUserStatsConditionInput | null,
};

export type UserStats = {
  __typename: "UserStats",
  userId: string,
  totalHabitLogged?: number | null,
  totalAppointmentsScheduled?: number | null,
  totalLessonsWatched?: number | null,
  totalLogins?: number | null,
  totalMessages?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserStatsInput = {
  userId: string,
  totalHabitLogged?: number | null,
  totalAppointmentsScheduled?: number | null,
  totalLessonsWatched?: number | null,
  totalLogins?: number | null,
  totalMessages?: number | null,
};

export type DeleteUserStatsInput = {
  userId: string,
};

export type CreateUserActivityLogInput = {
  id?: string | null,
  type: UserActivitiesEnum,
  source: ActivitySourceEnum,
  payload?: string | null,
  timestamp: number,
};

export enum UserActivitiesEnum {
  LOGGED_IN = "LOGGED_IN",
  BOOKED_SESSION = "BOOKED_SESSION",
  CANCELLED_SESSION = "CANCELLED_SESSION",
  COMPLETED_INTAKE = "COMPLETED_INTAKE",
  COMPLETED_ONBOARDING = "COMPLETED_ONBOARDING",
  COMPLETED_GROWTH_PATH_ITEM = "COMPLETED_GROWTH_PATH_ITEM",
  VIEWED_SCREEN = "VIEWED_SCREEN",
  WATCHED_LESSON = "WATCHED_LESSON",
  REGISTERED_FOR_EVENT = "REGISTERED_FOR_EVENT",
  MEMBERSHIP_CREATED = "MEMBERSHIP_CREATED",
  MEMBERSHIP_UPGRADED = "MEMBERSHIP_UPGRADED",
  MEMBERSHIP_DOWNGRADED = "MEMBERSHIP_DOWNGRADED",
  MEMBERSHIP_PAUSED = "MEMBERSHIP_PAUSED",
  MEMBERSHIP_CANCELLED = "MEMBERSHIP_CANCELLED",
  CHANGED_COACH = "CHANGED_COACH",
  UPDATED_ACCOUNT_INFORMATION = "UPDATED_ACCOUNT_INFORMATION",
  UPLOADED_PICTURE = "UPLOADED_PICTURE",
  STARTED_CHAT = "STARTED_CHAT",
  CREATED_GOAL = "CREATED_GOAL",
  LOGGED_GOAL = "LOGGED_GOAL",
  COMPLETED_ASSESSMENT = "COMPLETED_ASSESSMENT",
  JOURNAL_ENTRY_ADDED = "JOURNAL_ENTRY_ADDED",
  FORM_COMPLETED = "FORM_COMPLETED",
}


export enum ActivitySourceEnum {
  WEBAPP = "WEBAPP",
  MOBILEAPP = "MOBILEAPP",
  SYSTEM = "SYSTEM",
}


export type ModelUserActivityLogConditionInput = {
  type?: ModelUserActivitiesEnumInput | null,
  source?: ModelActivitySourceEnumInput | null,
  payload?: ModelStringInput | null,
  timestamp?: ModelIntInput | null,
  and?: Array< ModelUserActivityLogConditionInput | null > | null,
  or?: Array< ModelUserActivityLogConditionInput | null > | null,
  not?: ModelUserActivityLogConditionInput | null,
};

export type ModelUserActivitiesEnumInput = {
  eq?: UserActivitiesEnum | null,
  ne?: UserActivitiesEnum | null,
};

export type ModelActivitySourceEnumInput = {
  eq?: ActivitySourceEnum | null,
  ne?: ActivitySourceEnum | null,
};

export type UserActivityLog = {
  __typename: "UserActivityLog",
  id: string,
  type: UserActivitiesEnum,
  source: ActivitySourceEnum,
  payload?: string | null,
  timestamp: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserActivityLogInput = {
  id: string,
  type?: UserActivitiesEnum | null,
  source?: ActivitySourceEnum | null,
  payload?: string | null,
  timestamp?: number | null,
};

export type DeleteUserActivityLogInput = {
  id: string,
};

export type CreateJournalEntryTemplatesInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  templateText: string,
  templateBlocks: Array< LabelValueOptionTypeInput >,
  createdAt?: string | null,
};

export type LabelValueOptionTypeInput = {
  label: string,
  value: string,
};

export type ModelJournalEntryTemplatesConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  templateText?: ModelStringInput | null,
  and?: Array< ModelJournalEntryTemplatesConditionInput | null > | null,
  or?: Array< ModelJournalEntryTemplatesConditionInput | null > | null,
  not?: ModelJournalEntryTemplatesConditionInput | null,
};

export type JournalEntryTemplates = {
  __typename: "JournalEntryTemplates",
  id: string,
  name: string,
  description?: string | null,
  templateText: string,
  templateBlocks:  Array<LabelValueOptionType >,
  createdAt: string,
  updatedAt: string,
};

export type LabelValueOptionType = {
  __typename: "LabelValueOptionType",
  label: string,
  value: string,
};

export type UpdateJournalEntryTemplatesInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  templateText?: string | null,
  templateBlocks?: Array< LabelValueOptionTypeInput > | null,
  createdAt: string,
};

export type DeleteJournalEntryTemplatesInput = {
  id: string,
  createdAt: string,
};

export type CreateUserJournalEntryLogInput = {
  userId: string,
  entryTitle: string,
  entryLogType: JournalEntryLogTypeEnum,
  entryLogTags?: Array< LabelValueOptionTypeInput > | null,
  isVisibleToCoach: BoolEnum,
  isVisibleToPublic: BoolEnum,
  entryText: string,
  entryBlocks: Array< LabelValueOptionTypeInput >,
  journalEntryTemplateId?: string | null,
  rawEntry?: string | null,
  createdAt?: string | null,
};

export enum JournalEntryLogTypeEnum {
  PERSONAL_LOG = "PERSONAL_LOG",
  FORM_LOG = "FORM_LOG",
  SESSION_LOG = "SESSION_LOG",
}


export type ModelUserJournalEntryLogConditionInput = {
  entryTitle?: ModelStringInput | null,
  entryLogType?: ModelJournalEntryLogTypeEnumInput | null,
  isVisibleToCoach?: ModelBoolEnumInput | null,
  isVisibleToPublic?: ModelBoolEnumInput | null,
  entryText?: ModelStringInput | null,
  journalEntryTemplateId?: ModelIDInput | null,
  rawEntry?: ModelStringInput | null,
  and?: Array< ModelUserJournalEntryLogConditionInput | null > | null,
  or?: Array< ModelUserJournalEntryLogConditionInput | null > | null,
  not?: ModelUserJournalEntryLogConditionInput | null,
};

export type ModelJournalEntryLogTypeEnumInput = {
  eq?: JournalEntryLogTypeEnum | null,
  ne?: JournalEntryLogTypeEnum | null,
};

export type UserJournalEntryLog = {
  __typename: "UserJournalEntryLog",
  userId: string,
  entryTitle: string,
  entryLogType: JournalEntryLogTypeEnum,
  entryLogTags?:  Array<LabelValueOptionType > | null,
  isVisibleToCoach: BoolEnum,
  isVisibleToPublic: BoolEnum,
  entryText: string,
  entryBlocks:  Array<LabelValueOptionType >,
  journalEntryTemplateId?: string | null,
  rawEntry?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserJournalEntryLogInput = {
  userId: string,
  entryTitle?: string | null,
  entryLogType?: JournalEntryLogTypeEnum | null,
  entryLogTags?: Array< LabelValueOptionTypeInput > | null,
  isVisibleToCoach?: BoolEnum | null,
  isVisibleToPublic?: BoolEnum | null,
  entryText?: string | null,
  entryBlocks?: Array< LabelValueOptionTypeInput > | null,
  journalEntryTemplateId?: string | null,
  rawEntry?: string | null,
  createdAt: string,
};

export type DeleteUserJournalEntryLogInput = {
  userId: string,
  createdAt: string,
};

export type CreateUserPlanInput = {
  id?: string | null,
  userId: string,
  planId: string,
  planGroupId: string,
  planPricingSlug: string,
  startDate: string,
  endDate?: string | null,
  cancelled?: BoolEnum | null,
  cancellationReason?: string | null,
  createdAt?: string | null,
  active: BoolEnum,
  metadata?: UserPlanMetadataInput | null,
};

export type UserPlanMetadataInput = {
  stripeSubscriptionId?: string | null,
  stripeCustomerId?: string | null,
};

export type ModelUserPlanConditionInput = {
  userId?: ModelIDInput | null,
  planId?: ModelIDInput | null,
  planGroupId?: ModelIDInput | null,
  planPricingSlug?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  cancelled?: ModelBoolEnumInput | null,
  cancellationReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelUserPlanConditionInput | null > | null,
  or?: Array< ModelUserPlanConditionInput | null > | null,
  not?: ModelUserPlanConditionInput | null,
};

export type UpdateUserPlanInput = {
  id: string,
  userId?: string | null,
  planId?: string | null,
  planGroupId?: string | null,
  planPricingSlug?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  cancelled?: BoolEnum | null,
  cancellationReason?: string | null,
  createdAt?: string | null,
  active?: BoolEnum | null,
  metadata?: UserPlanMetadataInput | null,
};

export type DeleteUserPlanInput = {
  id: string,
};

export type CreateUserCoachingCreditsInput = {
  userId: string,
  yearMonth: number,
  creditsAwarded: number,
  creditsRemaining: number,
  lastUsedTimestamp?: number | null,
  createdAt?: string | null,
};

export type ModelUserCoachingCreditsConditionInput = {
  creditsAwarded?: ModelIntInput | null,
  creditsRemaining?: ModelIntInput | null,
  lastUsedTimestamp?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserCoachingCreditsConditionInput | null > | null,
  or?: Array< ModelUserCoachingCreditsConditionInput | null > | null,
  not?: ModelUserCoachingCreditsConditionInput | null,
};

export type UserCoachingCredits = {
  __typename: "UserCoachingCredits",
  userId: string,
  user?: User | null,
  yearMonth: number,
  creditsAwarded: number,
  creditsRemaining: number,
  lastUsedTimestamp?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserCoachingCreditsInput = {
  userId: string,
  yearMonth: number,
  creditsAwarded?: number | null,
  creditsRemaining?: number | null,
  lastUsedTimestamp?: number | null,
  createdAt?: string | null,
};

export type DeleteUserCoachingCreditsInput = {
  userId: string,
  yearMonth: number,
};

export type CreateUserCoachingCreditUsageLogInput = {
  userId: string,
  memo: string,
  timestamp: number,
  id?: string | null,
};

export type ModelUserCoachingCreditUsageLogConditionInput = {
  userId?: ModelIDInput | null,
  memo?: ModelStringInput | null,
  timestamp?: ModelIntInput | null,
  and?: Array< ModelUserCoachingCreditUsageLogConditionInput | null > | null,
  or?: Array< ModelUserCoachingCreditUsageLogConditionInput | null > | null,
  not?: ModelUserCoachingCreditUsageLogConditionInput | null,
};

export type UserCoachingCreditUsageLog = {
  __typename: "UserCoachingCreditUsageLog",
  userId: string,
  user?: User | null,
  memo: string,
  timestamp: number,
  id: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserCoachingCreditUsageLogInput = {
  userId?: string | null,
  memo?: string | null,
  timestamp?: number | null,
  id: string,
};

export type DeleteUserCoachingCreditUsageLogInput = {
  id: string,
};

export type CreateUserFocusAreaInput = {
  id?: string | null,
  userId: string,
  focusAreaId: string,
  startDate: string,
  endDate?: string | null,
  completed: BoolEnum,
  dateCompleted?: number | null,
};

export type ModelUserFocusAreaConditionInput = {
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  completed?: ModelBoolEnumInput | null,
  dateCompleted?: ModelIntInput | null,
  and?: Array< ModelUserFocusAreaConditionInput | null > | null,
  or?: Array< ModelUserFocusAreaConditionInput | null > | null,
  not?: ModelUserFocusAreaConditionInput | null,
};

export type UserFocusArea = {
  __typename: "UserFocusArea",
  id: string,
  userId: string,
  user?: User | null,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  startDate: string,
  endDate?: string | null,
  completed: BoolEnum,
  dateCompleted?: number | null,
  userFocusAreaGoals?: ModelUserFocusAreaGoalsConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelUserFocusAreaGoalsConnection = {
  __typename: "ModelUserFocusAreaGoalsConnection",
  items:  Array<UserFocusAreaGoals | null >,
  nextToken?: string | null,
};

export type UserFocusAreaGoals = {
  __typename: "UserFocusAreaGoals",
  id: string,
  userId: string,
  user?: User | null,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  focusAreaGoalId: string,
  focusAreaGoal?: FocusAreaGoal | null,
  userFocusAreaGoalHabits?: ModelUserFocusAreaGoalHabitConnection | null,
  completed?: BoolEnum | null,
  dateCompleted?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelUserFocusAreaGoalHabitConnection = {
  __typename: "ModelUserFocusAreaGoalHabitConnection",
  items:  Array<UserFocusAreaGoalHabit | null >,
  nextToken?: string | null,
};

export type UserFocusAreaGoalHabit = {
  __typename: "UserFocusAreaGoalHabit",
  id: string,
  userId: string,
  user?: User | null,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  focusAreaGoalId: string,
  focusAreaGoal?: FocusAreaGoal | null,
  focusAreaGoalHabitId: string,
  focusAreaGoalHabit?: FocusAreaGoalHabits | null,
  focusAreaGoalHabitLog?: ModelUserFocusAreaGoalHabitLogConnection | null,
  createdAt: string,
  completed?: BoolEnum | null,
  dateCompleted?: number | null,
  updatedAt: string,
};

export type ModelUserFocusAreaGoalHabitLogConnection = {
  __typename: "ModelUserFocusAreaGoalHabitLogConnection",
  items:  Array<UserFocusAreaGoalHabitLog | null >,
  nextToken?: string | null,
};

export type UserFocusAreaGoalHabitLog = {
  __typename: "UserFocusAreaGoalHabitLog",
  id: string,
  userId: string,
  userFocusAreaGoalHabitId: string,
  year: number,
  month: number,
  week: number,
  day: number,
  note?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserFocusAreaInput = {
  id: string,
  userId?: string | null,
  focusAreaId?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  completed?: BoolEnum | null,
  dateCompleted?: number | null,
};

export type DeleteUserFocusAreaInput = {
  id: string,
};

export type CreateUserFocusAreaGoalsInput = {
  id?: string | null,
  userId: string,
  focusAreaId: string,
  focusAreaGoalId: string,
  completed?: BoolEnum | null,
  dateCompleted?: number | null,
};

export type ModelUserFocusAreaGoalsConditionInput = {
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  focusAreaGoalId?: ModelIDInput | null,
  completed?: ModelBoolEnumInput | null,
  dateCompleted?: ModelIntInput | null,
  and?: Array< ModelUserFocusAreaGoalsConditionInput | null > | null,
  or?: Array< ModelUserFocusAreaGoalsConditionInput | null > | null,
  not?: ModelUserFocusAreaGoalsConditionInput | null,
};

export type UpdateUserFocusAreaGoalsInput = {
  id: string,
  userId?: string | null,
  focusAreaId?: string | null,
  focusAreaGoalId?: string | null,
  completed?: BoolEnum | null,
  dateCompleted?: number | null,
};

export type DeleteUserFocusAreaGoalsInput = {
  id: string,
};

export type CreateUserFocusAreaGoalHabitInput = {
  id?: string | null,
  userId: string,
  focusAreaId: string,
  focusAreaGoalId: string,
  focusAreaGoalHabitId: string,
  createdAt?: string | null,
  completed?: BoolEnum | null,
  dateCompleted?: number | null,
};

export type ModelUserFocusAreaGoalHabitConditionInput = {
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  focusAreaGoalId?: ModelIDInput | null,
  focusAreaGoalHabitId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  completed?: ModelBoolEnumInput | null,
  dateCompleted?: ModelIntInput | null,
  and?: Array< ModelUserFocusAreaGoalHabitConditionInput | null > | null,
  or?: Array< ModelUserFocusAreaGoalHabitConditionInput | null > | null,
  not?: ModelUserFocusAreaGoalHabitConditionInput | null,
};

export type UpdateUserFocusAreaGoalHabitInput = {
  id: string,
  userId?: string | null,
  focusAreaId?: string | null,
  focusAreaGoalId?: string | null,
  focusAreaGoalHabitId?: string | null,
  createdAt?: string | null,
  completed?: BoolEnum | null,
  dateCompleted?: number | null,
};

export type DeleteUserFocusAreaGoalHabitInput = {
  id: string,
};

export type CreateUserFocusAreaGoalHabitLogInput = {
  id?: string | null,
  userId: string,
  userFocusAreaGoalHabitId: string,
  year: number,
  month: number,
  week: number,
  day: number,
  note?: string | null,
};

export type ModelUserFocusAreaGoalHabitLogConditionInput = {
  userId?: ModelIDInput | null,
  userFocusAreaGoalHabitId?: ModelIDInput | null,
  year?: ModelIntInput | null,
  month?: ModelIntInput | null,
  week?: ModelIntInput | null,
  day?: ModelIntInput | null,
  note?: ModelStringInput | null,
  and?: Array< ModelUserFocusAreaGoalHabitLogConditionInput | null > | null,
  or?: Array< ModelUserFocusAreaGoalHabitLogConditionInput | null > | null,
  not?: ModelUserFocusAreaGoalHabitLogConditionInput | null,
};

export type UpdateUserFocusAreaGoalHabitLogInput = {
  id: string,
  userId?: string | null,
  userFocusAreaGoalHabitId?: string | null,
  year?: number | null,
  month?: number | null,
  week?: number | null,
  day?: number | null,
  note?: string | null,
};

export type DeleteUserFocusAreaGoalHabitLogInput = {
  id: string,
};

export type CreateUserAssessmentLogInput = {
  id?: string | null,
  createdAt?: string | null,
  userId: string,
  focusAreaId: string,
  assessment: string,
  score: number,
  maxScore: number,
  userNotified: boolean,
  coachReviewed: BoolEnum,
};

export type ModelUserAssessmentLogConditionInput = {
  createdAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  assessment?: ModelStringInput | null,
  score?: ModelIntInput | null,
  maxScore?: ModelIntInput | null,
  userNotified?: ModelBooleanInput | null,
  coachReviewed?: ModelBoolEnumInput | null,
  and?: Array< ModelUserAssessmentLogConditionInput | null > | null,
  or?: Array< ModelUserAssessmentLogConditionInput | null > | null,
  not?: ModelUserAssessmentLogConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UserAssessmentLog = {
  __typename: "UserAssessmentLog",
  id: string,
  createdAt: string,
  userId: string,
  focusAreaId: string,
  focusArea?: FocusArea | null,
  user?: User | null,
  assessment: string,
  score: number,
  maxScore: number,
  userNotified: boolean,
  coachReviewed: BoolEnum,
  updatedAt: string,
};

export type UpdateUserAssessmentLogInput = {
  id: string,
  createdAt?: string | null,
  userId?: string | null,
  focusAreaId?: string | null,
  assessment?: string | null,
  score?: number | null,
  maxScore?: number | null,
  userNotified?: boolean | null,
  coachReviewed?: BoolEnum | null,
};

export type DeleteUserAssessmentLogInput = {
  id: string,
};

export type CreateUserLessonsInput = {
  id?: string | null,
  userId: string,
  lessonId: string,
  startTimestamp?: number | null,
  completedTimestamp?: number | null,
  lastViewedTimestamp?: number | null,
  completed: BoolEnum,
  createdAt?: string | null,
};

export type ModelUserLessonsConditionInput = {
  userId?: ModelIDInput | null,
  lessonId?: ModelIDInput | null,
  startTimestamp?: ModelIntInput | null,
  completedTimestamp?: ModelIntInput | null,
  lastViewedTimestamp?: ModelIntInput | null,
  completed?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserLessonsConditionInput | null > | null,
  or?: Array< ModelUserLessonsConditionInput | null > | null,
  not?: ModelUserLessonsConditionInput | null,
};

export type UserLessons = {
  __typename: "UserLessons",
  id: string,
  userId: string,
  lessonId: string,
  lesson?: Lesson | null,
  startTimestamp?: number | null,
  completedTimestamp?: number | null,
  lastViewedTimestamp?: number | null,
  completed: BoolEnum,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserLessonsInput = {
  id: string,
  userId?: string | null,
  lessonId?: string | null,
  startTimestamp?: number | null,
  completedTimestamp?: number | null,
  lastViewedTimestamp?: number | null,
  completed?: BoolEnum | null,
  createdAt?: string | null,
};

export type DeleteUserLessonsInput = {
  id: string,
};

export type CreateUserGrowthPathItemInput = {
  id?: string | null,
  growthPathItemId: string,
  userId: string,
  order?: number | null,
  dateTimeAdded: number,
  completed: BoolEnum,
  dismissed: BoolEnum,
  completedTimestamp?: number | null,
  expirationDate?: string | null,
  locked: BoolEnum,
  hidden: BoolEnum,
  isScheduled: BoolEnum,
  visibleDate: string,
  visibleTimestamp?: number | null,
  growthPathJourneyId?: string | null,
  growthPathJourneyStep?: number | null,
  coachId?: string | null,
  source?: UserGrowthPathItemSourceEnum | null,
  lastActivityTimestamp?: number | null,
  dependsOnGrowthPathItems?: Array< string | null > | null,
};

export type ModelUserGrowthPathItemConditionInput = {
  growthPathItemId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  dateTimeAdded?: ModelIntInput | null,
  completed?: ModelBoolEnumInput | null,
  dismissed?: ModelBoolEnumInput | null,
  completedTimestamp?: ModelIntInput | null,
  expirationDate?: ModelStringInput | null,
  locked?: ModelBoolEnumInput | null,
  hidden?: ModelBoolEnumInput | null,
  isScheduled?: ModelBoolEnumInput | null,
  visibleDate?: ModelStringInput | null,
  visibleTimestamp?: ModelIntInput | null,
  growthPathJourneyId?: ModelIDInput | null,
  growthPathJourneyStep?: ModelIntInput | null,
  coachId?: ModelIDInput | null,
  source?: ModelUserGrowthPathItemSourceEnumInput | null,
  lastActivityTimestamp?: ModelIntInput | null,
  dependsOnGrowthPathItems?: ModelStringInput | null,
  and?: Array< ModelUserGrowthPathItemConditionInput | null > | null,
  or?: Array< ModelUserGrowthPathItemConditionInput | null > | null,
  not?: ModelUserGrowthPathItemConditionInput | null,
};

export type UpdateUserGrowthPathItemInput = {
  id: string,
  growthPathItemId?: string | null,
  userId?: string | null,
  order?: number | null,
  dateTimeAdded?: number | null,
  completed?: BoolEnum | null,
  dismissed?: BoolEnum | null,
  completedTimestamp?: number | null,
  expirationDate?: string | null,
  locked?: BoolEnum | null,
  hidden?: BoolEnum | null,
  isScheduled?: BoolEnum | null,
  visibleDate?: string | null,
  visibleTimestamp?: number | null,
  growthPathJourneyId?: string | null,
  growthPathJourneyStep?: number | null,
  coachId?: string | null,
  source?: UserGrowthPathItemSourceEnum | null,
  lastActivityTimestamp?: number | null,
  dependsOnGrowthPathItems?: Array< string | null > | null,
};

export type DeleteUserGrowthPathItemInput = {
  id: string,
};

export type CreateUserGrowthPathJourneyInput = {
  userId: string,
  growthPathJourneyId: string,
  completionLog?: Array< UserGrowthPathJourneyCompletionLogInput > | null,
  lastActivityTimestamp: number,
  active: BoolEnum,
  id?: string | null,
};

export type UserGrowthPathJourneyCompletionLogInput = {
  growthPathItemId: string,
  completionTimestamp: number,
};

export type ModelUserGrowthPathJourneyConditionInput = {
  userId?: ModelIDInput | null,
  growthPathJourneyId?: ModelIDInput | null,
  lastActivityTimestamp?: ModelIntInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelUserGrowthPathJourneyConditionInput | null > | null,
  or?: Array< ModelUserGrowthPathJourneyConditionInput | null > | null,
  not?: ModelUserGrowthPathJourneyConditionInput | null,
};

export type UserGrowthPathJourney = {
  __typename: "UserGrowthPathJourney",
  userId: string,
  growthPathJourneyId: string,
  growthPathJourney?: GrowthPathJourney | null,
  completionLog?:  Array<UserGrowthPathJourneyCompletionLog > | null,
  lastActivityTimestamp: number,
  active: BoolEnum,
  id: string,
  createdAt: string,
  updatedAt: string,
};

export type UserGrowthPathJourneyCompletionLog = {
  __typename: "UserGrowthPathJourneyCompletionLog",
  growthPathItemId: string,
  completionTimestamp: number,
};

export type UpdateUserGrowthPathJourneyInput = {
  userId?: string | null,
  growthPathJourneyId?: string | null,
  completionLog?: Array< UserGrowthPathJourneyCompletionLogInput > | null,
  lastActivityTimestamp?: number | null,
  active?: BoolEnum | null,
  id: string,
};

export type DeleteUserGrowthPathJourneyInput = {
  id: string,
};

export type CreateGrowthPathJourneyInput = {
  id?: string | null,
  title: string,
  description?: string | null,
  growthPathItems: Array< GrowthPathJourneyGrowthPathItemInput >,
  focusAreaId: string,
  active: BoolEnum,
  createdAt?: string | null,
};

export type GrowthPathJourneyGrowthPathItemInput = {
  step: number,
  growthPathItemId: string,
  rules?: Array< GrowthPathItemDependenciesInput > | null,
};

export type GrowthPathItemDependenciesInput = {
  ruleType: DependencyTypeEnum,
  dependencyGrowthPathItemId: string,
  scheduleDaysFromNow?: number | null,
};

export type ModelGrowthPathJourneyConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  focusAreaId?: ModelIDInput | null,
  active?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelGrowthPathJourneyConditionInput | null > | null,
  or?: Array< ModelGrowthPathJourneyConditionInput | null > | null,
  not?: ModelGrowthPathJourneyConditionInput | null,
};

export type UpdateGrowthPathJourneyInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  growthPathItems?: Array< GrowthPathJourneyGrowthPathItemInput > | null,
  focusAreaId?: string | null,
  active?: BoolEnum | null,
  createdAt?: string | null,
};

export type DeleteGrowthPathJourneyInput = {
  id: string,
};

export type CreateUserAppointmentsInput = {
  id?: string | null,
  userId: string,
  coachId: string,
  appointmentStartTime: number,
  appointmentEndTime: number,
  appointmentDurationMins: number,
  appointmentTimezone: string,
  appointmentType: AppointmentTypeEnum,
  cancelled?: BoolEnum | null,
  cancelDate?: number | null,
  cancelReason?: string | null,
  cancelNote?: string | null,
  metadata: UserAppointementMetadataInput,
};

export type UserAppointementMetadataInput = {
  acuityAppointmentId?: string | null,
  acuityAppointmentTypeId?: string | null,
  acuityConfirmationPageUrl?: string | null,
};

export type ModelUserAppointmentsConditionInput = {
  userId?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  appointmentStartTime?: ModelIntInput | null,
  appointmentEndTime?: ModelIntInput | null,
  appointmentDurationMins?: ModelIntInput | null,
  appointmentTimezone?: ModelStringInput | null,
  appointmentType?: ModelAppointmentTypeEnumInput | null,
  cancelled?: ModelBoolEnumInput | null,
  cancelDate?: ModelIntInput | null,
  cancelReason?: ModelStringInput | null,
  cancelNote?: ModelStringInput | null,
  and?: Array< ModelUserAppointmentsConditionInput | null > | null,
  or?: Array< ModelUserAppointmentsConditionInput | null > | null,
  not?: ModelUserAppointmentsConditionInput | null,
};

export type ModelAppointmentTypeEnumInput = {
  eq?: AppointmentTypeEnum | null,
  ne?: AppointmentTypeEnum | null,
};

export type UpdateUserAppointmentsInput = {
  id: string,
  userId?: string | null,
  coachId?: string | null,
  appointmentStartTime?: number | null,
  appointmentEndTime?: number | null,
  appointmentDurationMins?: number | null,
  appointmentTimezone?: string | null,
  appointmentType?: AppointmentTypeEnum | null,
  cancelled?: BoolEnum | null,
  cancelDate?: number | null,
  cancelReason?: string | null,
  cancelNote?: string | null,
  metadata?: UserAppointementMetadataInput | null,
};

export type DeleteUserAppointmentsInput = {
  id: string,
};

export type CreateUserNotificationInput = {
  id?: string | null,
  userId: string,
  notificationType: UserNotificationTypeEnum,
  notificationMessage: string,
  notificationTitle: string,
  notificationExpirationDate?: string | null,
  notificationRead: BoolEnum,
  createdAt?: string | null,
};

export enum UserNotificationTypeEnum {
  CHAT_MESSAGE = "CHAT_MESSAGE",
  ASSESSMENT_DUE = "ASSESSMENT_DUE",
  BILLING = "BILLING",
  NEW_GROWTH_PATH_ITEM = "NEW_GROWTH_PATH_ITEM",
  NEW_LESSON = "NEW_LESSON",
  NEW_EVENT = "NEW_EVENT",
  GENERAL = "GENERAL",
}


export type ModelUserNotificationConditionInput = {
  userId?: ModelIDInput | null,
  notificationType?: ModelUserNotificationTypeEnumInput | null,
  notificationMessage?: ModelStringInput | null,
  notificationTitle?: ModelStringInput | null,
  notificationExpirationDate?: ModelStringInput | null,
  notificationRead?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserNotificationConditionInput | null > | null,
  or?: Array< ModelUserNotificationConditionInput | null > | null,
  not?: ModelUserNotificationConditionInput | null,
};

export type ModelUserNotificationTypeEnumInput = {
  eq?: UserNotificationTypeEnum | null,
  ne?: UserNotificationTypeEnum | null,
};

export type UserNotification = {
  __typename: "UserNotification",
  id: string,
  userId: string,
  notificationType: UserNotificationTypeEnum,
  notificationMessage: string,
  notificationTitle: string,
  notificationExpirationDate?: string | null,
  notificationRead: BoolEnum,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserNotificationInput = {
  id: string,
  userId?: string | null,
  notificationType?: UserNotificationTypeEnum | null,
  notificationMessage?: string | null,
  notificationTitle?: string | null,
  notificationExpirationDate?: string | null,
  notificationRead?: BoolEnum | null,
  createdAt?: string | null,
};

export type DeleteUserNotificationInput = {
  id: string,
};

export type CreateCoachInput = {
  id?: string | null,
  firstName: string,
  lastName: string,
  email: string,
  title?: string | null,
  coachType?: Array< CoachTypeEnum | null > | null,
  avatarUrl?: string | null,
  description?: string | null,
  metadata?: CoachMetaDataInput | null,
  active: BoolEnum,
};

export type CoachMetaDataInput = {
  introVideoUrl?: string | null,
  gcalId?: string | null,
  calendlyId?: string | null,
  acuityCalendarId?: string | null,
  acuityUserId?: string | null,
  acuityKey?: string | null,
  acuityIssAppointmentId?: string | null,
  acuityRegularAppointmentId?: string | null,
  streamChatId?: string | null,
  slackId?: string | null,
  lastCoachNote?: number | null,
  lastChatMessage?: number | null,
};

export type ModelCoachConditionInput = {
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  title?: ModelStringInput | null,
  coachType?: ModelCoachTypeEnumListInput | null,
  avatarUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelCoachConditionInput | null > | null,
  or?: Array< ModelCoachConditionInput | null > | null,
  not?: ModelCoachConditionInput | null,
};

export type ModelCoachTypeEnumListInput = {
  eq?: Array< CoachTypeEnum | null > | null,
  ne?: Array< CoachTypeEnum | null > | null,
  contains?: CoachTypeEnum | null,
  notContains?: CoachTypeEnum | null,
};

export type UpdateCoachInput = {
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  title?: string | null,
  coachType?: Array< CoachTypeEnum | null > | null,
  avatarUrl?: string | null,
  description?: string | null,
  metadata?: CoachMetaDataInput | null,
  active?: BoolEnum | null,
};

export type DeleteCoachInput = {
  id: string,
};

export type CreateCoachFocusAreaInput = {
  id?: string | null,
  coachId: string,
  focusAreaId: string,
};

export type ModelCoachFocusAreaConditionInput = {
  coachId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  and?: Array< ModelCoachFocusAreaConditionInput | null > | null,
  or?: Array< ModelCoachFocusAreaConditionInput | null > | null,
  not?: ModelCoachFocusAreaConditionInput | null,
};

export type UpdateCoachFocusAreaInput = {
  id: string,
  coachId?: string | null,
  focusAreaId?: string | null,
};

export type DeleteCoachFocusAreaInput = {
  id: string,
};

export type CreateCoachUserNotificationInput = {
  id?: string | null,
  coachId: string,
  userId: string,
  title: string,
  read: BoolEnum,
  readTimestamp?: number | null,
  notificationType: CoachNotificationTypeEnum,
  rawPayload?: string | null,
  createdAt?: string | null,
};

export enum CoachNotificationTypeEnum {
  MEMBER_MESSAGE = "MEMBER_MESSAGE",
  MEMBER_ACTIVITY_COMPLETE = "MEMBER_ACTIVITY_COMPLETE",
  MEMBER_CANCELLATION = "MEMBER_CANCELLATION",
  GENRAL = "GENRAL",
}


export type ModelCoachUserNotificationConditionInput = {
  coachId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  read?: ModelBoolEnumInput | null,
  readTimestamp?: ModelIntInput | null,
  notificationType?: ModelCoachNotificationTypeEnumInput | null,
  rawPayload?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCoachUserNotificationConditionInput | null > | null,
  or?: Array< ModelCoachUserNotificationConditionInput | null > | null,
  not?: ModelCoachUserNotificationConditionInput | null,
};

export type ModelCoachNotificationTypeEnumInput = {
  eq?: CoachNotificationTypeEnum | null,
  ne?: CoachNotificationTypeEnum | null,
};

export type CoachUserNotification = {
  __typename: "CoachUserNotification",
  id: string,
  coachId: string,
  coach?: Coach | null,
  userId: string,
  user?: User | null,
  title: string,
  read: BoolEnum,
  readTimestamp?: number | null,
  notificationType: CoachNotificationTypeEnum,
  rawPayload?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCoachUserNotificationInput = {
  id: string,
  coachId?: string | null,
  userId?: string | null,
  title?: string | null,
  read?: BoolEnum | null,
  readTimestamp?: number | null,
  notificationType?: CoachNotificationTypeEnum | null,
  rawPayload?: string | null,
  createdAt?: string | null,
};

export type DeleteCoachUserNotificationInput = {
  id: string,
};

export type CreateGrowthPathItemInput = {
  id?: string | null,
  type: GrowthPathCardTypeEnum,
  title: string,
  subtitle?: string | null,
  avatarUrl?: string | null,
  description: string,
  categoryName?: string | null,
  categoryId?: string | null,
  estimatedCompletionTimeInMins?: number | null,
  actionTitle: string,
  actionDestination: string,
  actionPayload?: string | null,
  createdAt?: string | null,
  expirationDate?: string | null,
  lessonId?: string | null,
  tags?: Array< string | null > | null,
  isArchived: BoolEnum,
};

export type ModelGrowthPathItemConditionInput = {
  type?: ModelGrowthPathCardTypeEnumInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  avatarUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  categoryName?: ModelStringInput | null,
  categoryId?: ModelStringInput | null,
  estimatedCompletionTimeInMins?: ModelIntInput | null,
  actionTitle?: ModelStringInput | null,
  actionDestination?: ModelStringInput | null,
  actionPayload?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  lessonId?: ModelIDInput | null,
  tags?: ModelStringInput | null,
  isArchived?: ModelBoolEnumInput | null,
  and?: Array< ModelGrowthPathItemConditionInput | null > | null,
  or?: Array< ModelGrowthPathItemConditionInput | null > | null,
  not?: ModelGrowthPathItemConditionInput | null,
};

export type ModelGrowthPathCardTypeEnumInput = {
  eq?: GrowthPathCardTypeEnum | null,
  ne?: GrowthPathCardTypeEnum | null,
};

export type UpdateGrowthPathItemInput = {
  id: string,
  type?: GrowthPathCardTypeEnum | null,
  title?: string | null,
  subtitle?: string | null,
  avatarUrl?: string | null,
  description?: string | null,
  categoryName?: string | null,
  categoryId?: string | null,
  estimatedCompletionTimeInMins?: number | null,
  actionTitle?: string | null,
  actionDestination?: string | null,
  actionPayload?: string | null,
  createdAt?: string | null,
  expirationDate?: string | null,
  lessonId?: string | null,
  tags?: Array< string | null > | null,
  isArchived?: BoolEnum | null,
};

export type DeleteGrowthPathItemInput = {
  id: string,
};

export type CreateTopicTagsInput = {
  slug: string,
  name: string,
  description?: string | null,
};

export type ModelTopicTagsConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelTopicTagsConditionInput | null > | null,
  or?: Array< ModelTopicTagsConditionInput | null > | null,
  not?: ModelTopicTagsConditionInput | null,
};

export type TopicTags = {
  __typename: "TopicTags",
  slug: string,
  name: string,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTopicTagsInput = {
  slug: string,
  name?: string | null,
  description?: string | null,
};

export type DeleteTopicTagsInput = {
  slug: string,
};

export type CreateFocusAreaInput = {
  id?: string | null,
  name: string,
  slug: string,
  description?: string | null,
};

export type ModelFocusAreaConditionInput = {
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFocusAreaConditionInput | null > | null,
  or?: Array< ModelFocusAreaConditionInput | null > | null,
  not?: ModelFocusAreaConditionInput | null,
};

export type UpdateFocusAreaInput = {
  id: string,
  name?: string | null,
  slug?: string | null,
  description?: string | null,
};

export type DeleteFocusAreaInput = {
  id: string,
};

export type CreateFocusAreaGoalInput = {
  id?: string | null,
  focusAreaId: string,
  name: string,
  slug: string,
  description?: string | null,
};

export type ModelFocusAreaGoalConditionInput = {
  focusAreaId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFocusAreaGoalConditionInput | null > | null,
  or?: Array< ModelFocusAreaGoalConditionInput | null > | null,
  not?: ModelFocusAreaGoalConditionInput | null,
};

export type UpdateFocusAreaGoalInput = {
  id: string,
  focusAreaId?: string | null,
  name?: string | null,
  slug?: string | null,
  description?: string | null,
};

export type DeleteFocusAreaGoalInput = {
  id: string,
};

export type CreateFocusAreaGoalHabitsInput = {
  id?: string | null,
  focusAreaId: string,
  focusAreaGoalId: string,
  name: string,
  slug: string,
  description?: string | null,
};

export type ModelFocusAreaGoalHabitsConditionInput = {
  focusAreaId?: ModelIDInput | null,
  focusAreaGoalId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFocusAreaGoalHabitsConditionInput | null > | null,
  or?: Array< ModelFocusAreaGoalHabitsConditionInput | null > | null,
  not?: ModelFocusAreaGoalHabitsConditionInput | null,
};

export type UpdateFocusAreaGoalHabitsInput = {
  id: string,
  focusAreaId?: string | null,
  focusAreaGoalId?: string | null,
  name?: string | null,
  slug?: string | null,
  description?: string | null,
};

export type DeleteFocusAreaGoalHabitsInput = {
  id: string,
};

export type CreateProgramInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  level: number,
  active: BoolEnum,
};

export type ModelProgramConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  level?: ModelIntInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelProgramConditionInput | null > | null,
  or?: Array< ModelProgramConditionInput | null > | null,
  not?: ModelProgramConditionInput | null,
};

export type UpdateProgramInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  level?: number | null,
  active?: BoolEnum | null,
};

export type DeleteProgramInput = {
  id: string,
};

export type CreateLessonInput = {
  id?: string | null,
  programId: string,
  name: string,
  order: number,
  durationInMins: number,
  description?: string | null,
  transcript?: string | null,
  tags?: Array< string | null > | null,
  lessonType: LessonTypeEnum,
  metadata?: LessonMetadataInput | null,
  coverImageUrl?: string | null,
  isPremium: BoolEnum,
  active: BoolEnum,
};

export type LessonMetadataInput = {
  videoUrl?: string | null,
  videoStreamUrl?: string | null,
  videoExternalId?: string | null,
  videoDistributionPage?: string | null,
  formUrl?: string | null,
  formExternalId?: string | null,
};

export type ModelLessonConditionInput = {
  programId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  order?: ModelFloatInput | null,
  durationInMins?: ModelFloatInput | null,
  description?: ModelStringInput | null,
  transcript?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  lessonType?: ModelLessonTypeEnumInput | null,
  coverImageUrl?: ModelStringInput | null,
  isPremium?: ModelBoolEnumInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelLessonConditionInput | null > | null,
  or?: Array< ModelLessonConditionInput | null > | null,
  not?: ModelLessonConditionInput | null,
};

export type ModelLessonTypeEnumInput = {
  eq?: LessonTypeEnum | null,
  ne?: LessonTypeEnum | null,
};

export type UpdateLessonInput = {
  id: string,
  programId?: string | null,
  name?: string | null,
  order?: number | null,
  durationInMins?: number | null,
  description?: string | null,
  transcript?: string | null,
  tags?: Array< string | null > | null,
  lessonType?: LessonTypeEnum | null,
  metadata?: LessonMetadataInput | null,
  coverImageUrl?: string | null,
  isPremium?: BoolEnum | null,
  active?: BoolEnum | null,
};

export type DeleteLessonInput = {
  id: string,
};

export type CreateLessonFocusAreaInput = {
  lessonId: string,
  focusAreaId: string,
};

export type ModelLessonFocusAreaConditionInput = {
  and?: Array< ModelLessonFocusAreaConditionInput | null > | null,
  or?: Array< ModelLessonFocusAreaConditionInput | null > | null,
  not?: ModelLessonFocusAreaConditionInput | null,
};

export type UpdateLessonFocusAreaInput = {
  lessonId: string,
  focusAreaId: string,
};

export type DeleteLessonFocusAreaInput = {
  lessonId: string,
  focusAreaId: string,
};

export type CreatePlanGroupInput = {
  id?: string | null,
  name: string,
  startDate: string,
  endDate: string,
  trialPeriod: number,
  createdAt?: string | null,
  active: BoolEnum,
};

export type ModelPlanGroupConditionInput = {
  name?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  trialPeriod?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelPlanGroupConditionInput | null > | null,
  or?: Array< ModelPlanGroupConditionInput | null > | null,
  not?: ModelPlanGroupConditionInput | null,
};

export type UpdatePlanGroupInput = {
  id: string,
  name?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  trialPeriod?: number | null,
  createdAt?: string | null,
  active?: BoolEnum | null,
};

export type DeletePlanGroupInput = {
  id: string,
};

export type CreatePlanInput = {
  id?: string | null,
  planGroupId: string,
  name: string,
  description?: string | null,
  active: BoolEnum,
  defaultPrice: number,
  defaultPlanPriceId?: string | null,
  discountsAllowed?: boolean | null,
  display?: boolean | null,
  isTrial?: boolean | null,
  upgradeable?: boolean | null,
  downgradeable?: boolean | null,
  features: Array< string >,
  createdAt?: string | null,
  level: number,
  metadata?: PlanMetadataInput | null,
};

export type PlanMetadataInput = {
  coachingSessionsAllocated: number,
  stripeProductId?: string | null,
};

export type ModelPlanConditionInput = {
  planGroupId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  defaultPrice?: ModelFloatInput | null,
  defaultPlanPriceId?: ModelStringInput | null,
  discountsAllowed?: ModelBooleanInput | null,
  display?: ModelBooleanInput | null,
  isTrial?: ModelBooleanInput | null,
  upgradeable?: ModelBooleanInput | null,
  downgradeable?: ModelBooleanInput | null,
  features?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  level?: ModelIntInput | null,
  and?: Array< ModelPlanConditionInput | null > | null,
  or?: Array< ModelPlanConditionInput | null > | null,
  not?: ModelPlanConditionInput | null,
};

export type UpdatePlanInput = {
  id: string,
  planGroupId?: string | null,
  name?: string | null,
  description?: string | null,
  active?: BoolEnum | null,
  defaultPrice?: number | null,
  defaultPlanPriceId?: string | null,
  discountsAllowed?: boolean | null,
  display?: boolean | null,
  isTrial?: boolean | null,
  upgradeable?: boolean | null,
  downgradeable?: boolean | null,
  features?: Array< string > | null,
  createdAt?: string | null,
  level?: number | null,
  metadata?: PlanMetadataInput | null,
};

export type DeletePlanInput = {
  id: string,
};

export type CreatePlanPricingInput = {
  planId: string,
  slug: string,
  default: boolean,
  activationCodes?: Array< string | null > | null,
  downgradePricingIds?: Array< string | null > | null,
  upgradePricingIds?: Array< string | null > | null,
  price: number,
  metadata?: PlanPricingMetadaInput | null,
};

export type PlanPricingMetadaInput = {
  stripePriceId?: string | null,
};

export type ModelPlanPricingConditionInput = {
  default?: ModelBooleanInput | null,
  activationCodes?: ModelStringInput | null,
  downgradePricingIds?: ModelStringInput | null,
  upgradePricingIds?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  and?: Array< ModelPlanPricingConditionInput | null > | null,
  or?: Array< ModelPlanPricingConditionInput | null > | null,
  not?: ModelPlanPricingConditionInput | null,
};

export type UpdatePlanPricingInput = {
  planId: string,
  slug: string,
  default?: boolean | null,
  activationCodes?: Array< string | null > | null,
  downgradePricingIds?: Array< string | null > | null,
  upgradePricingIds?: Array< string | null > | null,
  price?: number | null,
  metadata?: PlanPricingMetadaInput | null,
};

export type DeletePlanPricingInput = {
  planId: string,
  slug: string,
};

export type CreateEventInput = {
  id?: string | null,
  name: string,
  title: string,
  description?: string | null,
  features?: Array< EventFeatureInput > | null,
  startDate: string,
  endDate: string,
  startTimestamp: number,
  endTimestamp: number,
  timezone: string,
  hostFirstName: string,
  hostLastName: string,
  hostEmail?: string | null,
  hostWebsite?: string | null,
  hostAvatar?: string | null,
  allowFreeMembers: BoolEnum,
  allowSprout: BoolEnum,
  allowBloom: BoolEnum,
  eventType: EventTypeEnum,
  attendeeLimit: number,
  price: number,
  featureImageUrl?: string | null,
  metadata?: EventMetadataInput | null,
};

export type EventFeatureInput = {
  title: string,
  description?: string | null,
};

export type EventMetadataInput = {
  stripeProductId?: string | null,
  stripePriceId?: string | null,
  eventLandingPageUrl?: string | null,
  eventMeetingLink?: string | null,
  activeCampaignTagId?: number | null,
  totalSessions?: number | null,
};

export type ModelEventConditionInput = {
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startTimestamp?: ModelIntInput | null,
  endTimestamp?: ModelIntInput | null,
  timezone?: ModelStringInput | null,
  hostFirstName?: ModelStringInput | null,
  hostLastName?: ModelStringInput | null,
  hostEmail?: ModelStringInput | null,
  hostWebsite?: ModelStringInput | null,
  hostAvatar?: ModelStringInput | null,
  allowFreeMembers?: ModelBoolEnumInput | null,
  allowSprout?: ModelBoolEnumInput | null,
  allowBloom?: ModelBoolEnumInput | null,
  eventType?: ModelEventTypeEnumInput | null,
  attendeeLimit?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  featureImageUrl?: ModelStringInput | null,
  and?: Array< ModelEventConditionInput | null > | null,
  or?: Array< ModelEventConditionInput | null > | null,
  not?: ModelEventConditionInput | null,
};

export type UpdateEventInput = {
  id: string,
  name?: string | null,
  title?: string | null,
  description?: string | null,
  features?: Array< EventFeatureInput > | null,
  startDate?: string | null,
  endDate?: string | null,
  startTimestamp?: number | null,
  endTimestamp?: number | null,
  timezone?: string | null,
  hostFirstName?: string | null,
  hostLastName?: string | null,
  hostEmail?: string | null,
  hostWebsite?: string | null,
  hostAvatar?: string | null,
  allowFreeMembers?: BoolEnum | null,
  allowSprout?: BoolEnum | null,
  allowBloom?: BoolEnum | null,
  eventType?: EventTypeEnum | null,
  attendeeLimit?: number | null,
  price?: number | null,
  featureImageUrl?: string | null,
  metadata?: EventMetadataInput | null,
};

export type DeleteEventInput = {
  id: string,
};

export type CreateEventTimeInput = {
  eventId: string,
  name: string,
  title: string,
  type: EventTimeTypeEnum,
  description?: string | null,
  startDate: string,
  endDate: string,
  timezone?: string | null,
  allowFreeMembers: BoolEnum,
  allowSprout: BoolEnum,
  allowBloom: BoolEnum,
  metadata?: EventTimeMetadataInput | null,
};

export type EventTimeMetadataInput = {
  acuityCalendarId?: string | null,
  acuityAppointmentTypeId?: string | null,
  meetingLinkVideo?: string | null,
  meetingLinkAudio?: string | null,
  recordingLink?: string | null,
};

export type ModelEventTimeConditionInput = {
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelEventTimeTypeEnumInput | null,
  description?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  allowFreeMembers?: ModelBoolEnumInput | null,
  allowSprout?: ModelBoolEnumInput | null,
  allowBloom?: ModelBoolEnumInput | null,
  and?: Array< ModelEventTimeConditionInput | null > | null,
  or?: Array< ModelEventTimeConditionInput | null > | null,
  not?: ModelEventTimeConditionInput | null,
};

export type ModelEventTimeTypeEnumInput = {
  eq?: EventTimeTypeEnum | null,
  ne?: EventTimeTypeEnum | null,
};

export type UpdateEventTimeInput = {
  eventId: string,
  name?: string | null,
  title?: string | null,
  type?: EventTimeTypeEnum | null,
  description?: string | null,
  startDate: string,
  endDate?: string | null,
  timezone?: string | null,
  allowFreeMembers?: BoolEnum | null,
  allowSprout?: BoolEnum | null,
  allowBloom?: BoolEnum | null,
  metadata?: EventTimeMetadataInput | null,
};

export type DeleteEventTimeInput = {
  eventId: string,
  startDate: string,
};

export type CreateEventSessionInput = {
  id?: string | null,
  eventId: string,
  sessionTitle?: string | null,
  sessionDescription?: string | null,
  startDate: string,
  endDate: string,
  startTimestamp: number,
  endTimestamp: number,
  timezone: string,
  isRecurring: BoolEnum,
  allowFreeMembers: BoolEnum,
  allowSprout: BoolEnum,
  allowBloom: BoolEnum,
  attendeeLimit: number,
  eventSessionFocusAreaId?: string | null,
  featureImageUrl?: string | null,
  metadata?: EventSessionMetadataInput | null,
};

export type EventSessionMetadataInput = {
  chatChannelId?: string | null,
  eventSessionLandingPageUrl?: string | null,
  eventSessionMeetingLink?: string | null,
  actuityAppointmentTypeId?: string | null,
  acuityCalendarId?: string | null,
  activeCampaignTagId?: number | null,
};

export type ModelEventSessionConditionInput = {
  eventId?: ModelIDInput | null,
  sessionTitle?: ModelStringInput | null,
  sessionDescription?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startTimestamp?: ModelIntInput | null,
  endTimestamp?: ModelIntInput | null,
  timezone?: ModelStringInput | null,
  isRecurring?: ModelBoolEnumInput | null,
  allowFreeMembers?: ModelBoolEnumInput | null,
  allowSprout?: ModelBoolEnumInput | null,
  allowBloom?: ModelBoolEnumInput | null,
  attendeeLimit?: ModelIntInput | null,
  eventSessionFocusAreaId?: ModelIDInput | null,
  featureImageUrl?: ModelStringInput | null,
  and?: Array< ModelEventSessionConditionInput | null > | null,
  or?: Array< ModelEventSessionConditionInput | null > | null,
  not?: ModelEventSessionConditionInput | null,
};

export type UpdateEventSessionInput = {
  id: string,
  eventId?: string | null,
  sessionTitle?: string | null,
  sessionDescription?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  startTimestamp?: number | null,
  endTimestamp?: number | null,
  timezone?: string | null,
  isRecurring?: BoolEnum | null,
  allowFreeMembers?: BoolEnum | null,
  allowSprout?: BoolEnum | null,
  allowBloom?: BoolEnum | null,
  attendeeLimit?: number | null,
  eventSessionFocusAreaId?: string | null,
  featureImageUrl?: string | null,
  metadata?: EventSessionMetadataInput | null,
};

export type DeleteEventSessionInput = {
  id: string,
};

export type CreateEventSessionTimeInput = {
  eventSessionId: string,
  eventId: string,
  name: string,
  title: string,
  type: EventTimeTypeEnum,
  description?: string | null,
  startDate: string,
  endDate: string,
  timezone?: string | null,
  metadata?: EventSessionTimeMetadataInput | null,
};

export type EventSessionTimeMetadataInput = {
  acuityCalendarId?: string | null,
  acuityAppointmentTypeId?: string | null,
  meetingLinkVideo?: string | null,
  meetingLinkAudio?: string | null,
  recordingLink?: string | null,
};

export type ModelEventSessionTimeConditionInput = {
  eventId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelEventTimeTypeEnumInput | null,
  description?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  and?: Array< ModelEventSessionTimeConditionInput | null > | null,
  or?: Array< ModelEventSessionTimeConditionInput | null > | null,
  not?: ModelEventSessionTimeConditionInput | null,
};

export type UpdateEventSessionTimeInput = {
  eventSessionId: string,
  eventId?: string | null,
  name?: string | null,
  title?: string | null,
  type?: EventTimeTypeEnum | null,
  description?: string | null,
  startDate: string,
  endDate?: string | null,
  timezone?: string | null,
  metadata?: EventSessionTimeMetadataInput | null,
};

export type DeleteEventSessionTimeInput = {
  eventSessionId: string,
  startDate: string,
};

export type CreateEventSessionFacilitatorInput = {
  eventSessionId: string,
  coachId: string,
};

export type ModelEventSessionFacilitatorConditionInput = {
  and?: Array< ModelEventSessionFacilitatorConditionInput | null > | null,
  or?: Array< ModelEventSessionFacilitatorConditionInput | null > | null,
  not?: ModelEventSessionFacilitatorConditionInput | null,
};

export type UpdateEventSessionFacilitatorInput = {
  eventSessionId: string,
  coachId: string,
};

export type DeleteEventSessionFacilitatorInput = {
  eventSessionId: string,
  coachId: string,
};

export type CreateEventSessionAttendeesInput = {
  eventSessionId: string,
  userId: string,
  eventId: string,
  confirmed: BoolEnum,
  confirmationTimestamp?: number | null,
  metadata?: EventSessionAttendeeMetadataInput | null,
};

export type EventSessionAttendeeMetadataInput = {
  paymentTimestamp?: number | null,
  stripeInvoiceId?: string | null,
  rawPaymentLog?: string | null,
};

export type ModelEventSessionAttendeesConditionInput = {
  eventId?: ModelIDInput | null,
  confirmed?: ModelBoolEnumInput | null,
  confirmationTimestamp?: ModelIntInput | null,
  and?: Array< ModelEventSessionAttendeesConditionInput | null > | null,
  or?: Array< ModelEventSessionAttendeesConditionInput | null > | null,
  not?: ModelEventSessionAttendeesConditionInput | null,
};

export type UpdateEventSessionAttendeesInput = {
  eventSessionId: string,
  userId: string,
  eventId?: string | null,
  confirmed?: BoolEnum | null,
  confirmationTimestamp?: number | null,
  metadata?: EventSessionAttendeeMetadataInput | null,
};

export type DeleteEventSessionAttendeesInput = {
  eventSessionId: string,
  userId: string,
};

export type AppointmentAvailabilityInput = {
  coachId: string,
  startDate: string,
  daysSpan: number,
  appointmentType: AppointmentTypeEnum,
  filters?: AppointmentAvailabilityFilters | null,
};

export type AppointmentAvailabilityFilters = {
  excludeDays?: Array< string | null > | null,
  excludeTimes?: Array< string | null > | null,
};

export type AppointmentAvailability = {
  __typename: "AppointmentAvailability",
  dates?:  Array<AppointmentAvailabilityDates | null > | null,
};

export type AppointmentAvailabilityDates = {
  __typename: "AppointmentAvailabilityDates",
  date?: string | null,
  times?:  Array<AppointmentAvailabilityTimes | null > | null,
};

export type AppointmentAvailabilityTimes = {
  __typename: "AppointmentAvailabilityTimes",
  time?: string | null,
  slotsAvailable?: number | null,
};

export enum SortDirectionEnum {
  ASC = "ASC",
  DESC = "DESC",
}


export type SearchableUserFilterInput = {
  id?: SearchableIDFilterInput | null,
  email?: SearchableStringFilterInput | null,
  firstName?: SearchableStringFilterInput | null,
  lastName?: SearchableStringFilterInput | null,
  phone?: SearchableStringFilterInput | null,
  avatar?: SearchableStringFilterInput | null,
  userBio?: SearchableStringFilterInput | null,
  age?: SearchableIntFilterInput | null,
  dateOfBirth?: SearchableStringFilterInput | null,
  genderId?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  lastSeen?: SearchableIntFilterInput | null,
  referralSource?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  roles?: SearchableStringFilterInput | null,
  stage?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserFilterInput | null > | null,
  or?: Array< SearchableUserFilterInput | null > | null,
  not?: SearchableUserFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableUserSortInput = {
  field?: SearchableUserSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserSortableFields {
  id = "id",
  email = "email",
  firstName = "firstName",
  lastName = "lastName",
  phone = "phone",
  avatar = "avatar",
  userBio = "userBio",
  age = "age",
  dateOfBirth = "dateOfBirth",
  genderId = "genderId",
  createdAt = "createdAt",
  lastSeen = "lastSeen",
  referralSource = "referralSource",
  updatedAt = "updatedAt",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableUserAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserAggregateField,
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum",
}


export enum SearchableUserAggregateField {
  id = "id",
  email = "email",
  firstName = "firstName",
  lastName = "lastName",
  phone = "phone",
  avatar = "avatar",
  userBio = "userBio",
  age = "age",
  dateOfBirth = "dateOfBirth",
  genderId = "genderId",
  createdAt = "createdAt",
  status = "status",
  lastSeen = "lastSeen",
  referralSource = "referralSource",
  roles = "roles",
  stage = "stage",
  updatedAt = "updatedAt",
}


export type SearchableUserConnection = {
  __typename: "SearchableUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult",
  name: string,
  result?: SearchableAggregateGenericResult | null,
};

export type SearchableAggregateGenericResult = SearchableAggregateScalarResult | SearchableAggregateBucketResult


export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult",
  value: number,
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult",
  buckets?:  Array<SearchableAggregateBucketResultItem | null > | null,
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem",
  key: string,
  doc_count: number,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelUserCoachFilterInput = {
  userId?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  isPrimary?: ModelBoolEnumInput | null,
  active?: ModelBoolEnumInput | null,
  coachingStartDate?: ModelStringInput | null,
  coachingEndDate?: ModelStringInput | null,
  and?: Array< ModelUserCoachFilterInput | null > | null,
  or?: Array< ModelUserCoachFilterInput | null > | null,
  not?: ModelUserCoachFilterInput | null,
};

export type ModelUserCoachRatingFilterInput = {
  userId?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  rating?: ModelFloatInput | null,
  comment?: ModelStringInput | null,
  ratingTimestamp?: ModelIntInput | null,
  and?: Array< ModelUserCoachRatingFilterInput | null > | null,
  or?: Array< ModelUserCoachRatingFilterInput | null > | null,
  not?: ModelUserCoachRatingFilterInput | null,
};

export type ModelUserCoachingNoteFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  appointmentId?: ModelIDInput | null,
  note?: ModelStringInput | null,
  visibleToUser?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserCoachingNoteFilterInput | null > | null,
  or?: Array< ModelUserCoachingNoteFilterInput | null > | null,
  not?: ModelUserCoachingNoteFilterInput | null,
};

export type ModelUserCoachingNoteConnection = {
  __typename: "ModelUserCoachingNoteConnection",
  items:  Array<UserCoachingNote | null >,
  nextToken?: string | null,
};

export type ModelUserStatsFilterInput = {
  userId?: ModelIDInput | null,
  totalHabitLogged?: ModelIntInput | null,
  totalAppointmentsScheduled?: ModelIntInput | null,
  totalLessonsWatched?: ModelIntInput | null,
  totalLogins?: ModelIntInput | null,
  totalMessages?: ModelIntInput | null,
  and?: Array< ModelUserStatsFilterInput | null > | null,
  or?: Array< ModelUserStatsFilterInput | null > | null,
  not?: ModelUserStatsFilterInput | null,
};

export type ModelUserStatsConnection = {
  __typename: "ModelUserStatsConnection",
  items:  Array<UserStats | null >,
  nextToken?: string | null,
};

export type ModelUserActivityLogFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelUserActivitiesEnumInput | null,
  source?: ModelActivitySourceEnumInput | null,
  payload?: ModelStringInput | null,
  timestamp?: ModelIntInput | null,
  and?: Array< ModelUserActivityLogFilterInput | null > | null,
  or?: Array< ModelUserActivityLogFilterInput | null > | null,
  not?: ModelUserActivityLogFilterInput | null,
};

export type ModelUserActivityLogConnection = {
  __typename: "ModelUserActivityLogConnection",
  items:  Array<UserActivityLog | null >,
  nextToken?: string | null,
};

export type ModelJournalEntryTemplatesFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  templateText?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelJournalEntryTemplatesFilterInput | null > | null,
  or?: Array< ModelJournalEntryTemplatesFilterInput | null > | null,
  not?: ModelJournalEntryTemplatesFilterInput | null,
};

export type ModelJournalEntryTemplatesConnection = {
  __typename: "ModelJournalEntryTemplatesConnection",
  items:  Array<JournalEntryTemplates | null >,
  nextToken?: string | null,
};

export type ModelUserJournalEntryLogFilterInput = {
  userId?: ModelIDInput | null,
  entryTitle?: ModelStringInput | null,
  entryLogType?: ModelJournalEntryLogTypeEnumInput | null,
  isVisibleToCoach?: ModelBoolEnumInput | null,
  isVisibleToPublic?: ModelBoolEnumInput | null,
  entryText?: ModelStringInput | null,
  journalEntryTemplateId?: ModelIDInput | null,
  rawEntry?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserJournalEntryLogFilterInput | null > | null,
  or?: Array< ModelUserJournalEntryLogFilterInput | null > | null,
  not?: ModelUserJournalEntryLogFilterInput | null,
};

export type ModelUserJournalEntryLogConnection = {
  __typename: "ModelUserJournalEntryLogConnection",
  items:  Array<UserJournalEntryLog | null >,
  nextToken?: string | null,
};

export type ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyConditionInput = {
  eq?: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput | null,
  le?: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput | null,
  lt?: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput | null,
  ge?: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput | null,
  gt?: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput | null,
  between?: Array< ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput | null > | null,
  beginsWith?: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput | null,
};

export type ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyInput = {
  userId?: string | null,
  createdAt?: string | null,
};

export type SearchableUserJournalEntryLogFilterInput = {
  userId?: SearchableIDFilterInput | null,
  entryTitle?: SearchableStringFilterInput | null,
  entryText?: SearchableStringFilterInput | null,
  journalEntryTemplateId?: SearchableIDFilterInput | null,
  rawEntry?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  entryLogType?: SearchableStringFilterInput | null,
  isVisibleToCoach?: SearchableStringFilterInput | null,
  isVisibleToPublic?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserJournalEntryLogFilterInput | null > | null,
  or?: Array< SearchableUserJournalEntryLogFilterInput | null > | null,
  not?: SearchableUserJournalEntryLogFilterInput | null,
};

export type SearchableUserJournalEntryLogSortInput = {
  field?: SearchableUserJournalEntryLogSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserJournalEntryLogSortableFields {
  userId = "userId",
  entryTitle = "entryTitle",
  entryText = "entryText",
  journalEntryTemplateId = "journalEntryTemplateId",
  rawEntry = "rawEntry",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserJournalEntryLogAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserJournalEntryLogAggregateField,
};

export enum SearchableUserJournalEntryLogAggregateField {
  userId = "userId",
  entryTitle = "entryTitle",
  entryLogType = "entryLogType",
  isVisibleToCoach = "isVisibleToCoach",
  isVisibleToPublic = "isVisibleToPublic",
  entryText = "entryText",
  journalEntryTemplateId = "journalEntryTemplateId",
  rawEntry = "rawEntry",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserJournalEntryLogConnection = {
  __typename: "SearchableUserJournalEntryLogConnection",
  items:  Array<UserJournalEntryLog | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelUserPlanFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  planId?: ModelIDInput | null,
  planGroupId?: ModelIDInput | null,
  planPricingSlug?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  cancelled?: ModelBoolEnumInput | null,
  cancellationReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelUserPlanFilterInput | null > | null,
  or?: Array< ModelUserPlanFilterInput | null > | null,
  not?: ModelUserPlanFilterInput | null,
};

export type ModelUserCoachingCreditsFilterInput = {
  userId?: ModelIDInput | null,
  yearMonth?: ModelIntInput | null,
  creditsAwarded?: ModelIntInput | null,
  creditsRemaining?: ModelIntInput | null,
  lastUsedTimestamp?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserCoachingCreditsFilterInput | null > | null,
  or?: Array< ModelUserCoachingCreditsFilterInput | null > | null,
  not?: ModelUserCoachingCreditsFilterInput | null,
};

export type ModelUserCoachingCreditsConnection = {
  __typename: "ModelUserCoachingCreditsConnection",
  items:  Array<UserCoachingCredits | null >,
  nextToken?: string | null,
};

export type ModelUserCoachingCreditUsageLogFilterInput = {
  userId?: ModelIDInput | null,
  memo?: ModelStringInput | null,
  timestamp?: ModelIntInput | null,
  and?: Array< ModelUserCoachingCreditUsageLogFilterInput | null > | null,
  or?: Array< ModelUserCoachingCreditUsageLogFilterInput | null > | null,
  not?: ModelUserCoachingCreditUsageLogFilterInput | null,
};

export type ModelUserCoachingCreditUsageLogConnection = {
  __typename: "ModelUserCoachingCreditUsageLogConnection",
  items:  Array<UserCoachingCreditUsageLog | null >,
  nextToken?: string | null,
};

export type ModelUserFocusAreaFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  completed?: ModelBoolEnumInput | null,
  dateCompleted?: ModelIntInput | null,
  and?: Array< ModelUserFocusAreaFilterInput | null > | null,
  or?: Array< ModelUserFocusAreaFilterInput | null > | null,
  not?: ModelUserFocusAreaFilterInput | null,
};

export type ModelUserFocusAreaConnection = {
  __typename: "ModelUserFocusAreaConnection",
  items:  Array<UserFocusArea | null >,
  nextToken?: string | null,
};

export type ModelUserFocusAreaGoalsFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  focusAreaGoalId?: ModelIDInput | null,
  completed?: ModelBoolEnumInput | null,
  dateCompleted?: ModelIntInput | null,
  and?: Array< ModelUserFocusAreaGoalsFilterInput | null > | null,
  or?: Array< ModelUserFocusAreaGoalsFilterInput | null > | null,
  not?: ModelUserFocusAreaGoalsFilterInput | null,
};

export type ModelUserFocusAreaGoalHabitFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  focusAreaGoalId?: ModelIDInput | null,
  focusAreaGoalHabitId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  completed?: ModelBoolEnumInput | null,
  dateCompleted?: ModelIntInput | null,
  and?: Array< ModelUserFocusAreaGoalHabitFilterInput | null > | null,
  or?: Array< ModelUserFocusAreaGoalHabitFilterInput | null > | null,
  not?: ModelUserFocusAreaGoalHabitFilterInput | null,
};

export type ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyConditionInput = {
  eq?: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput | null,
  le?: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput | null,
  lt?: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput | null,
  ge?: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput | null,
  gt?: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput | null,
  between?: Array< ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput | null > | null,
  beginsWith?: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput | null,
};

export type ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyInput = {
  focusAreaId?: string | null,
  focusAreaGoalId?: string | null,
};

export type ModelUserFocusAreaGoalHabitLogFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  userFocusAreaGoalHabitId?: ModelIDInput | null,
  year?: ModelIntInput | null,
  month?: ModelIntInput | null,
  week?: ModelIntInput | null,
  day?: ModelIntInput | null,
  note?: ModelStringInput | null,
  and?: Array< ModelUserFocusAreaGoalHabitLogFilterInput | null > | null,
  or?: Array< ModelUserFocusAreaGoalHabitLogFilterInput | null > | null,
  not?: ModelUserFocusAreaGoalHabitLogFilterInput | null,
};

export type ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyConditionInput = {
  eq?: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput | null,
  le?: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput | null,
  lt?: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput | null,
  ge?: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput | null,
  gt?: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput | null,
  between?: Array< ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput | null > | null,
  beginsWith?: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput | null,
};

export type ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyInput = {
  year?: number | null,
  week?: number | null,
  month?: number | null,
  day?: number | null,
};

export type ModelUserAssessmentLogFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  assessment?: ModelStringInput | null,
  score?: ModelIntInput | null,
  maxScore?: ModelIntInput | null,
  userNotified?: ModelBooleanInput | null,
  coachReviewed?: ModelBoolEnumInput | null,
  and?: Array< ModelUserAssessmentLogFilterInput | null > | null,
  or?: Array< ModelUserAssessmentLogFilterInput | null > | null,
  not?: ModelUserAssessmentLogFilterInput | null,
};

export type ModelUserAssessmentLogConnection = {
  __typename: "ModelUserAssessmentLogConnection",
  items:  Array<UserAssessmentLog | null >,
  nextToken?: string | null,
};

export type ModelUserLessonsFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  lessonId?: ModelIDInput | null,
  startTimestamp?: ModelIntInput | null,
  completedTimestamp?: ModelIntInput | null,
  lastViewedTimestamp?: ModelIntInput | null,
  completed?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserLessonsFilterInput | null > | null,
  or?: Array< ModelUserLessonsFilterInput | null > | null,
  not?: ModelUserLessonsFilterInput | null,
};

export type ModelUserLessonsConnection = {
  __typename: "ModelUserLessonsConnection",
  items:  Array<UserLessons | null >,
  nextToken?: string | null,
};

export type ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyConditionInput = {
  eq?: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput | null,
  le?: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput | null,
  lt?: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput | null,
  ge?: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput | null,
  gt?: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput | null,
  between?: Array< ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput | null > | null,
  beginsWith?: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput | null,
};

export type ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyInput = {
  userId?: string | null,
  createdAt?: string | null,
};

export type ModelUserGrowthPathJourneyFilterInput = {
  userId?: ModelIDInput | null,
  growthPathJourneyId?: ModelIDInput | null,
  lastActivityTimestamp?: ModelIntInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelUserGrowthPathJourneyFilterInput | null > | null,
  or?: Array< ModelUserGrowthPathJourneyFilterInput | null > | null,
  not?: ModelUserGrowthPathJourneyFilterInput | null,
};

export type ModelUserGrowthPathJourneyConnection = {
  __typename: "ModelUserGrowthPathJourneyConnection",
  items:  Array<UserGrowthPathJourney | null >,
  nextToken?: string | null,
};

export type ModelGrowthPathJourneyFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  focusAreaId?: ModelIDInput | null,
  active?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelGrowthPathJourneyFilterInput | null > | null,
  or?: Array< ModelGrowthPathJourneyFilterInput | null > | null,
  not?: ModelGrowthPathJourneyFilterInput | null,
};

export type ModelGrowthPathJourneyConnection = {
  __typename: "ModelGrowthPathJourneyConnection",
  items:  Array<GrowthPathJourney | null >,
  nextToken?: string | null,
};

export type ModelUserAppointmentsFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  appointmentStartTime?: ModelIntInput | null,
  appointmentEndTime?: ModelIntInput | null,
  appointmentDurationMins?: ModelIntInput | null,
  appointmentTimezone?: ModelStringInput | null,
  appointmentType?: ModelAppointmentTypeEnumInput | null,
  cancelled?: ModelBoolEnumInput | null,
  cancelDate?: ModelIntInput | null,
  cancelReason?: ModelStringInput | null,
  cancelNote?: ModelStringInput | null,
  and?: Array< ModelUserAppointmentsFilterInput | null > | null,
  or?: Array< ModelUserAppointmentsFilterInput | null > | null,
  not?: ModelUserAppointmentsFilterInput | null,
};

export type ModelUserNotificationFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  notificationType?: ModelUserNotificationTypeEnumInput | null,
  notificationMessage?: ModelStringInput | null,
  notificationTitle?: ModelStringInput | null,
  notificationExpirationDate?: ModelStringInput | null,
  notificationRead?: ModelBoolEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserNotificationFilterInput | null > | null,
  or?: Array< ModelUserNotificationFilterInput | null > | null,
  not?: ModelUserNotificationFilterInput | null,
};

export type ModelUserNotificationConnection = {
  __typename: "ModelUserNotificationConnection",
  items:  Array<UserNotification | null >,
  nextToken?: string | null,
};

export type ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyConditionInput = {
  eq?: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput | null,
  le?: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput | null,
  lt?: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput | null,
  ge?: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput | null,
  gt?: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput | null,
  between?: Array< ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput | null > | null,
  beginsWith?: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput | null,
};

export type ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyInput = {
  userId?: string | null,
  createdAt?: string | null,
};

export type ModelCoachFilterInput = {
  id?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  title?: ModelStringInput | null,
  coachType?: ModelCoachTypeEnumListInput | null,
  avatarUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelCoachFilterInput | null > | null,
  or?: Array< ModelCoachFilterInput | null > | null,
  not?: ModelCoachFilterInput | null,
};

export type ModelCoachConnection = {
  __typename: "ModelCoachConnection",
  items:  Array<Coach | null >,
  nextToken?: string | null,
};

export type ModelCoachFocusAreaFilterInput = {
  id?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  and?: Array< ModelCoachFocusAreaFilterInput | null > | null,
  or?: Array< ModelCoachFocusAreaFilterInput | null > | null,
  not?: ModelCoachFocusAreaFilterInput | null,
};

export type ModelCoachUserNotificationFilterInput = {
  id?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  read?: ModelBoolEnumInput | null,
  readTimestamp?: ModelIntInput | null,
  notificationType?: ModelCoachNotificationTypeEnumInput | null,
  rawPayload?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCoachUserNotificationFilterInput | null > | null,
  or?: Array< ModelCoachUserNotificationFilterInput | null > | null,
  not?: ModelCoachUserNotificationFilterInput | null,
};

export type ModelCoachUserNotificationConnection = {
  __typename: "ModelCoachUserNotificationConnection",
  items:  Array<CoachUserNotification | null >,
  nextToken?: string | null,
};

export type ModelGrowthPathItemFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelGrowthPathCardTypeEnumInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  avatarUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  categoryName?: ModelStringInput | null,
  categoryId?: ModelStringInput | null,
  estimatedCompletionTimeInMins?: ModelIntInput | null,
  actionTitle?: ModelStringInput | null,
  actionDestination?: ModelStringInput | null,
  actionPayload?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  lessonId?: ModelIDInput | null,
  tags?: ModelStringInput | null,
  isArchived?: ModelBoolEnumInput | null,
  and?: Array< ModelGrowthPathItemFilterInput | null > | null,
  or?: Array< ModelGrowthPathItemFilterInput | null > | null,
  not?: ModelGrowthPathItemFilterInput | null,
};

export type ModelGrowthPathItemConnection = {
  __typename: "ModelGrowthPathItemConnection",
  items:  Array<GrowthPathItem | null >,
  nextToken?: string | null,
};

export type ModelTopicTagsFilterInput = {
  slug?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelTopicTagsFilterInput | null > | null,
  or?: Array< ModelTopicTagsFilterInput | null > | null,
  not?: ModelTopicTagsFilterInput | null,
};

export type ModelTopicTagsConnection = {
  __typename: "ModelTopicTagsConnection",
  items:  Array<TopicTags | null >,
  nextToken?: string | null,
};

export type ModelFocusAreaFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFocusAreaFilterInput | null > | null,
  or?: Array< ModelFocusAreaFilterInput | null > | null,
  not?: ModelFocusAreaFilterInput | null,
};

export type ModelFocusAreaConnection = {
  __typename: "ModelFocusAreaConnection",
  items:  Array<FocusArea | null >,
  nextToken?: string | null,
};

export type ModelFocusAreaGoalFilterInput = {
  id?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFocusAreaGoalFilterInput | null > | null,
  or?: Array< ModelFocusAreaGoalFilterInput | null > | null,
  not?: ModelFocusAreaGoalFilterInput | null,
};

export type ModelFocusAreaGoalHabitsFilterInput = {
  id?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  focusAreaGoalId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFocusAreaGoalHabitsFilterInput | null > | null,
  or?: Array< ModelFocusAreaGoalHabitsFilterInput | null > | null,
  not?: ModelFocusAreaGoalHabitsFilterInput | null,
};

export type ModelProgramFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  level?: ModelIntInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelProgramFilterInput | null > | null,
  or?: Array< ModelProgramFilterInput | null > | null,
  not?: ModelProgramFilterInput | null,
};

export type ModelProgramConnection = {
  __typename: "ModelProgramConnection",
  items:  Array<Program | null >,
  nextToken?: string | null,
};

export type ModelLessonFilterInput = {
  id?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  order?: ModelFloatInput | null,
  durationInMins?: ModelFloatInput | null,
  description?: ModelStringInput | null,
  transcript?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  lessonType?: ModelLessonTypeEnumInput | null,
  coverImageUrl?: ModelStringInput | null,
  isPremium?: ModelBoolEnumInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelLessonFilterInput | null > | null,
  or?: Array< ModelLessonFilterInput | null > | null,
  not?: ModelLessonFilterInput | null,
};

export type ModelFloatKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelLessonFocusAreaFilterInput = {
  lessonId?: ModelIDInput | null,
  focusAreaId?: ModelIDInput | null,
  and?: Array< ModelLessonFocusAreaFilterInput | null > | null,
  or?: Array< ModelLessonFocusAreaFilterInput | null > | null,
  not?: ModelLessonFocusAreaFilterInput | null,
};

export type ModelPlanGroupFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  trialPeriod?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  and?: Array< ModelPlanGroupFilterInput | null > | null,
  or?: Array< ModelPlanGroupFilterInput | null > | null,
  not?: ModelPlanGroupFilterInput | null,
};

export type ModelPlanGroupConnection = {
  __typename: "ModelPlanGroupConnection",
  items:  Array<PlanGroup | null >,
  nextToken?: string | null,
};

export type ModelPlanFilterInput = {
  id?: ModelIDInput | null,
  planGroupId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBoolEnumInput | null,
  defaultPrice?: ModelFloatInput | null,
  defaultPlanPriceId?: ModelStringInput | null,
  discountsAllowed?: ModelBooleanInput | null,
  display?: ModelBooleanInput | null,
  isTrial?: ModelBooleanInput | null,
  upgradeable?: ModelBooleanInput | null,
  downgradeable?: ModelBooleanInput | null,
  features?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  level?: ModelIntInput | null,
  and?: Array< ModelPlanFilterInput | null > | null,
  or?: Array< ModelPlanFilterInput | null > | null,
  not?: ModelPlanFilterInput | null,
};

export type ModelPlanPricingFilterInput = {
  planId?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  activationCodes?: ModelStringInput | null,
  downgradePricingIds?: ModelStringInput | null,
  upgradePricingIds?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  and?: Array< ModelPlanPricingFilterInput | null > | null,
  or?: Array< ModelPlanPricingFilterInput | null > | null,
  not?: ModelPlanPricingFilterInput | null,
};

export type ModelEventTimeFilterInput = {
  eventId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelEventTimeTypeEnumInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  allowFreeMembers?: ModelBoolEnumInput | null,
  allowSprout?: ModelBoolEnumInput | null,
  allowBloom?: ModelBoolEnumInput | null,
  and?: Array< ModelEventTimeFilterInput | null > | null,
  or?: Array< ModelEventTimeFilterInput | null > | null,
  not?: ModelEventTimeFilterInput | null,
};

export type ModelEventSessionFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  sessionTitle?: ModelStringInput | null,
  sessionDescription?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startTimestamp?: ModelIntInput | null,
  endTimestamp?: ModelIntInput | null,
  timezone?: ModelStringInput | null,
  isRecurring?: ModelBoolEnumInput | null,
  allowFreeMembers?: ModelBoolEnumInput | null,
  allowSprout?: ModelBoolEnumInput | null,
  allowBloom?: ModelBoolEnumInput | null,
  attendeeLimit?: ModelIntInput | null,
  eventSessionFocusAreaId?: ModelIDInput | null,
  featureImageUrl?: ModelStringInput | null,
  and?: Array< ModelEventSessionFilterInput | null > | null,
  or?: Array< ModelEventSessionFilterInput | null > | null,
  not?: ModelEventSessionFilterInput | null,
};

export type ModelEventSessionTimeFilterInput = {
  eventSessionId?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelEventTimeTypeEnumInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  and?: Array< ModelEventSessionTimeFilterInput | null > | null,
  or?: Array< ModelEventSessionTimeFilterInput | null > | null,
  not?: ModelEventSessionTimeFilterInput | null,
};

export type ModelEventSessionFacilitatorFilterInput = {
  eventSessionId?: ModelIDInput | null,
  coachId?: ModelIDInput | null,
  and?: Array< ModelEventSessionFacilitatorFilterInput | null > | null,
  or?: Array< ModelEventSessionFacilitatorFilterInput | null > | null,
  not?: ModelEventSessionFacilitatorFilterInput | null,
};

export type ModelEventSessionAttendeesFilterInput = {
  eventSessionId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  confirmed?: ModelBoolEnumInput | null,
  confirmationTimestamp?: ModelIntInput | null,
  and?: Array< ModelEventSessionAttendeesFilterInput | null > | null,
  or?: Array< ModelEventSessionAttendeesFilterInput | null > | null,
  not?: ModelEventSessionAttendeesFilterInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  email?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  phone?: ModelSubscriptionStringInput | null,
  avatar?: ModelSubscriptionStringInput | null,
  userBio?: ModelSubscriptionStringInput | null,
  age?: ModelSubscriptionIntInput | null,
  dateOfBirth?: ModelSubscriptionStringInput | null,
  genderId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  lastSeen?: ModelSubscriptionIntInput | null,
  referralSource?: ModelSubscriptionStringInput | null,
  roles?: ModelSubscriptionStringInput | null,
  stage?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionUserCoachFilterInput = {
  userId?: ModelSubscriptionIDInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  isPrimary?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionStringInput | null,
  coachingStartDate?: ModelSubscriptionStringInput | null,
  coachingEndDate?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserCoachFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserCoachFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionUserCoachRatingFilterInput = {
  userId?: ModelSubscriptionIDInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  rating?: ModelSubscriptionFloatInput | null,
  comment?: ModelSubscriptionStringInput | null,
  ratingTimestamp?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserCoachRatingFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserCoachRatingFilterInput | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionUserCoachingNoteFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  appointmentId?: ModelSubscriptionIDInput | null,
  note?: ModelSubscriptionStringInput | null,
  visibleToUser?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserCoachingNoteFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserCoachingNoteFilterInput | null > | null,
};

export type ModelSubscriptionUserStatsFilterInput = {
  userId?: ModelSubscriptionIDInput | null,
  totalHabitLogged?: ModelSubscriptionIntInput | null,
  totalAppointmentsScheduled?: ModelSubscriptionIntInput | null,
  totalLessonsWatched?: ModelSubscriptionIntInput | null,
  totalLogins?: ModelSubscriptionIntInput | null,
  totalMessages?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserStatsFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserStatsFilterInput | null > | null,
};

export type ModelSubscriptionUserActivityLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  source?: ModelSubscriptionStringInput | null,
  payload?: ModelSubscriptionStringInput | null,
  timestamp?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserActivityLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserActivityLogFilterInput | null > | null,
};

export type ModelSubscriptionJournalEntryTemplatesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  templateText?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionJournalEntryTemplatesFilterInput | null > | null,
  or?: Array< ModelSubscriptionJournalEntryTemplatesFilterInput | null > | null,
};

export type ModelSubscriptionUserJournalEntryLogFilterInput = {
  userId?: ModelSubscriptionIDInput | null,
  entryTitle?: ModelSubscriptionStringInput | null,
  entryLogType?: ModelSubscriptionStringInput | null,
  isVisibleToCoach?: ModelSubscriptionStringInput | null,
  isVisibleToPublic?: ModelSubscriptionStringInput | null,
  entryText?: ModelSubscriptionStringInput | null,
  journalEntryTemplateId?: ModelSubscriptionIDInput | null,
  rawEntry?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserJournalEntryLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserJournalEntryLogFilterInput | null > | null,
};

export type ModelSubscriptionUserPlanFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  planId?: ModelSubscriptionIDInput | null,
  planGroupId?: ModelSubscriptionIDInput | null,
  planPricingSlug?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  cancelled?: ModelSubscriptionStringInput | null,
  cancellationReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserPlanFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserPlanFilterInput | null > | null,
};

export type ModelSubscriptionUserCoachingCreditsFilterInput = {
  userId?: ModelSubscriptionIDInput | null,
  yearMonth?: ModelSubscriptionIntInput | null,
  creditsAwarded?: ModelSubscriptionIntInput | null,
  creditsRemaining?: ModelSubscriptionIntInput | null,
  lastUsedTimestamp?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserCoachingCreditsFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserCoachingCreditsFilterInput | null > | null,
};

export type ModelSubscriptionUserCoachingCreditUsageLogFilterInput = {
  userId?: ModelSubscriptionIDInput | null,
  memo?: ModelSubscriptionStringInput | null,
  timestamp?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserCoachingCreditUsageLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserCoachingCreditUsageLogFilterInput | null > | null,
};

export type ModelSubscriptionUserFocusAreaFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  completed?: ModelSubscriptionStringInput | null,
  dateCompleted?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserFocusAreaFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFocusAreaFilterInput | null > | null,
};

export type ModelSubscriptionUserFocusAreaGoalsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  focusAreaGoalId?: ModelSubscriptionIDInput | null,
  completed?: ModelSubscriptionStringInput | null,
  dateCompleted?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserFocusAreaGoalsFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFocusAreaGoalsFilterInput | null > | null,
};

export type ModelSubscriptionUserFocusAreaGoalHabitFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  focusAreaGoalId?: ModelSubscriptionIDInput | null,
  focusAreaGoalHabitId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  completed?: ModelSubscriptionStringInput | null,
  dateCompleted?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserFocusAreaGoalHabitFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFocusAreaGoalHabitFilterInput | null > | null,
};

export type ModelSubscriptionUserFocusAreaGoalHabitLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  userFocusAreaGoalHabitId?: ModelSubscriptionIDInput | null,
  year?: ModelSubscriptionIntInput | null,
  month?: ModelSubscriptionIntInput | null,
  week?: ModelSubscriptionIntInput | null,
  day?: ModelSubscriptionIntInput | null,
  note?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFocusAreaGoalHabitLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFocusAreaGoalHabitLogFilterInput | null > | null,
};

export type ModelSubscriptionUserAssessmentLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  assessment?: ModelSubscriptionStringInput | null,
  score?: ModelSubscriptionIntInput | null,
  maxScore?: ModelSubscriptionIntInput | null,
  userNotified?: ModelSubscriptionBooleanInput | null,
  coachReviewed?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserAssessmentLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserAssessmentLogFilterInput | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionUserLessonsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  lessonId?: ModelSubscriptionIDInput | null,
  startTimestamp?: ModelSubscriptionIntInput | null,
  completedTimestamp?: ModelSubscriptionIntInput | null,
  lastViewedTimestamp?: ModelSubscriptionIntInput | null,
  completed?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserLessonsFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserLessonsFilterInput | null > | null,
};

export type ModelSubscriptionUserGrowthPathItemFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  growthPathItemId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  order?: ModelSubscriptionIntInput | null,
  dateTimeAdded?: ModelSubscriptionIntInput | null,
  completed?: ModelSubscriptionStringInput | null,
  dismissed?: ModelSubscriptionStringInput | null,
  completedTimestamp?: ModelSubscriptionIntInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  locked?: ModelSubscriptionStringInput | null,
  hidden?: ModelSubscriptionStringInput | null,
  isScheduled?: ModelSubscriptionStringInput | null,
  visibleDate?: ModelSubscriptionStringInput | null,
  visibleTimestamp?: ModelSubscriptionIntInput | null,
  growthPathJourneyId?: ModelSubscriptionIDInput | null,
  growthPathJourneyStep?: ModelSubscriptionIntInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  source?: ModelSubscriptionStringInput | null,
  lastActivityTimestamp?: ModelSubscriptionIntInput | null,
  dependsOnGrowthPathItems?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserGrowthPathItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserGrowthPathItemFilterInput | null > | null,
};

export type ModelSubscriptionUserGrowthPathJourneyFilterInput = {
  userId?: ModelSubscriptionIDInput | null,
  growthPathJourneyId?: ModelSubscriptionIDInput | null,
  lastActivityTimestamp?: ModelSubscriptionIntInput | null,
  active?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserGrowthPathJourneyFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserGrowthPathJourneyFilterInput | null > | null,
};

export type ModelSubscriptionGrowthPathJourneyFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  active?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGrowthPathJourneyFilterInput | null > | null,
  or?: Array< ModelSubscriptionGrowthPathJourneyFilterInput | null > | null,
};

export type ModelSubscriptionUserAppointmentsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  appointmentStartTime?: ModelSubscriptionIntInput | null,
  appointmentEndTime?: ModelSubscriptionIntInput | null,
  appointmentDurationMins?: ModelSubscriptionIntInput | null,
  appointmentTimezone?: ModelSubscriptionStringInput | null,
  appointmentType?: ModelSubscriptionStringInput | null,
  cancelled?: ModelSubscriptionStringInput | null,
  cancelDate?: ModelSubscriptionIntInput | null,
  cancelReason?: ModelSubscriptionStringInput | null,
  cancelNote?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserAppointmentsFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserAppointmentsFilterInput | null > | null,
};

export type ModelSubscriptionUserNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  notificationType?: ModelSubscriptionStringInput | null,
  notificationMessage?: ModelSubscriptionStringInput | null,
  notificationTitle?: ModelSubscriptionStringInput | null,
  notificationExpirationDate?: ModelSubscriptionStringInput | null,
  notificationRead?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserNotificationFilterInput | null > | null,
};

export type ModelSubscriptionCoachFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  coachType?: ModelSubscriptionStringInput | null,
  avatarUrl?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCoachFilterInput | null > | null,
  or?: Array< ModelSubscriptionCoachFilterInput | null > | null,
};

export type ModelSubscriptionCoachFocusAreaFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionCoachFocusAreaFilterInput | null > | null,
  or?: Array< ModelSubscriptionCoachFocusAreaFilterInput | null > | null,
};

export type ModelSubscriptionCoachUserNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  read?: ModelSubscriptionStringInput | null,
  readTimestamp?: ModelSubscriptionIntInput | null,
  notificationType?: ModelSubscriptionStringInput | null,
  rawPayload?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCoachUserNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionCoachUserNotificationFilterInput | null > | null,
};

export type ModelSubscriptionGrowthPathItemFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  subtitle?: ModelSubscriptionStringInput | null,
  avatarUrl?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  categoryName?: ModelSubscriptionStringInput | null,
  categoryId?: ModelSubscriptionStringInput | null,
  estimatedCompletionTimeInMins?: ModelSubscriptionIntInput | null,
  actionTitle?: ModelSubscriptionStringInput | null,
  actionDestination?: ModelSubscriptionStringInput | null,
  actionPayload?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  lessonId?: ModelSubscriptionIDInput | null,
  tags?: ModelSubscriptionStringInput | null,
  isArchived?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGrowthPathItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionGrowthPathItemFilterInput | null > | null,
};

export type ModelSubscriptionTopicTagsFilterInput = {
  slug?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTopicTagsFilterInput | null > | null,
  or?: Array< ModelSubscriptionTopicTagsFilterInput | null > | null,
};

export type ModelSubscriptionFocusAreaFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFocusAreaFilterInput | null > | null,
  or?: Array< ModelSubscriptionFocusAreaFilterInput | null > | null,
};

export type ModelSubscriptionFocusAreaGoalFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFocusAreaGoalFilterInput | null > | null,
  or?: Array< ModelSubscriptionFocusAreaGoalFilterInput | null > | null,
};

export type ModelSubscriptionFocusAreaGoalHabitsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  focusAreaGoalId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFocusAreaGoalHabitsFilterInput | null > | null,
  or?: Array< ModelSubscriptionFocusAreaGoalHabitsFilterInput | null > | null,
};

export type ModelSubscriptionProgramFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  level?: ModelSubscriptionIntInput | null,
  active?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProgramFilterInput | null > | null,
  or?: Array< ModelSubscriptionProgramFilterInput | null > | null,
};

export type ModelSubscriptionLessonFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  programId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  order?: ModelSubscriptionFloatInput | null,
  durationInMins?: ModelSubscriptionFloatInput | null,
  description?: ModelSubscriptionStringInput | null,
  transcript?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  lessonType?: ModelSubscriptionStringInput | null,
  coverImageUrl?: ModelSubscriptionStringInput | null,
  isPremium?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLessonFilterInput | null > | null,
  or?: Array< ModelSubscriptionLessonFilterInput | null > | null,
};

export type ModelSubscriptionLessonFocusAreaFilterInput = {
  lessonId?: ModelSubscriptionIDInput | null,
  focusAreaId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionLessonFocusAreaFilterInput | null > | null,
  or?: Array< ModelSubscriptionLessonFocusAreaFilterInput | null > | null,
};

export type ModelSubscriptionPlanGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  trialPeriod?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPlanGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlanGroupFilterInput | null > | null,
};

export type ModelSubscriptionPlanFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  planGroupId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionStringInput | null,
  defaultPrice?: ModelSubscriptionFloatInput | null,
  defaultPlanPriceId?: ModelSubscriptionStringInput | null,
  discountsAllowed?: ModelSubscriptionBooleanInput | null,
  display?: ModelSubscriptionBooleanInput | null,
  isTrial?: ModelSubscriptionBooleanInput | null,
  upgradeable?: ModelSubscriptionBooleanInput | null,
  downgradeable?: ModelSubscriptionBooleanInput | null,
  features?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  level?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionPlanFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlanFilterInput | null > | null,
};

export type ModelSubscriptionPlanPricingFilterInput = {
  planId?: ModelSubscriptionIDInput | null,
  slug?: ModelSubscriptionStringInput | null,
  default?: ModelSubscriptionBooleanInput | null,
  activationCodes?: ModelSubscriptionStringInput | null,
  downgradePricingIds?: ModelSubscriptionStringInput | null,
  upgradePricingIds?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionPlanPricingFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlanPricingFilterInput | null > | null,
};

export type ModelSubscriptionEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  startTimestamp?: ModelSubscriptionIntInput | null,
  endTimestamp?: ModelSubscriptionIntInput | null,
  timezone?: ModelSubscriptionStringInput | null,
  hostFirstName?: ModelSubscriptionStringInput | null,
  hostLastName?: ModelSubscriptionStringInput | null,
  hostEmail?: ModelSubscriptionStringInput | null,
  hostWebsite?: ModelSubscriptionStringInput | null,
  hostAvatar?: ModelSubscriptionStringInput | null,
  allowFreeMembers?: ModelSubscriptionStringInput | null,
  allowSprout?: ModelSubscriptionStringInput | null,
  allowBloom?: ModelSubscriptionStringInput | null,
  eventType?: ModelSubscriptionStringInput | null,
  attendeeLimit?: ModelSubscriptionIntInput | null,
  price?: ModelSubscriptionFloatInput | null,
  featureImageUrl?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventFilterInput | null > | null,
};

export type ModelSubscriptionEventTimeFilterInput = {
  eventId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  timezone?: ModelSubscriptionStringInput | null,
  allowFreeMembers?: ModelSubscriptionStringInput | null,
  allowSprout?: ModelSubscriptionStringInput | null,
  allowBloom?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventTimeFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventTimeFilterInput | null > | null,
};

export type ModelSubscriptionEventSessionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  sessionTitle?: ModelSubscriptionStringInput | null,
  sessionDescription?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  startTimestamp?: ModelSubscriptionIntInput | null,
  endTimestamp?: ModelSubscriptionIntInput | null,
  timezone?: ModelSubscriptionStringInput | null,
  isRecurring?: ModelSubscriptionStringInput | null,
  allowFreeMembers?: ModelSubscriptionStringInput | null,
  allowSprout?: ModelSubscriptionStringInput | null,
  allowBloom?: ModelSubscriptionStringInput | null,
  attendeeLimit?: ModelSubscriptionIntInput | null,
  eventSessionFocusAreaId?: ModelSubscriptionIDInput | null,
  featureImageUrl?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventSessionFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventSessionFilterInput | null > | null,
};

export type ModelSubscriptionEventSessionTimeFilterInput = {
  eventSessionId?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  timezone?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventSessionTimeFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventSessionTimeFilterInput | null > | null,
};

export type ModelSubscriptionEventSessionFacilitatorFilterInput = {
  eventSessionId?: ModelSubscriptionIDInput | null,
  coachId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionEventSessionFacilitatorFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventSessionFacilitatorFilterInput | null > | null,
};

export type ModelSubscriptionEventSessionAttendeesFilterInput = {
  eventSessionId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  confirmed?: ModelSubscriptionStringInput | null,
  confirmationTimestamp?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionEventSessionAttendeesFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventSessionAttendeesFilterInput | null > | null,
};

export type CreateUserCustomMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserCustomMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    referralSource: string,
    roles: Array< RolesEnum >,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type FindGrowthPathsByUserIdCustomQueryVariables = {
  userId: string,
  dateTimeAdded?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserGrowthPathItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FindGrowthPathsByUserIdCustomQuery = {
  listGrowthPathsByUserId?:  {
    __typename: "ModelUserGrowthPathItemConnection",
    items:  Array< {
      __typename: "UserGrowthPathItem",
      id: string,
      growthPathItemId: string,
      growthPathItem?:  {
        __typename: "GrowthPathItem",
        id: string,
        type: GrowthPathCardTypeEnum,
        title: string,
        subtitle?: string | null,
        avatarUrl?: string | null,
        description: string,
        categoryName?: string | null,
        categoryId?: string | null,
        estimatedCompletionTimeInMins?: number | null,
        actionTitle: string,
        actionDestination: string,
        actionPayload?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      userId: string,
      dateTimeAdded: number,
      completed: BoolEnum,
      locked: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUsersCustomQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersCustomQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      referralSource: string,
      roles: Array< RolesEnum >,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          plan?:  {
            __typename: "Plan",
            id: string,
            planGroupId: string,
            name: string,
            description?: string | null,
            active: BoolEnum,
            defaultPrice: number,
            defaultPlanPriceId?: string | null,
            discountsAllowed?: boolean | null,
            display?: boolean | null,
            isTrial?: boolean | null,
            upgradeable?: boolean | null,
            downgradeable?: boolean | null,
            features: Array< string >,
            createdAt: string,
            level: number,
            pricing?:  {
              __typename: "ModelPlanPricingConnection",
              nextToken?: string | null,
            } | null,
            metadata?:  {
              __typename: "PlanMetadata",
              coachingSessionsAllocated: number,
              stripeProductId?: string | null,
            } | null,
            updatedAt: string,
          } | null,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          metadata?:  {
            __typename: "UserPlanMetadata",
            stripeSubscriptionId?: string | null,
            stripeCustomerId?: string | null,
          } | null,
          updatedAt: string,
        } | null >,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
      },
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventCustomQueryVariables = {
  id: string,
};

export type GetEventCustomQuery = {
  getEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        userId: string,
        eventId: string,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          items:  Array< {
            __typename: "EventSessionAttendees",
            eventSessionId: string,
            userId: string,
            eventId: string,
            confirmed: BoolEnum,
          } | null >,
        } | null,
        eventSessionFocusAreaId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventsByEventTypeCustomQueryVariables = {
  eventType: EventTypeEnum,
  startDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsByEventTypeCustomQuery = {
  listEventsByEventType?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          metadata?:  {
            __typename: "EventSessionMetadata",
            chatChannelId?: string | null,
            eventSessionLandingPageUrl?: string | null,
            eventSessionMeetingLink?: string | null,
            actuityAppointmentTypeId?: string | null,
            acuityCalendarId?: string | null,
            activeCampaignTagId?: number | null,
          } | null,
          eventSessionAttendees?:  {
            __typename: "ModelEventSessionAttendeesConnection",
            items:  Array< {
              __typename: "EventSessionAttendees",
              eventSessionId: string,
              userId: string,
              eventId: string,
              confirmed: BoolEnum,
            } | null >,
          } | null,
          eventSessionFocusAreaId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BookAppointmentMutationVariables = {
  input: AppointmentInput,
};

export type BookAppointmentMutation = {
  bookAppointment?: string | null,
};

export type ScheduleAcuityAppointmentMutationVariables = {
  input?: AcuityAppointmentInput | null,
};

export type ScheduleAcuityAppointmentMutation = {
  scheduleAcuityAppointment?: string | null,
};

export type CancelAppointmentMutationVariables = {
  id: string,
  acuityAppointmentId: string,
  userId: string,
  coachId: string,
  appointmentType: AppointmentTypeEnum,
  isAdmin?: boolean | null,
  noShow?: boolean | null,
  cancelNote?: string | null,
};

export type CancelAppointmentMutation = {
  cancelAppointment?: string | null,
};

export type UpsertACTagMutationVariables = {
  user: ACUserInput,
  tags: string,
};

export type UpsertACTagMutation = {
  upsertACTag?: string | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    lastSeen?: number | null,
    referralSource: string,
    roles: Array< RolesEnum >,
    stage?: FunnelStageEnum | null,
    plans?:  {
      __typename: "ModelUserPlanConnection",
      items:  Array< {
        __typename: "UserPlan",
        id: string,
        userId: string,
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        planPricingSlug: string,
        planPricing?:  {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate: string,
        endDate?: string | null,
        cancelled?: BoolEnum | null,
        cancellationReason?: string | null,
        createdAt: string,
        active: BoolEnum,
        metadata?:  {
          __typename: "UserPlanMetadata",
          stripeSubscriptionId?: string | null,
          stripeCustomerId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelUserAppointmentsConnection",
      items:  Array< {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    coaches?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    growthPaths?:  {
      __typename: "ModelUserGrowthPathItemConnection",
      items:  Array< {
        __typename: "UserGrowthPathItem",
        id: string,
        growthPathItemId: string,
        growthPathItem?:  {
          __typename: "GrowthPathItem",
          id: string,
          type: GrowthPathCardTypeEnum,
          title: string,
          subtitle?: string | null,
          avatarUrl?: string | null,
          description: string,
          categoryName?: string | null,
          categoryId?: string | null,
          estimatedCompletionTimeInMins?: number | null,
          actionTitle: string,
          actionDestination: string,
          actionPayload?: string | null,
          createdAt: string,
          expirationDate?: string | null,
          lessonId?: string | null,
          tags?: Array< string | null > | null,
          isArchived: BoolEnum,
          updatedAt: string,
        } | null,
        userId: string,
        order?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        dateTimeAdded: number,
        completed: BoolEnum,
        dismissed: BoolEnum,
        completedTimestamp?: number | null,
        expirationDate?: string | null,
        locked: BoolEnum,
        hidden: BoolEnum,
        isScheduled: BoolEnum,
        visibleDate: string,
        visibleTimestamp?: number | null,
        growthPathJourneyId?: string | null,
        growthPathJourneyStep?: number | null,
        growthPathJourney?:  {
          __typename: "GrowthPathJourney",
          id: string,
          title: string,
          description?: string | null,
          focusAreaId: string,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        coachId?: string | null,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        source?: UserGrowthPathItemSourceEnum | null,
        lastActivityTimestamp?: number | null,
        dependsOnGrowthPathItems?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    lastSeen?: number | null,
    referralSource: string,
    roles: Array< RolesEnum >,
    stage?: FunnelStageEnum | null,
    plans?:  {
      __typename: "ModelUserPlanConnection",
      items:  Array< {
        __typename: "UserPlan",
        id: string,
        userId: string,
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        planPricingSlug: string,
        planPricing?:  {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate: string,
        endDate?: string | null,
        cancelled?: BoolEnum | null,
        cancellationReason?: string | null,
        createdAt: string,
        active: BoolEnum,
        metadata?:  {
          __typename: "UserPlanMetadata",
          stripeSubscriptionId?: string | null,
          stripeCustomerId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelUserAppointmentsConnection",
      items:  Array< {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    coaches?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    growthPaths?:  {
      __typename: "ModelUserGrowthPathItemConnection",
      items:  Array< {
        __typename: "UserGrowthPathItem",
        id: string,
        growthPathItemId: string,
        growthPathItem?:  {
          __typename: "GrowthPathItem",
          id: string,
          type: GrowthPathCardTypeEnum,
          title: string,
          subtitle?: string | null,
          avatarUrl?: string | null,
          description: string,
          categoryName?: string | null,
          categoryId?: string | null,
          estimatedCompletionTimeInMins?: number | null,
          actionTitle: string,
          actionDestination: string,
          actionPayload?: string | null,
          createdAt: string,
          expirationDate?: string | null,
          lessonId?: string | null,
          tags?: Array< string | null > | null,
          isArchived: BoolEnum,
          updatedAt: string,
        } | null,
        userId: string,
        order?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        dateTimeAdded: number,
        completed: BoolEnum,
        dismissed: BoolEnum,
        completedTimestamp?: number | null,
        expirationDate?: string | null,
        locked: BoolEnum,
        hidden: BoolEnum,
        isScheduled: BoolEnum,
        visibleDate: string,
        visibleTimestamp?: number | null,
        growthPathJourneyId?: string | null,
        growthPathJourneyStep?: number | null,
        growthPathJourney?:  {
          __typename: "GrowthPathJourney",
          id: string,
          title: string,
          description?: string | null,
          focusAreaId: string,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        coachId?: string | null,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        source?: UserGrowthPathItemSourceEnum | null,
        lastActivityTimestamp?: number | null,
        dependsOnGrowthPathItems?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    lastSeen?: number | null,
    referralSource: string,
    roles: Array< RolesEnum >,
    stage?: FunnelStageEnum | null,
    plans?:  {
      __typename: "ModelUserPlanConnection",
      items:  Array< {
        __typename: "UserPlan",
        id: string,
        userId: string,
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        planPricingSlug: string,
        planPricing?:  {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate: string,
        endDate?: string | null,
        cancelled?: BoolEnum | null,
        cancellationReason?: string | null,
        createdAt: string,
        active: BoolEnum,
        metadata?:  {
          __typename: "UserPlanMetadata",
          stripeSubscriptionId?: string | null,
          stripeCustomerId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelUserAppointmentsConnection",
      items:  Array< {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    coaches?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    growthPaths?:  {
      __typename: "ModelUserGrowthPathItemConnection",
      items:  Array< {
        __typename: "UserGrowthPathItem",
        id: string,
        growthPathItemId: string,
        growthPathItem?:  {
          __typename: "GrowthPathItem",
          id: string,
          type: GrowthPathCardTypeEnum,
          title: string,
          subtitle?: string | null,
          avatarUrl?: string | null,
          description: string,
          categoryName?: string | null,
          categoryId?: string | null,
          estimatedCompletionTimeInMins?: number | null,
          actionTitle: string,
          actionDestination: string,
          actionPayload?: string | null,
          createdAt: string,
          expirationDate?: string | null,
          lessonId?: string | null,
          tags?: Array< string | null > | null,
          isArchived: BoolEnum,
          updatedAt: string,
        } | null,
        userId: string,
        order?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        dateTimeAdded: number,
        completed: BoolEnum,
        dismissed: BoolEnum,
        completedTimestamp?: number | null,
        expirationDate?: string | null,
        locked: BoolEnum,
        hidden: BoolEnum,
        isScheduled: BoolEnum,
        visibleDate: string,
        visibleTimestamp?: number | null,
        growthPathJourneyId?: string | null,
        growthPathJourneyStep?: number | null,
        growthPathJourney?:  {
          __typename: "GrowthPathJourney",
          id: string,
          title: string,
          description?: string | null,
          focusAreaId: string,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        coachId?: string | null,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        source?: UserGrowthPathItemSourceEnum | null,
        lastActivityTimestamp?: number | null,
        dependsOnGrowthPathItems?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type CreateUserCoachMutationVariables = {
  input: CreateUserCoachInput,
  condition?: ModelUserCoachConditionInput | null,
};

export type CreateUserCoachMutation = {
  createUserCoach?:  {
    __typename: "UserCoach",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPrimary: BoolEnum,
    active: BoolEnum,
    coachingStartDate: string,
    coachingEndDate?: string | null,
    ratings?:  {
      __typename: "ModelUserCoachRatingConnection",
      items:  Array< {
        __typename: "UserCoachRating",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        rating: number,
        comment?: string | null,
        ratingTimestamp: number,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserCoachMutationVariables = {
  input: UpdateUserCoachInput,
  condition?: ModelUserCoachConditionInput | null,
};

export type UpdateUserCoachMutation = {
  updateUserCoach?:  {
    __typename: "UserCoach",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPrimary: BoolEnum,
    active: BoolEnum,
    coachingStartDate: string,
    coachingEndDate?: string | null,
    ratings?:  {
      __typename: "ModelUserCoachRatingConnection",
      items:  Array< {
        __typename: "UserCoachRating",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        rating: number,
        comment?: string | null,
        ratingTimestamp: number,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserCoachMutationVariables = {
  input: DeleteUserCoachInput,
  condition?: ModelUserCoachConditionInput | null,
};

export type DeleteUserCoachMutation = {
  deleteUserCoach?:  {
    __typename: "UserCoach",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPrimary: BoolEnum,
    active: BoolEnum,
    coachingStartDate: string,
    coachingEndDate?: string | null,
    ratings?:  {
      __typename: "ModelUserCoachRatingConnection",
      items:  Array< {
        __typename: "UserCoachRating",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        rating: number,
        comment?: string | null,
        ratingTimestamp: number,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserCoachRatingMutationVariables = {
  input: CreateUserCoachRatingInput,
  condition?: ModelUserCoachRatingConditionInput | null,
};

export type CreateUserCoachRatingMutation = {
  createUserCoachRating?:  {
    __typename: "UserCoachRating",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    rating: number,
    comment?: string | null,
    ratingTimestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserCoachRatingMutationVariables = {
  input: UpdateUserCoachRatingInput,
  condition?: ModelUserCoachRatingConditionInput | null,
};

export type UpdateUserCoachRatingMutation = {
  updateUserCoachRating?:  {
    __typename: "UserCoachRating",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    rating: number,
    comment?: string | null,
    ratingTimestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserCoachRatingMutationVariables = {
  input: DeleteUserCoachRatingInput,
  condition?: ModelUserCoachRatingConditionInput | null,
};

export type DeleteUserCoachRatingMutation = {
  deleteUserCoachRating?:  {
    __typename: "UserCoachRating",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    rating: number,
    comment?: string | null,
    ratingTimestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserCoachingNoteMutationVariables = {
  input: CreateUserCoachingNoteInput,
  condition?: ModelUserCoachingNoteConditionInput | null,
};

export type CreateUserCoachingNoteMutation = {
  createUserCoachingNote?:  {
    __typename: "UserCoachingNote",
    id: string,
    userId: string,
    coachId: string,
    appointmentId?: string | null,
    appointment?:  {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null,
    note: string,
    visibleToUser: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserCoachingNoteMutationVariables = {
  input: UpdateUserCoachingNoteInput,
  condition?: ModelUserCoachingNoteConditionInput | null,
};

export type UpdateUserCoachingNoteMutation = {
  updateUserCoachingNote?:  {
    __typename: "UserCoachingNote",
    id: string,
    userId: string,
    coachId: string,
    appointmentId?: string | null,
    appointment?:  {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null,
    note: string,
    visibleToUser: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserCoachingNoteMutationVariables = {
  input: DeleteUserCoachingNoteInput,
  condition?: ModelUserCoachingNoteConditionInput | null,
};

export type DeleteUserCoachingNoteMutation = {
  deleteUserCoachingNote?:  {
    __typename: "UserCoachingNote",
    id: string,
    userId: string,
    coachId: string,
    appointmentId?: string | null,
    appointment?:  {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null,
    note: string,
    visibleToUser: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserStatsMutationVariables = {
  input: CreateUserStatsInput,
  condition?: ModelUserStatsConditionInput | null,
};

export type CreateUserStatsMutation = {
  createUserStats?:  {
    __typename: "UserStats",
    userId: string,
    totalHabitLogged?: number | null,
    totalAppointmentsScheduled?: number | null,
    totalLessonsWatched?: number | null,
    totalLogins?: number | null,
    totalMessages?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserStatsMutationVariables = {
  input: UpdateUserStatsInput,
  condition?: ModelUserStatsConditionInput | null,
};

export type UpdateUserStatsMutation = {
  updateUserStats?:  {
    __typename: "UserStats",
    userId: string,
    totalHabitLogged?: number | null,
    totalAppointmentsScheduled?: number | null,
    totalLessonsWatched?: number | null,
    totalLogins?: number | null,
    totalMessages?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserStatsMutationVariables = {
  input: DeleteUserStatsInput,
  condition?: ModelUserStatsConditionInput | null,
};

export type DeleteUserStatsMutation = {
  deleteUserStats?:  {
    __typename: "UserStats",
    userId: string,
    totalHabitLogged?: number | null,
    totalAppointmentsScheduled?: number | null,
    totalLessonsWatched?: number | null,
    totalLogins?: number | null,
    totalMessages?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserActivityLogMutationVariables = {
  input: CreateUserActivityLogInput,
  condition?: ModelUserActivityLogConditionInput | null,
};

export type CreateUserActivityLogMutation = {
  createUserActivityLog?:  {
    __typename: "UserActivityLog",
    id: string,
    type: UserActivitiesEnum,
    source: ActivitySourceEnum,
    payload?: string | null,
    timestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserActivityLogMutationVariables = {
  input: UpdateUserActivityLogInput,
  condition?: ModelUserActivityLogConditionInput | null,
};

export type UpdateUserActivityLogMutation = {
  updateUserActivityLog?:  {
    __typename: "UserActivityLog",
    id: string,
    type: UserActivitiesEnum,
    source: ActivitySourceEnum,
    payload?: string | null,
    timestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserActivityLogMutationVariables = {
  input: DeleteUserActivityLogInput,
  condition?: ModelUserActivityLogConditionInput | null,
};

export type DeleteUserActivityLogMutation = {
  deleteUserActivityLog?:  {
    __typename: "UserActivityLog",
    id: string,
    type: UserActivitiesEnum,
    source: ActivitySourceEnum,
    payload?: string | null,
    timestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateJournalEntryTemplatesMutationVariables = {
  input: CreateJournalEntryTemplatesInput,
  condition?: ModelJournalEntryTemplatesConditionInput | null,
};

export type CreateJournalEntryTemplatesMutation = {
  createJournalEntryTemplates?:  {
    __typename: "JournalEntryTemplates",
    id: string,
    name: string,
    description?: string | null,
    templateText: string,
    templateBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateJournalEntryTemplatesMutationVariables = {
  input: UpdateJournalEntryTemplatesInput,
  condition?: ModelJournalEntryTemplatesConditionInput | null,
};

export type UpdateJournalEntryTemplatesMutation = {
  updateJournalEntryTemplates?:  {
    __typename: "JournalEntryTemplates",
    id: string,
    name: string,
    description?: string | null,
    templateText: string,
    templateBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteJournalEntryTemplatesMutationVariables = {
  input: DeleteJournalEntryTemplatesInput,
  condition?: ModelJournalEntryTemplatesConditionInput | null,
};

export type DeleteJournalEntryTemplatesMutation = {
  deleteJournalEntryTemplates?:  {
    __typename: "JournalEntryTemplates",
    id: string,
    name: string,
    description?: string | null,
    templateText: string,
    templateBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserJournalEntryLogMutationVariables = {
  input: CreateUserJournalEntryLogInput,
  condition?: ModelUserJournalEntryLogConditionInput | null,
};

export type CreateUserJournalEntryLogMutation = {
  createUserJournalEntryLog?:  {
    __typename: "UserJournalEntryLog",
    userId: string,
    entryTitle: string,
    entryLogType: JournalEntryLogTypeEnum,
    entryLogTags?:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } > | null,
    isVisibleToCoach: BoolEnum,
    isVisibleToPublic: BoolEnum,
    entryText: string,
    entryBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    journalEntryTemplateId?: string | null,
    rawEntry?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserJournalEntryLogMutationVariables = {
  input: UpdateUserJournalEntryLogInput,
  condition?: ModelUserJournalEntryLogConditionInput | null,
};

export type UpdateUserJournalEntryLogMutation = {
  updateUserJournalEntryLog?:  {
    __typename: "UserJournalEntryLog",
    userId: string,
    entryTitle: string,
    entryLogType: JournalEntryLogTypeEnum,
    entryLogTags?:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } > | null,
    isVisibleToCoach: BoolEnum,
    isVisibleToPublic: BoolEnum,
    entryText: string,
    entryBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    journalEntryTemplateId?: string | null,
    rawEntry?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserJournalEntryLogMutationVariables = {
  input: DeleteUserJournalEntryLogInput,
  condition?: ModelUserJournalEntryLogConditionInput | null,
};

export type DeleteUserJournalEntryLogMutation = {
  deleteUserJournalEntryLog?:  {
    __typename: "UserJournalEntryLog",
    userId: string,
    entryTitle: string,
    entryLogType: JournalEntryLogTypeEnum,
    entryLogTags?:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } > | null,
    isVisibleToCoach: BoolEnum,
    isVisibleToPublic: BoolEnum,
    entryText: string,
    entryBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    journalEntryTemplateId?: string | null,
    rawEntry?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserPlanMutationVariables = {
  input: CreateUserPlanInput,
  condition?: ModelUserPlanConditionInput | null,
};

export type CreateUserPlanMutation = {
  createUserPlan?:  {
    __typename: "UserPlan",
    id: string,
    userId: string,
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planPricingSlug: string,
    planPricing?:  {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    cancelled?: BoolEnum | null,
    cancellationReason?: string | null,
    createdAt: string,
    active: BoolEnum,
    metadata?:  {
      __typename: "UserPlanMetadata",
      stripeSubscriptionId?: string | null,
      stripeCustomerId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type UpdateUserPlanMutationVariables = {
  input: UpdateUserPlanInput,
  condition?: ModelUserPlanConditionInput | null,
};

export type UpdateUserPlanMutation = {
  updateUserPlan?:  {
    __typename: "UserPlan",
    id: string,
    userId: string,
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planPricingSlug: string,
    planPricing?:  {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    cancelled?: BoolEnum | null,
    cancellationReason?: string | null,
    createdAt: string,
    active: BoolEnum,
    metadata?:  {
      __typename: "UserPlanMetadata",
      stripeSubscriptionId?: string | null,
      stripeCustomerId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type DeleteUserPlanMutationVariables = {
  input: DeleteUserPlanInput,
  condition?: ModelUserPlanConditionInput | null,
};

export type DeleteUserPlanMutation = {
  deleteUserPlan?:  {
    __typename: "UserPlan",
    id: string,
    userId: string,
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planPricingSlug: string,
    planPricing?:  {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    cancelled?: BoolEnum | null,
    cancellationReason?: string | null,
    createdAt: string,
    active: BoolEnum,
    metadata?:  {
      __typename: "UserPlanMetadata",
      stripeSubscriptionId?: string | null,
      stripeCustomerId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreateUserCoachingCreditsMutationVariables = {
  input: CreateUserCoachingCreditsInput,
  condition?: ModelUserCoachingCreditsConditionInput | null,
};

export type CreateUserCoachingCreditsMutation = {
  createUserCoachingCredits?:  {
    __typename: "UserCoachingCredits",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    yearMonth: number,
    creditsAwarded: number,
    creditsRemaining: number,
    lastUsedTimestamp?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserCoachingCreditsMutationVariables = {
  input: UpdateUserCoachingCreditsInput,
  condition?: ModelUserCoachingCreditsConditionInput | null,
};

export type UpdateUserCoachingCreditsMutation = {
  updateUserCoachingCredits?:  {
    __typename: "UserCoachingCredits",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    yearMonth: number,
    creditsAwarded: number,
    creditsRemaining: number,
    lastUsedTimestamp?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserCoachingCreditsMutationVariables = {
  input: DeleteUserCoachingCreditsInput,
  condition?: ModelUserCoachingCreditsConditionInput | null,
};

export type DeleteUserCoachingCreditsMutation = {
  deleteUserCoachingCredits?:  {
    __typename: "UserCoachingCredits",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    yearMonth: number,
    creditsAwarded: number,
    creditsRemaining: number,
    lastUsedTimestamp?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserCoachingCreditUsageLogMutationVariables = {
  input: CreateUserCoachingCreditUsageLogInput,
  condition?: ModelUserCoachingCreditUsageLogConditionInput | null,
};

export type CreateUserCoachingCreditUsageLogMutation = {
  createUserCoachingCreditUsageLog?:  {
    __typename: "UserCoachingCreditUsageLog",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    memo: string,
    timestamp: number,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserCoachingCreditUsageLogMutationVariables = {
  input: UpdateUserCoachingCreditUsageLogInput,
  condition?: ModelUserCoachingCreditUsageLogConditionInput | null,
};

export type UpdateUserCoachingCreditUsageLogMutation = {
  updateUserCoachingCreditUsageLog?:  {
    __typename: "UserCoachingCreditUsageLog",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    memo: string,
    timestamp: number,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserCoachingCreditUsageLogMutationVariables = {
  input: DeleteUserCoachingCreditUsageLogInput,
  condition?: ModelUserCoachingCreditUsageLogConditionInput | null,
};

export type DeleteUserCoachingCreditUsageLogMutation = {
  deleteUserCoachingCreditUsageLog?:  {
    __typename: "UserCoachingCreditUsageLog",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    memo: string,
    timestamp: number,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserFocusAreaMutationVariables = {
  input: CreateUserFocusAreaInput,
  condition?: ModelUserFocusAreaConditionInput | null,
};

export type CreateUserFocusAreaMutation = {
  createUserFocusArea?:  {
    __typename: "UserFocusArea",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    completed: BoolEnum,
    dateCompleted?: number | null,
    userFocusAreaGoals?:  {
      __typename: "ModelUserFocusAreaGoalsConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoals",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userFocusAreaGoalHabits?:  {
          __typename: "ModelUserFocusAreaGoalHabitConnection",
          nextToken?: string | null,
        } | null,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserFocusAreaMutationVariables = {
  input: UpdateUserFocusAreaInput,
  condition?: ModelUserFocusAreaConditionInput | null,
};

export type UpdateUserFocusAreaMutation = {
  updateUserFocusArea?:  {
    __typename: "UserFocusArea",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    completed: BoolEnum,
    dateCompleted?: number | null,
    userFocusAreaGoals?:  {
      __typename: "ModelUserFocusAreaGoalsConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoals",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userFocusAreaGoalHabits?:  {
          __typename: "ModelUserFocusAreaGoalHabitConnection",
          nextToken?: string | null,
        } | null,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserFocusAreaMutationVariables = {
  input: DeleteUserFocusAreaInput,
  condition?: ModelUserFocusAreaConditionInput | null,
};

export type DeleteUserFocusAreaMutation = {
  deleteUserFocusArea?:  {
    __typename: "UserFocusArea",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    completed: BoolEnum,
    dateCompleted?: number | null,
    userFocusAreaGoals?:  {
      __typename: "ModelUserFocusAreaGoalsConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoals",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userFocusAreaGoalHabits?:  {
          __typename: "ModelUserFocusAreaGoalHabitConnection",
          nextToken?: string | null,
        } | null,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserFocusAreaGoalsMutationVariables = {
  input: CreateUserFocusAreaGoalsInput,
  condition?: ModelUserFocusAreaGoalsConditionInput | null,
};

export type CreateUserFocusAreaGoalsMutation = {
  createUserFocusAreaGoals?:  {
    __typename: "UserFocusAreaGoals",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userFocusAreaGoalHabits?:  {
      __typename: "ModelUserFocusAreaGoalHabitConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabit",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitId: string,
        focusAreaGoalHabit?:  {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitLog?:  {
          __typename: "ModelUserFocusAreaGoalHabitLogConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserFocusAreaGoalsMutationVariables = {
  input: UpdateUserFocusAreaGoalsInput,
  condition?: ModelUserFocusAreaGoalsConditionInput | null,
};

export type UpdateUserFocusAreaGoalsMutation = {
  updateUserFocusAreaGoals?:  {
    __typename: "UserFocusAreaGoals",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userFocusAreaGoalHabits?:  {
      __typename: "ModelUserFocusAreaGoalHabitConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabit",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitId: string,
        focusAreaGoalHabit?:  {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitLog?:  {
          __typename: "ModelUserFocusAreaGoalHabitLogConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserFocusAreaGoalsMutationVariables = {
  input: DeleteUserFocusAreaGoalsInput,
  condition?: ModelUserFocusAreaGoalsConditionInput | null,
};

export type DeleteUserFocusAreaGoalsMutation = {
  deleteUserFocusAreaGoals?:  {
    __typename: "UserFocusAreaGoals",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userFocusAreaGoalHabits?:  {
      __typename: "ModelUserFocusAreaGoalHabitConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabit",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitId: string,
        focusAreaGoalHabit?:  {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitLog?:  {
          __typename: "ModelUserFocusAreaGoalHabitLogConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserFocusAreaGoalHabitMutationVariables = {
  input: CreateUserFocusAreaGoalHabitInput,
  condition?: ModelUserFocusAreaGoalHabitConditionInput | null,
};

export type CreateUserFocusAreaGoalHabitMutation = {
  createUserFocusAreaGoalHabit?:  {
    __typename: "UserFocusAreaGoalHabit",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitId: string,
    focusAreaGoalHabit?:  {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitLog?:  {
      __typename: "ModelUserFocusAreaGoalHabitLogConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabitLog",
        id: string,
        userId: string,
        userFocusAreaGoalHabitId: string,
        year: number,
        month: number,
        week: number,
        day: number,
        note?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateUserFocusAreaGoalHabitMutationVariables = {
  input: UpdateUserFocusAreaGoalHabitInput,
  condition?: ModelUserFocusAreaGoalHabitConditionInput | null,
};

export type UpdateUserFocusAreaGoalHabitMutation = {
  updateUserFocusAreaGoalHabit?:  {
    __typename: "UserFocusAreaGoalHabit",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitId: string,
    focusAreaGoalHabit?:  {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitLog?:  {
      __typename: "ModelUserFocusAreaGoalHabitLogConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabitLog",
        id: string,
        userId: string,
        userFocusAreaGoalHabitId: string,
        year: number,
        month: number,
        week: number,
        day: number,
        note?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteUserFocusAreaGoalHabitMutationVariables = {
  input: DeleteUserFocusAreaGoalHabitInput,
  condition?: ModelUserFocusAreaGoalHabitConditionInput | null,
};

export type DeleteUserFocusAreaGoalHabitMutation = {
  deleteUserFocusAreaGoalHabit?:  {
    __typename: "UserFocusAreaGoalHabit",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitId: string,
    focusAreaGoalHabit?:  {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitLog?:  {
      __typename: "ModelUserFocusAreaGoalHabitLogConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabitLog",
        id: string,
        userId: string,
        userFocusAreaGoalHabitId: string,
        year: number,
        month: number,
        week: number,
        day: number,
        note?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateUserFocusAreaGoalHabitLogMutationVariables = {
  input: CreateUserFocusAreaGoalHabitLogInput,
  condition?: ModelUserFocusAreaGoalHabitLogConditionInput | null,
};

export type CreateUserFocusAreaGoalHabitLogMutation = {
  createUserFocusAreaGoalHabitLog?:  {
    __typename: "UserFocusAreaGoalHabitLog",
    id: string,
    userId: string,
    userFocusAreaGoalHabitId: string,
    year: number,
    month: number,
    week: number,
    day: number,
    note?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserFocusAreaGoalHabitLogMutationVariables = {
  input: UpdateUserFocusAreaGoalHabitLogInput,
  condition?: ModelUserFocusAreaGoalHabitLogConditionInput | null,
};

export type UpdateUserFocusAreaGoalHabitLogMutation = {
  updateUserFocusAreaGoalHabitLog?:  {
    __typename: "UserFocusAreaGoalHabitLog",
    id: string,
    userId: string,
    userFocusAreaGoalHabitId: string,
    year: number,
    month: number,
    week: number,
    day: number,
    note?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserFocusAreaGoalHabitLogMutationVariables = {
  input: DeleteUserFocusAreaGoalHabitLogInput,
  condition?: ModelUserFocusAreaGoalHabitLogConditionInput | null,
};

export type DeleteUserFocusAreaGoalHabitLogMutation = {
  deleteUserFocusAreaGoalHabitLog?:  {
    __typename: "UserFocusAreaGoalHabitLog",
    id: string,
    userId: string,
    userFocusAreaGoalHabitId: string,
    year: number,
    month: number,
    week: number,
    day: number,
    note?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserAssessmentLogMutationVariables = {
  input: CreateUserAssessmentLogInput,
  condition?: ModelUserAssessmentLogConditionInput | null,
};

export type CreateUserAssessmentLogMutation = {
  createUserAssessmentLog?:  {
    __typename: "UserAssessmentLog",
    id: string,
    createdAt: string,
    userId: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    assessment: string,
    score: number,
    maxScore: number,
    userNotified: boolean,
    coachReviewed: BoolEnum,
    updatedAt: string,
  } | null,
};

export type UpdateUserAssessmentLogMutationVariables = {
  input: UpdateUserAssessmentLogInput,
  condition?: ModelUserAssessmentLogConditionInput | null,
};

export type UpdateUserAssessmentLogMutation = {
  updateUserAssessmentLog?:  {
    __typename: "UserAssessmentLog",
    id: string,
    createdAt: string,
    userId: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    assessment: string,
    score: number,
    maxScore: number,
    userNotified: boolean,
    coachReviewed: BoolEnum,
    updatedAt: string,
  } | null,
};

export type DeleteUserAssessmentLogMutationVariables = {
  input: DeleteUserAssessmentLogInput,
  condition?: ModelUserAssessmentLogConditionInput | null,
};

export type DeleteUserAssessmentLogMutation = {
  deleteUserAssessmentLog?:  {
    __typename: "UserAssessmentLog",
    id: string,
    createdAt: string,
    userId: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    assessment: string,
    score: number,
    maxScore: number,
    userNotified: boolean,
    coachReviewed: BoolEnum,
    updatedAt: string,
  } | null,
};

export type CreateUserLessonsMutationVariables = {
  input: CreateUserLessonsInput,
  condition?: ModelUserLessonsConditionInput | null,
};

export type CreateUserLessonsMutation = {
  createUserLessons?:  {
    __typename: "UserLessons",
    id: string,
    userId: string,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    startTimestamp?: number | null,
    completedTimestamp?: number | null,
    lastViewedTimestamp?: number | null,
    completed: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserLessonsMutationVariables = {
  input: UpdateUserLessonsInput,
  condition?: ModelUserLessonsConditionInput | null,
};

export type UpdateUserLessonsMutation = {
  updateUserLessons?:  {
    __typename: "UserLessons",
    id: string,
    userId: string,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    startTimestamp?: number | null,
    completedTimestamp?: number | null,
    lastViewedTimestamp?: number | null,
    completed: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserLessonsMutationVariables = {
  input: DeleteUserLessonsInput,
  condition?: ModelUserLessonsConditionInput | null,
};

export type DeleteUserLessonsMutation = {
  deleteUserLessons?:  {
    __typename: "UserLessons",
    id: string,
    userId: string,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    startTimestamp?: number | null,
    completedTimestamp?: number | null,
    lastViewedTimestamp?: number | null,
    completed: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserGrowthPathItemMutationVariables = {
  input: CreateUserGrowthPathItemInput,
  condition?: ModelUserGrowthPathItemConditionInput | null,
};

export type CreateUserGrowthPathItemMutation = {
  createUserGrowthPathItem?:  {
    __typename: "UserGrowthPathItem",
    id: string,
    growthPathItemId: string,
    growthPathItem?:  {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null,
    userId: string,
    order?: number | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    dateTimeAdded: number,
    completed: BoolEnum,
    dismissed: BoolEnum,
    completedTimestamp?: number | null,
    expirationDate?: string | null,
    locked: BoolEnum,
    hidden: BoolEnum,
    isScheduled: BoolEnum,
    visibleDate: string,
    visibleTimestamp?: number | null,
    growthPathJourneyId?: string | null,
    growthPathJourneyStep?: number | null,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    coachId?: string | null,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    source?: UserGrowthPathItemSourceEnum | null,
    lastActivityTimestamp?: number | null,
    dependsOnGrowthPathItems?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserGrowthPathItemMutationVariables = {
  input: UpdateUserGrowthPathItemInput,
  condition?: ModelUserGrowthPathItemConditionInput | null,
};

export type UpdateUserGrowthPathItemMutation = {
  updateUserGrowthPathItem?:  {
    __typename: "UserGrowthPathItem",
    id: string,
    growthPathItemId: string,
    growthPathItem?:  {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null,
    userId: string,
    order?: number | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    dateTimeAdded: number,
    completed: BoolEnum,
    dismissed: BoolEnum,
    completedTimestamp?: number | null,
    expirationDate?: string | null,
    locked: BoolEnum,
    hidden: BoolEnum,
    isScheduled: BoolEnum,
    visibleDate: string,
    visibleTimestamp?: number | null,
    growthPathJourneyId?: string | null,
    growthPathJourneyStep?: number | null,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    coachId?: string | null,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    source?: UserGrowthPathItemSourceEnum | null,
    lastActivityTimestamp?: number | null,
    dependsOnGrowthPathItems?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserGrowthPathItemMutationVariables = {
  input: DeleteUserGrowthPathItemInput,
  condition?: ModelUserGrowthPathItemConditionInput | null,
};

export type DeleteUserGrowthPathItemMutation = {
  deleteUserGrowthPathItem?:  {
    __typename: "UserGrowthPathItem",
    id: string,
    growthPathItemId: string,
    growthPathItem?:  {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null,
    userId: string,
    order?: number | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    dateTimeAdded: number,
    completed: BoolEnum,
    dismissed: BoolEnum,
    completedTimestamp?: number | null,
    expirationDate?: string | null,
    locked: BoolEnum,
    hidden: BoolEnum,
    isScheduled: BoolEnum,
    visibleDate: string,
    visibleTimestamp?: number | null,
    growthPathJourneyId?: string | null,
    growthPathJourneyStep?: number | null,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    coachId?: string | null,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    source?: UserGrowthPathItemSourceEnum | null,
    lastActivityTimestamp?: number | null,
    dependsOnGrowthPathItems?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserGrowthPathJourneyMutationVariables = {
  input: CreateUserGrowthPathJourneyInput,
  condition?: ModelUserGrowthPathJourneyConditionInput | null,
};

export type CreateUserGrowthPathJourneyMutation = {
  createUserGrowthPathJourney?:  {
    __typename: "UserGrowthPathJourney",
    userId: string,
    growthPathJourneyId: string,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    completionLog?:  Array< {
      __typename: "UserGrowthPathJourneyCompletionLog",
      growthPathItemId: string,
      completionTimestamp: number,
    } > | null,
    lastActivityTimestamp: number,
    active: BoolEnum,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserGrowthPathJourneyMutationVariables = {
  input: UpdateUserGrowthPathJourneyInput,
  condition?: ModelUserGrowthPathJourneyConditionInput | null,
};

export type UpdateUserGrowthPathJourneyMutation = {
  updateUserGrowthPathJourney?:  {
    __typename: "UserGrowthPathJourney",
    userId: string,
    growthPathJourneyId: string,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    completionLog?:  Array< {
      __typename: "UserGrowthPathJourneyCompletionLog",
      growthPathItemId: string,
      completionTimestamp: number,
    } > | null,
    lastActivityTimestamp: number,
    active: BoolEnum,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserGrowthPathJourneyMutationVariables = {
  input: DeleteUserGrowthPathJourneyInput,
  condition?: ModelUserGrowthPathJourneyConditionInput | null,
};

export type DeleteUserGrowthPathJourneyMutation = {
  deleteUserGrowthPathJourney?:  {
    __typename: "UserGrowthPathJourney",
    userId: string,
    growthPathJourneyId: string,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    completionLog?:  Array< {
      __typename: "UserGrowthPathJourneyCompletionLog",
      growthPathItemId: string,
      completionTimestamp: number,
    } > | null,
    lastActivityTimestamp: number,
    active: BoolEnum,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateGrowthPathJourneyMutationVariables = {
  input: CreateGrowthPathJourneyInput,
  condition?: ModelGrowthPathJourneyConditionInput | null,
};

export type CreateGrowthPathJourneyMutation = {
  createGrowthPathJourney?:  {
    __typename: "GrowthPathJourney",
    id: string,
    title: string,
    description?: string | null,
    growthPathItems:  Array< {
      __typename: "GrowthPathJourneyGrowthPathItem",
      step: number,
      growthPathItemId: string,
      rules?:  Array< {
        __typename: "GrowthPathItemDependencies",
        ruleType: DependencyTypeEnum,
        dependencyGrowthPathItemId: string,
        scheduleDaysFromNow?: number | null,
      } > | null,
    } >,
    focusAreaId: string,
    focusArea:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateGrowthPathJourneyMutationVariables = {
  input: UpdateGrowthPathJourneyInput,
  condition?: ModelGrowthPathJourneyConditionInput | null,
};

export type UpdateGrowthPathJourneyMutation = {
  updateGrowthPathJourney?:  {
    __typename: "GrowthPathJourney",
    id: string,
    title: string,
    description?: string | null,
    growthPathItems:  Array< {
      __typename: "GrowthPathJourneyGrowthPathItem",
      step: number,
      growthPathItemId: string,
      rules?:  Array< {
        __typename: "GrowthPathItemDependencies",
        ruleType: DependencyTypeEnum,
        dependencyGrowthPathItemId: string,
        scheduleDaysFromNow?: number | null,
      } > | null,
    } >,
    focusAreaId: string,
    focusArea:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteGrowthPathJourneyMutationVariables = {
  input: DeleteGrowthPathJourneyInput,
  condition?: ModelGrowthPathJourneyConditionInput | null,
};

export type DeleteGrowthPathJourneyMutation = {
  deleteGrowthPathJourney?:  {
    __typename: "GrowthPathJourney",
    id: string,
    title: string,
    description?: string | null,
    growthPathItems:  Array< {
      __typename: "GrowthPathJourneyGrowthPathItem",
      step: number,
      growthPathItemId: string,
      rules?:  Array< {
        __typename: "GrowthPathItemDependencies",
        ruleType: DependencyTypeEnum,
        dependencyGrowthPathItemId: string,
        scheduleDaysFromNow?: number | null,
      } > | null,
    } >,
    focusAreaId: string,
    focusArea:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserAppointmentsMutationVariables = {
  input: CreateUserAppointmentsInput,
  condition?: ModelUserAppointmentsConditionInput | null,
};

export type CreateUserAppointmentsMutation = {
  createUserAppointments?:  {
    __typename: "UserAppointments",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointmentStartTime: number,
    appointmentEndTime: number,
    appointmentDurationMins: number,
    appointmentTimezone: string,
    appointmentType: AppointmentTypeEnum,
    cancelled?: BoolEnum | null,
    cancelDate?: number | null,
    cancelReason?: string | null,
    cancelNote?: string | null,
    metadata:  {
      __typename: "UserAppointementMetadata",
      acuityAppointmentId?: string | null,
      acuityAppointmentTypeId?: string | null,
      acuityConfirmationPageUrl?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserAppointmentsMutationVariables = {
  input: UpdateUserAppointmentsInput,
  condition?: ModelUserAppointmentsConditionInput | null,
};

export type UpdateUserAppointmentsMutation = {
  updateUserAppointments?:  {
    __typename: "UserAppointments",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointmentStartTime: number,
    appointmentEndTime: number,
    appointmentDurationMins: number,
    appointmentTimezone: string,
    appointmentType: AppointmentTypeEnum,
    cancelled?: BoolEnum | null,
    cancelDate?: number | null,
    cancelReason?: string | null,
    cancelNote?: string | null,
    metadata:  {
      __typename: "UserAppointementMetadata",
      acuityAppointmentId?: string | null,
      acuityAppointmentTypeId?: string | null,
      acuityConfirmationPageUrl?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserAppointmentsMutationVariables = {
  input: DeleteUserAppointmentsInput,
  condition?: ModelUserAppointmentsConditionInput | null,
};

export type DeleteUserAppointmentsMutation = {
  deleteUserAppointments?:  {
    __typename: "UserAppointments",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointmentStartTime: number,
    appointmentEndTime: number,
    appointmentDurationMins: number,
    appointmentTimezone: string,
    appointmentType: AppointmentTypeEnum,
    cancelled?: BoolEnum | null,
    cancelDate?: number | null,
    cancelReason?: string | null,
    cancelNote?: string | null,
    metadata:  {
      __typename: "UserAppointementMetadata",
      acuityAppointmentId?: string | null,
      acuityAppointmentTypeId?: string | null,
      acuityConfirmationPageUrl?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserNotificationMutationVariables = {
  input: CreateUserNotificationInput,
  condition?: ModelUserNotificationConditionInput | null,
};

export type CreateUserNotificationMutation = {
  createUserNotification?:  {
    __typename: "UserNotification",
    id: string,
    userId: string,
    notificationType: UserNotificationTypeEnum,
    notificationMessage: string,
    notificationTitle: string,
    notificationExpirationDate?: string | null,
    notificationRead: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserNotificationMutationVariables = {
  input: UpdateUserNotificationInput,
  condition?: ModelUserNotificationConditionInput | null,
};

export type UpdateUserNotificationMutation = {
  updateUserNotification?:  {
    __typename: "UserNotification",
    id: string,
    userId: string,
    notificationType: UserNotificationTypeEnum,
    notificationMessage: string,
    notificationTitle: string,
    notificationExpirationDate?: string | null,
    notificationRead: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserNotificationMutationVariables = {
  input: DeleteUserNotificationInput,
  condition?: ModelUserNotificationConditionInput | null,
};

export type DeleteUserNotificationMutation = {
  deleteUserNotification?:  {
    __typename: "UserNotification",
    id: string,
    userId: string,
    notificationType: UserNotificationTypeEnum,
    notificationMessage: string,
    notificationTitle: string,
    notificationExpirationDate?: string | null,
    notificationRead: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCoachMutationVariables = {
  input: CreateCoachInput,
  condition?: ModelCoachConditionInput | null,
};

export type CreateCoachMutation = {
  createCoach?:  {
    __typename: "Coach",
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    title?: string | null,
    coachType?: Array< CoachTypeEnum | null > | null,
    avatarUrl?: string | null,
    description?: string | null,
    metadata?:  {
      __typename: "CoachMetaData",
      introVideoUrl?: string | null,
      gcalId?: string | null,
      calendlyId?: string | null,
      acuityCalendarId?: string | null,
      acuityUserId?: string | null,
      acuityKey?: string | null,
      acuityIssAppointmentId?: string | null,
      acuityRegularAppointmentId?: string | null,
      streamChatId?: string | null,
      slackId?: string | null,
      lastCoachNote?: number | null,
      lastChatMessage?: number | null,
    } | null,
    focusAreas?:  {
      __typename: "ModelCoachFocusAreaConnection",
      items:  Array< {
        __typename: "CoachFocusArea",
        id: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    members?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCoachMutationVariables = {
  input: UpdateCoachInput,
  condition?: ModelCoachConditionInput | null,
};

export type UpdateCoachMutation = {
  updateCoach?:  {
    __typename: "Coach",
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    title?: string | null,
    coachType?: Array< CoachTypeEnum | null > | null,
    avatarUrl?: string | null,
    description?: string | null,
    metadata?:  {
      __typename: "CoachMetaData",
      introVideoUrl?: string | null,
      gcalId?: string | null,
      calendlyId?: string | null,
      acuityCalendarId?: string | null,
      acuityUserId?: string | null,
      acuityKey?: string | null,
      acuityIssAppointmentId?: string | null,
      acuityRegularAppointmentId?: string | null,
      streamChatId?: string | null,
      slackId?: string | null,
      lastCoachNote?: number | null,
      lastChatMessage?: number | null,
    } | null,
    focusAreas?:  {
      __typename: "ModelCoachFocusAreaConnection",
      items:  Array< {
        __typename: "CoachFocusArea",
        id: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    members?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCoachMutationVariables = {
  input: DeleteCoachInput,
  condition?: ModelCoachConditionInput | null,
};

export type DeleteCoachMutation = {
  deleteCoach?:  {
    __typename: "Coach",
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    title?: string | null,
    coachType?: Array< CoachTypeEnum | null > | null,
    avatarUrl?: string | null,
    description?: string | null,
    metadata?:  {
      __typename: "CoachMetaData",
      introVideoUrl?: string | null,
      gcalId?: string | null,
      calendlyId?: string | null,
      acuityCalendarId?: string | null,
      acuityUserId?: string | null,
      acuityKey?: string | null,
      acuityIssAppointmentId?: string | null,
      acuityRegularAppointmentId?: string | null,
      streamChatId?: string | null,
      slackId?: string | null,
      lastCoachNote?: number | null,
      lastChatMessage?: number | null,
    } | null,
    focusAreas?:  {
      __typename: "ModelCoachFocusAreaConnection",
      items:  Array< {
        __typename: "CoachFocusArea",
        id: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    members?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCoachFocusAreaMutationVariables = {
  input: CreateCoachFocusAreaInput,
  condition?: ModelCoachFocusAreaConditionInput | null,
};

export type CreateCoachFocusAreaMutation = {
  createCoachFocusArea?:  {
    __typename: "CoachFocusArea",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCoachFocusAreaMutationVariables = {
  input: UpdateCoachFocusAreaInput,
  condition?: ModelCoachFocusAreaConditionInput | null,
};

export type UpdateCoachFocusAreaMutation = {
  updateCoachFocusArea?:  {
    __typename: "CoachFocusArea",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCoachFocusAreaMutationVariables = {
  input: DeleteCoachFocusAreaInput,
  condition?: ModelCoachFocusAreaConditionInput | null,
};

export type DeleteCoachFocusAreaMutation = {
  deleteCoachFocusArea?:  {
    __typename: "CoachFocusArea",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCoachUserNotificationMutationVariables = {
  input: CreateCoachUserNotificationInput,
  condition?: ModelCoachUserNotificationConditionInput | null,
};

export type CreateCoachUserNotificationMutation = {
  createCoachUserNotification?:  {
    __typename: "CoachUserNotification",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    title: string,
    read: BoolEnum,
    readTimestamp?: number | null,
    notificationType: CoachNotificationTypeEnum,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCoachUserNotificationMutationVariables = {
  input: UpdateCoachUserNotificationInput,
  condition?: ModelCoachUserNotificationConditionInput | null,
};

export type UpdateCoachUserNotificationMutation = {
  updateCoachUserNotification?:  {
    __typename: "CoachUserNotification",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    title: string,
    read: BoolEnum,
    readTimestamp?: number | null,
    notificationType: CoachNotificationTypeEnum,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCoachUserNotificationMutationVariables = {
  input: DeleteCoachUserNotificationInput,
  condition?: ModelCoachUserNotificationConditionInput | null,
};

export type DeleteCoachUserNotificationMutation = {
  deleteCoachUserNotification?:  {
    __typename: "CoachUserNotification",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    title: string,
    read: BoolEnum,
    readTimestamp?: number | null,
    notificationType: CoachNotificationTypeEnum,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateGrowthPathItemMutationVariables = {
  input: CreateGrowthPathItemInput,
  condition?: ModelGrowthPathItemConditionInput | null,
};

export type CreateGrowthPathItemMutation = {
  createGrowthPathItem?:  {
    __typename: "GrowthPathItem",
    id: string,
    type: GrowthPathCardTypeEnum,
    title: string,
    subtitle?: string | null,
    avatarUrl?: string | null,
    description: string,
    categoryName?: string | null,
    categoryId?: string | null,
    estimatedCompletionTimeInMins?: number | null,
    actionTitle: string,
    actionDestination: string,
    actionPayload?: string | null,
    createdAt: string,
    expirationDate?: string | null,
    lessonId?: string | null,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    tags?: Array< string | null > | null,
    isArchived: BoolEnum,
    updatedAt: string,
  } | null,
};

export type UpdateGrowthPathItemMutationVariables = {
  input: UpdateGrowthPathItemInput,
  condition?: ModelGrowthPathItemConditionInput | null,
};

export type UpdateGrowthPathItemMutation = {
  updateGrowthPathItem?:  {
    __typename: "GrowthPathItem",
    id: string,
    type: GrowthPathCardTypeEnum,
    title: string,
    subtitle?: string | null,
    avatarUrl?: string | null,
    description: string,
    categoryName?: string | null,
    categoryId?: string | null,
    estimatedCompletionTimeInMins?: number | null,
    actionTitle: string,
    actionDestination: string,
    actionPayload?: string | null,
    createdAt: string,
    expirationDate?: string | null,
    lessonId?: string | null,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    tags?: Array< string | null > | null,
    isArchived: BoolEnum,
    updatedAt: string,
  } | null,
};

export type DeleteGrowthPathItemMutationVariables = {
  input: DeleteGrowthPathItemInput,
  condition?: ModelGrowthPathItemConditionInput | null,
};

export type DeleteGrowthPathItemMutation = {
  deleteGrowthPathItem?:  {
    __typename: "GrowthPathItem",
    id: string,
    type: GrowthPathCardTypeEnum,
    title: string,
    subtitle?: string | null,
    avatarUrl?: string | null,
    description: string,
    categoryName?: string | null,
    categoryId?: string | null,
    estimatedCompletionTimeInMins?: number | null,
    actionTitle: string,
    actionDestination: string,
    actionPayload?: string | null,
    createdAt: string,
    expirationDate?: string | null,
    lessonId?: string | null,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    tags?: Array< string | null > | null,
    isArchived: BoolEnum,
    updatedAt: string,
  } | null,
};

export type CreateTopicTagsMutationVariables = {
  input: CreateTopicTagsInput,
  condition?: ModelTopicTagsConditionInput | null,
};

export type CreateTopicTagsMutation = {
  createTopicTags?:  {
    __typename: "TopicTags",
    slug: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTopicTagsMutationVariables = {
  input: UpdateTopicTagsInput,
  condition?: ModelTopicTagsConditionInput | null,
};

export type UpdateTopicTagsMutation = {
  updateTopicTags?:  {
    __typename: "TopicTags",
    slug: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTopicTagsMutationVariables = {
  input: DeleteTopicTagsInput,
  condition?: ModelTopicTagsConditionInput | null,
};

export type DeleteTopicTagsMutation = {
  deleteTopicTags?:  {
    __typename: "TopicTags",
    slug: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFocusAreaMutationVariables = {
  input: CreateFocusAreaInput,
  condition?: ModelFocusAreaConditionInput | null,
};

export type CreateFocusAreaMutation = {
  createFocusArea?:  {
    __typename: "FocusArea",
    id: string,
    name: string,
    slug: string,
    description?: string | null,
    focusAreaGoals?:  {
      __typename: "ModelFocusAreaGoalConnection",
      items:  Array< {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFocusAreaMutationVariables = {
  input: UpdateFocusAreaInput,
  condition?: ModelFocusAreaConditionInput | null,
};

export type UpdateFocusAreaMutation = {
  updateFocusArea?:  {
    __typename: "FocusArea",
    id: string,
    name: string,
    slug: string,
    description?: string | null,
    focusAreaGoals?:  {
      __typename: "ModelFocusAreaGoalConnection",
      items:  Array< {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFocusAreaMutationVariables = {
  input: DeleteFocusAreaInput,
  condition?: ModelFocusAreaConditionInput | null,
};

export type DeleteFocusAreaMutation = {
  deleteFocusArea?:  {
    __typename: "FocusArea",
    id: string,
    name: string,
    slug: string,
    description?: string | null,
    focusAreaGoals?:  {
      __typename: "ModelFocusAreaGoalConnection",
      items:  Array< {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFocusAreaGoalMutationVariables = {
  input: CreateFocusAreaGoalInput,
  condition?: ModelFocusAreaGoalConditionInput | null,
};

export type CreateFocusAreaGoalMutation = {
  createFocusAreaGoal?:  {
    __typename: "FocusAreaGoal",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabits?:  {
      __typename: "ModelFocusAreaGoalHabitsConnection",
      items:  Array< {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFocusAreaGoalMutationVariables = {
  input: UpdateFocusAreaGoalInput,
  condition?: ModelFocusAreaGoalConditionInput | null,
};

export type UpdateFocusAreaGoalMutation = {
  updateFocusAreaGoal?:  {
    __typename: "FocusAreaGoal",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabits?:  {
      __typename: "ModelFocusAreaGoalHabitsConnection",
      items:  Array< {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFocusAreaGoalMutationVariables = {
  input: DeleteFocusAreaGoalInput,
  condition?: ModelFocusAreaGoalConditionInput | null,
};

export type DeleteFocusAreaGoalMutation = {
  deleteFocusAreaGoal?:  {
    __typename: "FocusAreaGoal",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabits?:  {
      __typename: "ModelFocusAreaGoalHabitsConnection",
      items:  Array< {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFocusAreaGoalHabitsMutationVariables = {
  input: CreateFocusAreaGoalHabitsInput,
  condition?: ModelFocusAreaGoalHabitsConditionInput | null,
};

export type CreateFocusAreaGoalHabitsMutation = {
  createFocusAreaGoalHabits?:  {
    __typename: "FocusAreaGoalHabits",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFocusAreaGoalHabitsMutationVariables = {
  input: UpdateFocusAreaGoalHabitsInput,
  condition?: ModelFocusAreaGoalHabitsConditionInput | null,
};

export type UpdateFocusAreaGoalHabitsMutation = {
  updateFocusAreaGoalHabits?:  {
    __typename: "FocusAreaGoalHabits",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFocusAreaGoalHabitsMutationVariables = {
  input: DeleteFocusAreaGoalHabitsInput,
  condition?: ModelFocusAreaGoalHabitsConditionInput | null,
};

export type DeleteFocusAreaGoalHabitsMutation = {
  deleteFocusAreaGoalHabits?:  {
    __typename: "FocusAreaGoalHabits",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProgramMutationVariables = {
  input: CreateProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type CreateProgramMutation = {
  createProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    level: number,
    lessons?:  {
      __typename: "ModelLessonConnection",
      items:  Array< {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProgramMutationVariables = {
  input: UpdateProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type UpdateProgramMutation = {
  updateProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    level: number,
    lessons?:  {
      __typename: "ModelLessonConnection",
      items:  Array< {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProgramMutationVariables = {
  input: DeleteProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type DeleteProgramMutation = {
  deleteProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    level: number,
    lessons?:  {
      __typename: "ModelLessonConnection",
      items:  Array< {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLessonMutationVariables = {
  input: CreateLessonInput,
  condition?: ModelLessonConditionInput | null,
};

export type CreateLessonMutation = {
  createLesson?:  {
    __typename: "Lesson",
    id: string,
    programId: string,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    order: number,
    durationInMins: number,
    description?: string | null,
    transcript?: string | null,
    focusAreas?:  {
      __typename: "ModelLessonFocusAreaConnection",
      items:  Array< {
        __typename: "LessonFocusArea",
        lessonId: string,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    tags?: Array< string | null > | null,
    lessonType: LessonTypeEnum,
    metadata?:  {
      __typename: "LessonMetadata",
      videoUrl?: string | null,
      videoStreamUrl?: string | null,
      videoExternalId?: string | null,
      videoDistributionPage?: string | null,
      formUrl?: string | null,
      formExternalId?: string | null,
    } | null,
    coverImageUrl?: string | null,
    isPremium: BoolEnum,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLessonMutationVariables = {
  input: UpdateLessonInput,
  condition?: ModelLessonConditionInput | null,
};

export type UpdateLessonMutation = {
  updateLesson?:  {
    __typename: "Lesson",
    id: string,
    programId: string,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    order: number,
    durationInMins: number,
    description?: string | null,
    transcript?: string | null,
    focusAreas?:  {
      __typename: "ModelLessonFocusAreaConnection",
      items:  Array< {
        __typename: "LessonFocusArea",
        lessonId: string,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    tags?: Array< string | null > | null,
    lessonType: LessonTypeEnum,
    metadata?:  {
      __typename: "LessonMetadata",
      videoUrl?: string | null,
      videoStreamUrl?: string | null,
      videoExternalId?: string | null,
      videoDistributionPage?: string | null,
      formUrl?: string | null,
      formExternalId?: string | null,
    } | null,
    coverImageUrl?: string | null,
    isPremium: BoolEnum,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLessonMutationVariables = {
  input: DeleteLessonInput,
  condition?: ModelLessonConditionInput | null,
};

export type DeleteLessonMutation = {
  deleteLesson?:  {
    __typename: "Lesson",
    id: string,
    programId: string,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    order: number,
    durationInMins: number,
    description?: string | null,
    transcript?: string | null,
    focusAreas?:  {
      __typename: "ModelLessonFocusAreaConnection",
      items:  Array< {
        __typename: "LessonFocusArea",
        lessonId: string,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    tags?: Array< string | null > | null,
    lessonType: LessonTypeEnum,
    metadata?:  {
      __typename: "LessonMetadata",
      videoUrl?: string | null,
      videoStreamUrl?: string | null,
      videoExternalId?: string | null,
      videoDistributionPage?: string | null,
      formUrl?: string | null,
      formExternalId?: string | null,
    } | null,
    coverImageUrl?: string | null,
    isPremium: BoolEnum,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLessonFocusAreaMutationVariables = {
  input: CreateLessonFocusAreaInput,
  condition?: ModelLessonFocusAreaConditionInput | null,
};

export type CreateLessonFocusAreaMutation = {
  createLessonFocusArea?:  {
    __typename: "LessonFocusArea",
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLessonFocusAreaMutationVariables = {
  input: UpdateLessonFocusAreaInput,
  condition?: ModelLessonFocusAreaConditionInput | null,
};

export type UpdateLessonFocusAreaMutation = {
  updateLessonFocusArea?:  {
    __typename: "LessonFocusArea",
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLessonFocusAreaMutationVariables = {
  input: DeleteLessonFocusAreaInput,
  condition?: ModelLessonFocusAreaConditionInput | null,
};

export type DeleteLessonFocusAreaMutation = {
  deleteLessonFocusArea?:  {
    __typename: "LessonFocusArea",
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePlanGroupMutationVariables = {
  input: CreatePlanGroupInput,
  condition?: ModelPlanGroupConditionInput | null,
};

export type CreatePlanGroupMutation = {
  createPlanGroup?:  {
    __typename: "PlanGroup",
    id: string,
    name: string,
    startDate: string,
    endDate: string,
    trialPeriod: number,
    createdAt: string,
    active: BoolEnum,
    plans?:  {
      __typename: "ModelPlanConnection",
      items:  Array< {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type UpdatePlanGroupMutationVariables = {
  input: UpdatePlanGroupInput,
  condition?: ModelPlanGroupConditionInput | null,
};

export type UpdatePlanGroupMutation = {
  updatePlanGroup?:  {
    __typename: "PlanGroup",
    id: string,
    name: string,
    startDate: string,
    endDate: string,
    trialPeriod: number,
    createdAt: string,
    active: BoolEnum,
    plans?:  {
      __typename: "ModelPlanConnection",
      items:  Array< {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type DeletePlanGroupMutationVariables = {
  input: DeletePlanGroupInput,
  condition?: ModelPlanGroupConditionInput | null,
};

export type DeletePlanGroupMutation = {
  deletePlanGroup?:  {
    __typename: "PlanGroup",
    id: string,
    name: string,
    startDate: string,
    endDate: string,
    trialPeriod: number,
    createdAt: string,
    active: BoolEnum,
    plans?:  {
      __typename: "ModelPlanConnection",
      items:  Array< {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreatePlanMutationVariables = {
  input: CreatePlanInput,
  condition?: ModelPlanConditionInput | null,
};

export type CreatePlanMutation = {
  createPlan?:  {
    __typename: "Plan",
    id: string,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    name: string,
    description?: string | null,
    active: BoolEnum,
    defaultPrice: number,
    defaultPlanPriceId?: string | null,
    discountsAllowed?: boolean | null,
    display?: boolean | null,
    isTrial?: boolean | null,
    upgradeable?: boolean | null,
    downgradeable?: boolean | null,
    features: Array< string >,
    createdAt: string,
    level: number,
    pricing?:  {
      __typename: "ModelPlanPricingConnection",
      items:  Array< {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata?:  {
      __typename: "PlanMetadata",
      coachingSessionsAllocated: number,
      stripeProductId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type UpdatePlanMutationVariables = {
  input: UpdatePlanInput,
  condition?: ModelPlanConditionInput | null,
};

export type UpdatePlanMutation = {
  updatePlan?:  {
    __typename: "Plan",
    id: string,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    name: string,
    description?: string | null,
    active: BoolEnum,
    defaultPrice: number,
    defaultPlanPriceId?: string | null,
    discountsAllowed?: boolean | null,
    display?: boolean | null,
    isTrial?: boolean | null,
    upgradeable?: boolean | null,
    downgradeable?: boolean | null,
    features: Array< string >,
    createdAt: string,
    level: number,
    pricing?:  {
      __typename: "ModelPlanPricingConnection",
      items:  Array< {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata?:  {
      __typename: "PlanMetadata",
      coachingSessionsAllocated: number,
      stripeProductId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type DeletePlanMutationVariables = {
  input: DeletePlanInput,
  condition?: ModelPlanConditionInput | null,
};

export type DeletePlanMutation = {
  deletePlan?:  {
    __typename: "Plan",
    id: string,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    name: string,
    description?: string | null,
    active: BoolEnum,
    defaultPrice: number,
    defaultPlanPriceId?: string | null,
    discountsAllowed?: boolean | null,
    display?: boolean | null,
    isTrial?: boolean | null,
    upgradeable?: boolean | null,
    downgradeable?: boolean | null,
    features: Array< string >,
    createdAt: string,
    level: number,
    pricing?:  {
      __typename: "ModelPlanPricingConnection",
      items:  Array< {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata?:  {
      __typename: "PlanMetadata",
      coachingSessionsAllocated: number,
      stripeProductId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreatePlanPricingMutationVariables = {
  input: CreatePlanPricingInput,
  condition?: ModelPlanPricingConditionInput | null,
};

export type CreatePlanPricingMutation = {
  createPlanPricing?:  {
    __typename: "PlanPricing",
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    slug: string,
    default: boolean,
    activationCodes?: Array< string | null > | null,
    downgradePricingIds?: Array< string | null > | null,
    upgradePricingIds?: Array< string | null > | null,
    price: number,
    metadata?:  {
      __typename: "PlanPricingMetada",
      stripePriceId?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePlanPricingMutationVariables = {
  input: UpdatePlanPricingInput,
  condition?: ModelPlanPricingConditionInput | null,
};

export type UpdatePlanPricingMutation = {
  updatePlanPricing?:  {
    __typename: "PlanPricing",
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    slug: string,
    default: boolean,
    activationCodes?: Array< string | null > | null,
    downgradePricingIds?: Array< string | null > | null,
    upgradePricingIds?: Array< string | null > | null,
    price: number,
    metadata?:  {
      __typename: "PlanPricingMetada",
      stripePriceId?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePlanPricingMutationVariables = {
  input: DeletePlanPricingInput,
  condition?: ModelPlanPricingConditionInput | null,
};

export type DeletePlanPricingMutation = {
  deletePlanPricing?:  {
    __typename: "PlanPricing",
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    slug: string,
    default: boolean,
    activationCodes?: Array< string | null > | null,
    downgradePricingIds?: Array< string | null > | null,
    upgradePricingIds?: Array< string | null > | null,
    price: number,
    metadata?:  {
      __typename: "PlanPricingMetada",
      stripePriceId?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventMutationVariables = {
  input: CreateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type CreateEventMutation = {
  createEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventTimeConnection",
      items:  Array< {
        __typename: "EventTime",
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        metadata?:  {
          __typename: "EventTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
      activeCampaignTagId?: number | null,
      totalSessions?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type UpdateEventMutation = {
  updateEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventTimeConnection",
      items:  Array< {
        __typename: "EventTime",
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        metadata?:  {
          __typename: "EventTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
      activeCampaignTagId?: number | null,
      totalSessions?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput,
  condition?: ModelEventConditionInput | null,
};

export type DeleteEventMutation = {
  deleteEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventTimeConnection",
      items:  Array< {
        __typename: "EventTime",
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        metadata?:  {
          __typename: "EventTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
      activeCampaignTagId?: number | null,
      totalSessions?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventTimeMutationVariables = {
  input: CreateEventTimeInput,
  condition?: ModelEventTimeConditionInput | null,
};

export type CreateEventTimeMutation = {
  createEventTime?:  {
    __typename: "EventTime",
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    metadata?:  {
      __typename: "EventTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventTimeMutationVariables = {
  input: UpdateEventTimeInput,
  condition?: ModelEventTimeConditionInput | null,
};

export type UpdateEventTimeMutation = {
  updateEventTime?:  {
    __typename: "EventTime",
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    metadata?:  {
      __typename: "EventTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventTimeMutationVariables = {
  input: DeleteEventTimeInput,
  condition?: ModelEventTimeConditionInput | null,
};

export type DeleteEventTimeMutation = {
  deleteEventTime?:  {
    __typename: "EventTime",
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    metadata?:  {
      __typename: "EventTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventSessionMutationVariables = {
  input: CreateEventSessionInput,
  condition?: ModelEventSessionConditionInput | null,
};

export type CreateEventSessionMutation = {
  createEventSession?:  {
    __typename: "EventSession",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sessionTitle?: string | null,
    sessionDescription?: string | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    isRecurring: BoolEnum,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    attendeeLimit: number,
    facilitators?:  {
      __typename: "ModelEventSessionFacilitatorConnection",
      items:  Array< {
        __typename: "EventSessionFacilitator",
        eventSessionId: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionAttendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventSessionTimeConnection",
      items:  Array< {
        __typename: "EventSessionTime",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        metadata?:  {
          __typename: "EventSessionTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionFocusAreaId?: string | null,
    eventSessionFocusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventSessionMetadata",
      chatChannelId?: string | null,
      eventSessionLandingPageUrl?: string | null,
      eventSessionMeetingLink?: string | null,
      actuityAppointmentTypeId?: string | null,
      acuityCalendarId?: string | null,
      activeCampaignTagId?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventSessionMutationVariables = {
  input: UpdateEventSessionInput,
  condition?: ModelEventSessionConditionInput | null,
};

export type UpdateEventSessionMutation = {
  updateEventSession?:  {
    __typename: "EventSession",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sessionTitle?: string | null,
    sessionDescription?: string | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    isRecurring: BoolEnum,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    attendeeLimit: number,
    facilitators?:  {
      __typename: "ModelEventSessionFacilitatorConnection",
      items:  Array< {
        __typename: "EventSessionFacilitator",
        eventSessionId: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionAttendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventSessionTimeConnection",
      items:  Array< {
        __typename: "EventSessionTime",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        metadata?:  {
          __typename: "EventSessionTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionFocusAreaId?: string | null,
    eventSessionFocusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventSessionMetadata",
      chatChannelId?: string | null,
      eventSessionLandingPageUrl?: string | null,
      eventSessionMeetingLink?: string | null,
      actuityAppointmentTypeId?: string | null,
      acuityCalendarId?: string | null,
      activeCampaignTagId?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventSessionMutationVariables = {
  input: DeleteEventSessionInput,
  condition?: ModelEventSessionConditionInput | null,
};

export type DeleteEventSessionMutation = {
  deleteEventSession?:  {
    __typename: "EventSession",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sessionTitle?: string | null,
    sessionDescription?: string | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    isRecurring: BoolEnum,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    attendeeLimit: number,
    facilitators?:  {
      __typename: "ModelEventSessionFacilitatorConnection",
      items:  Array< {
        __typename: "EventSessionFacilitator",
        eventSessionId: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionAttendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventSessionTimeConnection",
      items:  Array< {
        __typename: "EventSessionTime",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        metadata?:  {
          __typename: "EventSessionTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionFocusAreaId?: string | null,
    eventSessionFocusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventSessionMetadata",
      chatChannelId?: string | null,
      eventSessionLandingPageUrl?: string | null,
      eventSessionMeetingLink?: string | null,
      actuityAppointmentTypeId?: string | null,
      acuityCalendarId?: string | null,
      activeCampaignTagId?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventSessionTimeMutationVariables = {
  input: CreateEventSessionTimeInput,
  condition?: ModelEventSessionTimeConditionInput | null,
};

export type CreateEventSessionTimeMutation = {
  createEventSessionTime?:  {
    __typename: "EventSessionTime",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    metadata?:  {
      __typename: "EventSessionTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventSessionTimeMutationVariables = {
  input: UpdateEventSessionTimeInput,
  condition?: ModelEventSessionTimeConditionInput | null,
};

export type UpdateEventSessionTimeMutation = {
  updateEventSessionTime?:  {
    __typename: "EventSessionTime",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    metadata?:  {
      __typename: "EventSessionTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventSessionTimeMutationVariables = {
  input: DeleteEventSessionTimeInput,
  condition?: ModelEventSessionTimeConditionInput | null,
};

export type DeleteEventSessionTimeMutation = {
  deleteEventSessionTime?:  {
    __typename: "EventSessionTime",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    metadata?:  {
      __typename: "EventSessionTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventSessionFacilitatorMutationVariables = {
  input: CreateEventSessionFacilitatorInput,
  condition?: ModelEventSessionFacilitatorConditionInput | null,
};

export type CreateEventSessionFacilitatorMutation = {
  createEventSessionFacilitator?:  {
    __typename: "EventSessionFacilitator",
    eventSessionId: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventSessionFacilitatorMutationVariables = {
  input: UpdateEventSessionFacilitatorInput,
  condition?: ModelEventSessionFacilitatorConditionInput | null,
};

export type UpdateEventSessionFacilitatorMutation = {
  updateEventSessionFacilitator?:  {
    __typename: "EventSessionFacilitator",
    eventSessionId: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventSessionFacilitatorMutationVariables = {
  input: DeleteEventSessionFacilitatorInput,
  condition?: ModelEventSessionFacilitatorConditionInput | null,
};

export type DeleteEventSessionFacilitatorMutation = {
  deleteEventSessionFacilitator?:  {
    __typename: "EventSessionFacilitator",
    eventSessionId: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventSessionAttendeesMutationVariables = {
  input: CreateEventSessionAttendeesInput,
  condition?: ModelEventSessionAttendeesConditionInput | null,
};

export type CreateEventSessionAttendeesMutation = {
  createEventSessionAttendees?:  {
    __typename: "EventSessionAttendees",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    confirmed: BoolEnum,
    confirmationTimestamp?: number | null,
    metadata?:  {
      __typename: "EventSessionAttendeeMetadata",
      paymentTimestamp?: number | null,
      stripeInvoiceId?: string | null,
      rawPaymentLog?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventSessionAttendeesMutationVariables = {
  input: UpdateEventSessionAttendeesInput,
  condition?: ModelEventSessionAttendeesConditionInput | null,
};

export type UpdateEventSessionAttendeesMutation = {
  updateEventSessionAttendees?:  {
    __typename: "EventSessionAttendees",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    confirmed: BoolEnum,
    confirmationTimestamp?: number | null,
    metadata?:  {
      __typename: "EventSessionAttendeeMetadata",
      paymentTimestamp?: number | null,
      stripeInvoiceId?: string | null,
      rawPaymentLog?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventSessionAttendeesMutationVariables = {
  input: DeleteEventSessionAttendeesInput,
  condition?: ModelEventSessionAttendeesConditionInput | null,
};

export type DeleteEventSessionAttendeesMutation = {
  deleteEventSessionAttendees?:  {
    __typename: "EventSessionAttendees",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    confirmed: BoolEnum,
    confirmationTimestamp?: number | null,
    metadata?:  {
      __typename: "EventSessionAttendeeMetadata",
      paymentTimestamp?: number | null,
      stripeInvoiceId?: string | null,
      rawPaymentLog?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type FindCoachAppointmentAvailabilityQueryVariables = {
  input: AppointmentAvailabilityInput,
};

export type FindCoachAppointmentAvailabilityQuery = {
  findCoachAppointmentAvailability?:  {
    __typename: "AppointmentAvailability",
    dates?:  Array< {
      __typename: "AppointmentAvailabilityDates",
      date?: string | null,
      times?:  Array< {
        __typename: "AppointmentAvailabilityTimes",
        time?: string | null,
        slotsAvailable?: number | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type ListUserAppointmentsByEmailQueryVariables = {
  email: string,
  expanded?: boolean | null,
  showall?: boolean | null,
  excludeForms?: boolean | null,
  canceled?: boolean | null,
  direction?: SortDirectionEnum | null,
  limit?: number | null,
  minDate?: string | null,
  maxDate?: string | null,
  phone?: string | null,
};

export type ListUserAppointmentsByEmailQuery = {
  listUserAppointmentsByEmail?: string | null,
};

export type LogEventQueryVariables = {
  eventName: string,
  message: string,
  messageAttributes?: string | null,
};

export type LogEventQuery = {
  logEvent?: string | null,
};

export type GetStripePaymentIntentQueryVariables = {
  userId: string,
  pricingId: string,
  metadata: string,
};

export type GetStripePaymentIntentQuery = {
  getStripePaymentIntent?: string | null,
};

export type AddUserToChatChannelQueryVariables = {
  members: Array< string | null >,
  channelId: string,
  channelName: string,
  defaultMessage?: string | null,
  defaultMessageFromUserId?: string | null,
};

export type AddUserToChatChannelQuery = {
  addUserToChatChannel?: string | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    lastSeen?: number | null,
    referralSource: string,
    roles: Array< RolesEnum >,
    stage?: FunnelStageEnum | null,
    plans?:  {
      __typename: "ModelUserPlanConnection",
      items:  Array< {
        __typename: "UserPlan",
        id: string,
        userId: string,
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        planPricingSlug: string,
        planPricing?:  {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate: string,
        endDate?: string | null,
        cancelled?: BoolEnum | null,
        cancellationReason?: string | null,
        createdAt: string,
        active: BoolEnum,
        metadata?:  {
          __typename: "UserPlanMetadata",
          stripeSubscriptionId?: string | null,
          stripeCustomerId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelUserAppointmentsConnection",
      items:  Array< {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    coaches?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    growthPaths?:  {
      __typename: "ModelUserGrowthPathItemConnection",
      items:  Array< {
        __typename: "UserGrowthPathItem",
        id: string,
        growthPathItemId: string,
        growthPathItem?:  {
          __typename: "GrowthPathItem",
          id: string,
          type: GrowthPathCardTypeEnum,
          title: string,
          subtitle?: string | null,
          avatarUrl?: string | null,
          description: string,
          categoryName?: string | null,
          categoryId?: string | null,
          estimatedCompletionTimeInMins?: number | null,
          actionTitle: string,
          actionDestination: string,
          actionPayload?: string | null,
          createdAt: string,
          expirationDate?: string | null,
          lessonId?: string | null,
          tags?: Array< string | null > | null,
          isArchived: BoolEnum,
          updatedAt: string,
        } | null,
        userId: string,
        order?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        dateTimeAdded: number,
        completed: BoolEnum,
        dismissed: BoolEnum,
        completedTimestamp?: number | null,
        expirationDate?: string | null,
        locked: BoolEnum,
        hidden: BoolEnum,
        isScheduled: BoolEnum,
        visibleDate: string,
        visibleTimestamp?: number | null,
        growthPathJourneyId?: string | null,
        growthPathJourneyStep?: number | null,
        growthPathJourney?:  {
          __typename: "GrowthPathJourney",
          id: string,
          title: string,
          description?: string | null,
          focusAreaId: string,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        coachId?: string | null,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        source?: UserGrowthPathItemSourceEnum | null,
        lastActivityTimestamp?: number | null,
        dependsOnGrowthPathItems?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FindUserByEmailQueryVariables = {
  email: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FindUserByEmailQuery = {
  findUserByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUsersQueryVariables = {
  filter?: SearchableUserFilterInput | null,
  sort?: Array< SearchableUserSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserAggregationInput | null > | null,
};

export type SearchUsersQuery = {
  searchUsers?:  {
    __typename: "SearchableUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUserCoachQueryVariables = {
  userId: string,
  coachId: string,
};

export type GetUserCoachQuery = {
  getUserCoach?:  {
    __typename: "UserCoach",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPrimary: BoolEnum,
    active: BoolEnum,
    coachingStartDate: string,
    coachingEndDate?: string | null,
    ratings?:  {
      __typename: "ModelUserCoachRatingConnection",
      items:  Array< {
        __typename: "UserCoachRating",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        rating: number,
        comment?: string | null,
        ratingTimestamp: number,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserCoachesQueryVariables = {
  userId?: string | null,
  coachId?: ModelIDKeyConditionInput | null,
  filter?: ModelUserCoachFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserCoachesQuery = {
  listUserCoaches?:  {
    __typename: "ModelUserCoachConnection",
    items:  Array< {
      __typename: "UserCoach",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      isPrimary: BoolEnum,
      active: BoolEnum,
      coachingStartDate: string,
      coachingEndDate?: string | null,
      ratings?:  {
        __typename: "ModelUserCoachRatingConnection",
        items:  Array< {
          __typename: "UserCoachRating",
          userId: string,
          coachId: string,
          rating: number,
          comment?: string | null,
          ratingTimestamp: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserCoachByCoachIdQueryVariables = {
  coachId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserCoachFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachByCoachIdQuery = {
  listUserCoachByCoachId?:  {
    __typename: "ModelUserCoachConnection",
    items:  Array< {
      __typename: "UserCoach",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      isPrimary: BoolEnum,
      active: BoolEnum,
      coachingStartDate: string,
      coachingEndDate?: string | null,
      ratings?:  {
        __typename: "ModelUserCoachRatingConnection",
        items:  Array< {
          __typename: "UserCoachRating",
          userId: string,
          coachId: string,
          rating: number,
          comment?: string | null,
          ratingTimestamp: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserCoachByCoachIdByStartDateQueryVariables = {
  coachId: string,
  coachingStartDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserCoachFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachByCoachIdByStartDateQuery = {
  listUserCoachByCoachIdByStartDate?:  {
    __typename: "ModelUserCoachConnection",
    items:  Array< {
      __typename: "UserCoach",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      isPrimary: BoolEnum,
      active: BoolEnum,
      coachingStartDate: string,
      coachingEndDate?: string | null,
      ratings?:  {
        __typename: "ModelUserCoachRatingConnection",
        items:  Array< {
          __typename: "UserCoachRating",
          userId: string,
          coachId: string,
          rating: number,
          comment?: string | null,
          ratingTimestamp: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserCoachByIsPrimaryQueryVariables = {
  isPrimary: BoolEnum,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserCoachFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachByIsPrimaryQuery = {
  listUserCoachByIsPrimary?:  {
    __typename: "ModelUserCoachConnection",
    items:  Array< {
      __typename: "UserCoach",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      isPrimary: BoolEnum,
      active: BoolEnum,
      coachingStartDate: string,
      coachingEndDate?: string | null,
      ratings?:  {
        __typename: "ModelUserCoachRatingConnection",
        items:  Array< {
          __typename: "UserCoachRating",
          userId: string,
          coachId: string,
          rating: number,
          comment?: string | null,
          ratingTimestamp: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserCoachRatingQueryVariables = {
  userId: string,
  coachId: string,
};

export type GetUserCoachRatingQuery = {
  getUserCoachRating?:  {
    __typename: "UserCoachRating",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    rating: number,
    comment?: string | null,
    ratingTimestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserCoachRatingsQueryVariables = {
  userId?: string | null,
  coachId?: ModelIDKeyConditionInput | null,
  filter?: ModelUserCoachRatingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserCoachRatingsQuery = {
  listUserCoachRatings?:  {
    __typename: "ModelUserCoachRatingConnection",
    items:  Array< {
      __typename: "UserCoachRating",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      rating: number,
      comment?: string | null,
      ratingTimestamp: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserCoachRatingsByCoachIdQueryVariables = {
  coachId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserCoachRatingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachRatingsByCoachIdQuery = {
  listUserCoachRatingsByCoachId?:  {
    __typename: "ModelUserCoachRatingConnection",
    items:  Array< {
      __typename: "UserCoachRating",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      rating: number,
      comment?: string | null,
      ratingTimestamp: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserCoachingNoteQueryVariables = {
  id: string,
};

export type GetUserCoachingNoteQuery = {
  getUserCoachingNote?:  {
    __typename: "UserCoachingNote",
    id: string,
    userId: string,
    coachId: string,
    appointmentId?: string | null,
    appointment?:  {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null,
    note: string,
    visibleToUser: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserCoachingNotesQueryVariables = {
  filter?: ModelUserCoachingNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachingNotesQuery = {
  listUserCoachingNotes?:  {
    __typename: "ModelUserCoachingNoteConnection",
    items:  Array< {
      __typename: "UserCoachingNote",
      id: string,
      userId: string,
      coachId: string,
      appointmentId?: string | null,
      appointment?:  {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null,
      note: string,
      visibleToUser: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserCoachingNotesByUserIdByCreatedDateQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserCoachingNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachingNotesByUserIdByCreatedDateQuery = {
  listUserCoachingNotesByUserIdByCreatedDate?:  {
    __typename: "ModelUserCoachingNoteConnection",
    items:  Array< {
      __typename: "UserCoachingNote",
      id: string,
      userId: string,
      coachId: string,
      appointmentId?: string | null,
      appointment?:  {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null,
      note: string,
      visibleToUser: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserStatsQueryVariables = {
  userId: string,
};

export type GetUserStatsQuery = {
  getUserStats?:  {
    __typename: "UserStats",
    userId: string,
    totalHabitLogged?: number | null,
    totalAppointmentsScheduled?: number | null,
    totalLessonsWatched?: number | null,
    totalLogins?: number | null,
    totalMessages?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserStatsQueryVariables = {
  userId?: string | null,
  filter?: ModelUserStatsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserStatsQuery = {
  listUserStats?:  {
    __typename: "ModelUserStatsConnection",
    items:  Array< {
      __typename: "UserStats",
      userId: string,
      totalHabitLogged?: number | null,
      totalAppointmentsScheduled?: number | null,
      totalLessonsWatched?: number | null,
      totalLogins?: number | null,
      totalMessages?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserActivityLogQueryVariables = {
  id: string,
};

export type GetUserActivityLogQuery = {
  getUserActivityLog?:  {
    __typename: "UserActivityLog",
    id: string,
    type: UserActivitiesEnum,
    source: ActivitySourceEnum,
    payload?: string | null,
    timestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserActivityLogsQueryVariables = {
  filter?: ModelUserActivityLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserActivityLogsQuery = {
  listUserActivityLogs?:  {
    __typename: "ModelUserActivityLogConnection",
    items:  Array< {
      __typename: "UserActivityLog",
      id: string,
      type: UserActivitiesEnum,
      source: ActivitySourceEnum,
      payload?: string | null,
      timestamp: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserActivityLogByTypeByTimestampQueryVariables = {
  type: UserActivitiesEnum,
  timestamp?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserActivityLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserActivityLogByTypeByTimestampQuery = {
  listUserActivityLogByTypeByTimestamp?:  {
    __typename: "ModelUserActivityLogConnection",
    items:  Array< {
      __typename: "UserActivityLog",
      id: string,
      type: UserActivitiesEnum,
      source: ActivitySourceEnum,
      payload?: string | null,
      timestamp: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetJournalEntryTemplatesQueryVariables = {
  id: string,
  createdAt: string,
};

export type GetJournalEntryTemplatesQuery = {
  getJournalEntryTemplates?:  {
    __typename: "JournalEntryTemplates",
    id: string,
    name: string,
    description?: string | null,
    templateText: string,
    templateBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListJournalEntryTemplatesQueryVariables = {
  id?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelJournalEntryTemplatesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListJournalEntryTemplatesQuery = {
  listJournalEntryTemplates?:  {
    __typename: "ModelJournalEntryTemplatesConnection",
    items:  Array< {
      __typename: "JournalEntryTemplates",
      id: string,
      name: string,
      description?: string | null,
      templateText: string,
      templateBlocks:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserJournalEntryLogQueryVariables = {
  userId: string,
  createdAt: string,
};

export type GetUserJournalEntryLogQuery = {
  getUserJournalEntryLog?:  {
    __typename: "UserJournalEntryLog",
    userId: string,
    entryTitle: string,
    entryLogType: JournalEntryLogTypeEnum,
    entryLogTags?:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } > | null,
    isVisibleToCoach: BoolEnum,
    isVisibleToPublic: BoolEnum,
    entryText: string,
    entryBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    journalEntryTemplateId?: string | null,
    rawEntry?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserJournalEntryLogsQueryVariables = {
  userId?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelUserJournalEntryLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserJournalEntryLogsQuery = {
  listUserJournalEntryLogs?:  {
    __typename: "ModelUserJournalEntryLogConnection",
    items:  Array< {
      __typename: "UserJournalEntryLog",
      userId: string,
      entryTitle: string,
      entryLogType: JournalEntryLogTypeEnum,
      entryLogTags?:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } > | null,
      isVisibleToCoach: BoolEnum,
      isVisibleToPublic: BoolEnum,
      entryText: string,
      entryBlocks:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } >,
      journalEntryTemplateId?: string | null,
      rawEntry?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserJournalEntryLogsByLogTypeByCreatedAtQueryVariables = {
  entryLogType: JournalEntryLogTypeEnum,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserJournalEntryLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserJournalEntryLogsByLogTypeByCreatedAtQuery = {
  listUserJournalEntryLogsByLogTypeByCreatedAt?:  {
    __typename: "ModelUserJournalEntryLogConnection",
    items:  Array< {
      __typename: "UserJournalEntryLog",
      userId: string,
      entryTitle: string,
      entryLogType: JournalEntryLogTypeEnum,
      entryLogTags?:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } > | null,
      isVisibleToCoach: BoolEnum,
      isVisibleToPublic: BoolEnum,
      entryText: string,
      entryBlocks:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } >,
      journalEntryTemplateId?: string | null,
      rawEntry?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListJournalEntryLogByUserIdByDateQueryVariables = {
  entryLogType: JournalEntryLogTypeEnum,
  userIdCreatedAt?: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserJournalEntryLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJournalEntryLogByUserIdByDateQuery = {
  listJournalEntryLogByUserIdByDate?:  {
    __typename: "ModelUserJournalEntryLogConnection",
    items:  Array< {
      __typename: "UserJournalEntryLog",
      userId: string,
      entryTitle: string,
      entryLogType: JournalEntryLogTypeEnum,
      entryLogTags?:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } > | null,
      isVisibleToCoach: BoolEnum,
      isVisibleToPublic: BoolEnum,
      entryText: string,
      entryBlocks:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } >,
      journalEntryTemplateId?: string | null,
      rawEntry?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUserJournalEntryLogsQueryVariables = {
  filter?: SearchableUserJournalEntryLogFilterInput | null,
  sort?: Array< SearchableUserJournalEntryLogSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserJournalEntryLogAggregationInput | null > | null,
};

export type SearchUserJournalEntryLogsQuery = {
  searchUserJournalEntryLogs?:  {
    __typename: "SearchableUserJournalEntryLogConnection",
    items:  Array< {
      __typename: "UserJournalEntryLog",
      userId: string,
      entryTitle: string,
      entryLogType: JournalEntryLogTypeEnum,
      entryLogTags?:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } > | null,
      isVisibleToCoach: BoolEnum,
      isVisibleToPublic: BoolEnum,
      entryText: string,
      entryBlocks:  Array< {
        __typename: "LabelValueOptionType",
        label: string,
        value: string,
      } >,
      journalEntryTemplateId?: string | null,
      rawEntry?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUserPlanQueryVariables = {
  id: string,
};

export type GetUserPlanQuery = {
  getUserPlan?:  {
    __typename: "UserPlan",
    id: string,
    userId: string,
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planPricingSlug: string,
    planPricing?:  {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    cancelled?: BoolEnum | null,
    cancellationReason?: string | null,
    createdAt: string,
    active: BoolEnum,
    metadata?:  {
      __typename: "UserPlanMetadata",
      stripeSubscriptionId?: string | null,
      stripeCustomerId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListUserPlansQueryVariables = {
  filter?: ModelUserPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserPlansQuery = {
  listUserPlans?:  {
    __typename: "ModelUserPlanConnection",
    items:  Array< {
      __typename: "UserPlan",
      id: string,
      userId: string,
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      planPricingSlug: string,
      planPricing?:  {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate: string,
      endDate?: string | null,
      cancelled?: BoolEnum | null,
      cancellationReason?: string | null,
      createdAt: string,
      active: BoolEnum,
      metadata?:  {
        __typename: "UserPlanMetadata",
        stripeSubscriptionId?: string | null,
        stripeCustomerId?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserPlansByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserPlansByUserIdQuery = {
  listUserPlansByUserId?:  {
    __typename: "ModelUserPlanConnection",
    items:  Array< {
      __typename: "UserPlan",
      id: string,
      userId: string,
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      planPricingSlug: string,
      planPricing?:  {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate: string,
      endDate?: string | null,
      cancelled?: BoolEnum | null,
      cancellationReason?: string | null,
      createdAt: string,
      active: BoolEnum,
      metadata?:  {
        __typename: "UserPlanMetadata",
        stripeSubscriptionId?: string | null,
        stripeCustomerId?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserCoachingCreditsQueryVariables = {
  userId: string,
  yearMonth: number,
};

export type GetUserCoachingCreditsQuery = {
  getUserCoachingCredits?:  {
    __typename: "UserCoachingCredits",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    yearMonth: number,
    creditsAwarded: number,
    creditsRemaining: number,
    lastUsedTimestamp?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserCoachingCreditsQueryVariables = {
  userId?: string | null,
  yearMonth?: ModelIntKeyConditionInput | null,
  filter?: ModelUserCoachingCreditsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserCoachingCreditsQuery = {
  listUserCoachingCredits?:  {
    __typename: "ModelUserCoachingCreditsConnection",
    items:  Array< {
      __typename: "UserCoachingCredits",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      yearMonth: number,
      creditsAwarded: number,
      creditsRemaining: number,
      lastUsedTimestamp?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserCoachingCreditUsageLogQueryVariables = {
  id: string,
};

export type GetUserCoachingCreditUsageLogQuery = {
  getUserCoachingCreditUsageLog?:  {
    __typename: "UserCoachingCreditUsageLog",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    memo: string,
    timestamp: number,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserCoachingCreditUsageLogsQueryVariables = {
  filter?: ModelUserCoachingCreditUsageLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachingCreditUsageLogsQuery = {
  listUserCoachingCreditUsageLogs?:  {
    __typename: "ModelUserCoachingCreditUsageLogConnection",
    items:  Array< {
      __typename: "UserCoachingCreditUsageLog",
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      memo: string,
      timestamp: number,
      id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserFocusAreaQueryVariables = {
  id: string,
};

export type GetUserFocusAreaQuery = {
  getUserFocusArea?:  {
    __typename: "UserFocusArea",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    completed: BoolEnum,
    dateCompleted?: number | null,
    userFocusAreaGoals?:  {
      __typename: "ModelUserFocusAreaGoalsConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoals",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userFocusAreaGoalHabits?:  {
          __typename: "ModelUserFocusAreaGoalHabitConnection",
          nextToken?: string | null,
        } | null,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserFocusAreasQueryVariables = {
  filter?: ModelUserFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreasQuery = {
  listUserFocusAreas?:  {
    __typename: "ModelUserFocusAreaConnection",
    items:  Array< {
      __typename: "UserFocusArea",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate: string,
      endDate?: string | null,
      completed: BoolEnum,
      dateCompleted?: number | null,
      userFocusAreaGoals?:  {
        __typename: "ModelUserFocusAreaGoalsConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoals",
          id: string,
          userId: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          completed?: BoolEnum | null,
          dateCompleted?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreasByUserIdQueryVariables = {
  userId: string,
  startDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreasByUserIdQuery = {
  listUserFocusAreasByUserId?:  {
    __typename: "ModelUserFocusAreaConnection",
    items:  Array< {
      __typename: "UserFocusArea",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate: string,
      endDate?: string | null,
      completed: BoolEnum,
      dateCompleted?: number | null,
      userFocusAreaGoals?:  {
        __typename: "ModelUserFocusAreaGoalsConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoals",
          id: string,
          userId: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          completed?: BoolEnum | null,
          dateCompleted?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreasByFocusAreaIdQueryVariables = {
  focusAreaId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreasByFocusAreaIdQuery = {
  listUserFocusAreasByFocusAreaId?:  {
    __typename: "ModelUserFocusAreaConnection",
    items:  Array< {
      __typename: "UserFocusArea",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate: string,
      endDate?: string | null,
      completed: BoolEnum,
      dateCompleted?: number | null,
      userFocusAreaGoals?:  {
        __typename: "ModelUserFocusAreaGoalsConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoals",
          id: string,
          userId: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          completed?: BoolEnum | null,
          dateCompleted?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserFocusAreaGoalsQueryVariables = {
  id: string,
};

export type GetUserFocusAreaGoalsQuery = {
  getUserFocusAreaGoals?:  {
    __typename: "UserFocusAreaGoals",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userFocusAreaGoalHabits?:  {
      __typename: "ModelUserFocusAreaGoalHabitConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabit",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitId: string,
        focusAreaGoalHabit?:  {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitLog?:  {
          __typename: "ModelUserFocusAreaGoalHabitLogConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserFocusAreaGoalsQueryVariables = {
  filter?: ModelUserFocusAreaGoalsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalsQuery = {
  listUserFocusAreaGoals?:  {
    __typename: "ModelUserFocusAreaGoalsConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoals",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      userFocusAreaGoalHabits?:  {
        __typename: "ModelUserFocusAreaGoalHabitConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoalHabit",
          id: string,
          userId: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          focusAreaGoalHabitId: string,
          createdAt: string,
          completed?: BoolEnum | null,
          dateCompleted?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      completed?: BoolEnum | null,
      dateCompleted?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreaGoalsByUserIdByFocusAreaIdQueryVariables = {
  userId: string,
  focusAreaId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaGoalsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalsByUserIdByFocusAreaIdQuery = {
  listUserFocusAreaGoalsByUserIdByFocusAreaId?:  {
    __typename: "ModelUserFocusAreaGoalsConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoals",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      userFocusAreaGoalHabits?:  {
        __typename: "ModelUserFocusAreaGoalHabitConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoalHabit",
          id: string,
          userId: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          focusAreaGoalHabitId: string,
          createdAt: string,
          completed?: BoolEnum | null,
          dateCompleted?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      completed?: BoolEnum | null,
      dateCompleted?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreaGoalsByfocusAreaIdQueryVariables = {
  focusAreaId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaGoalsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalsByfocusAreaIdQuery = {
  listUserFocusAreaGoalsByfocusAreaId?:  {
    __typename: "ModelUserFocusAreaGoalsConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoals",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      userFocusAreaGoalHabits?:  {
        __typename: "ModelUserFocusAreaGoalHabitConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoalHabit",
          id: string,
          userId: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          focusAreaGoalHabitId: string,
          createdAt: string,
          completed?: BoolEnum | null,
          dateCompleted?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      completed?: BoolEnum | null,
      dateCompleted?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserFocusAreaGoalHabitQueryVariables = {
  id: string,
};

export type GetUserFocusAreaGoalHabitQuery = {
  getUserFocusAreaGoalHabit?:  {
    __typename: "UserFocusAreaGoalHabit",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitId: string,
    focusAreaGoalHabit?:  {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitLog?:  {
      __typename: "ModelUserFocusAreaGoalHabitLogConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabitLog",
        id: string,
        userId: string,
        userFocusAreaGoalHabitId: string,
        year: number,
        month: number,
        week: number,
        day: number,
        note?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    updatedAt: string,
  } | null,
};

export type ListUserFocusAreaGoalHabitsQueryVariables = {
  filter?: ModelUserFocusAreaGoalHabitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalHabitsQuery = {
  listUserFocusAreaGoalHabits?:  {
    __typename: "ModelUserFocusAreaGoalHabitConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoalHabit",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitId: string,
      focusAreaGoalHabit?:  {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitLog?:  {
        __typename: "ModelUserFocusAreaGoalHabitLogConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoalHabitLog",
          id: string,
          userId: string,
          userFocusAreaGoalHabitId: string,
          year: number,
          month: number,
          week: number,
          day: number,
          note?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      completed?: BoolEnum | null,
      dateCompleted?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreaGoalHabitByUserIdByFocusAreaGoalIdQueryVariables = {
  userId: string,
  focusAreaIdFocusAreaGoalId?: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaGoalHabitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalHabitByUserIdByFocusAreaGoalIdQuery = {
  listUserFocusAreaGoalHabitByUserIdByFocusAreaGoalId?:  {
    __typename: "ModelUserFocusAreaGoalHabitConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoalHabit",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitId: string,
      focusAreaGoalHabit?:  {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitLog?:  {
        __typename: "ModelUserFocusAreaGoalHabitLogConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoalHabitLog",
          id: string,
          userId: string,
          userFocusAreaGoalHabitId: string,
          year: number,
          month: number,
          week: number,
          day: number,
          note?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      completed?: BoolEnum | null,
      dateCompleted?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreaGoalHabitByFocusAreaIdQueryVariables = {
  focusAreaGoalId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaGoalHabitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalHabitByFocusAreaIdQuery = {
  listUserFocusAreaGoalHabitByFocusAreaId?:  {
    __typename: "ModelUserFocusAreaGoalHabitConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoalHabit",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitId: string,
      focusAreaGoalHabit?:  {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitLog?:  {
        __typename: "ModelUserFocusAreaGoalHabitLogConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoalHabitLog",
          id: string,
          userId: string,
          userFocusAreaGoalHabitId: string,
          year: number,
          month: number,
          week: number,
          day: number,
          note?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      completed?: BoolEnum | null,
      dateCompleted?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreaGoalHabitByFocusAreaGoalHabitIdQueryVariables = {
  focusAreaGoalHabitId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaGoalHabitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalHabitByFocusAreaGoalHabitIdQuery = {
  listUserFocusAreaGoalHabitByFocusAreaGoalHabitId?:  {
    __typename: "ModelUserFocusAreaGoalHabitConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoalHabit",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitId: string,
      focusAreaGoalHabit?:  {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabitLog?:  {
        __typename: "ModelUserFocusAreaGoalHabitLogConnection",
        items:  Array< {
          __typename: "UserFocusAreaGoalHabitLog",
          id: string,
          userId: string,
          userFocusAreaGoalHabitId: string,
          year: number,
          month: number,
          week: number,
          day: number,
          note?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      completed?: BoolEnum | null,
      dateCompleted?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserFocusAreaGoalHabitLogQueryVariables = {
  id: string,
};

export type GetUserFocusAreaGoalHabitLogQuery = {
  getUserFocusAreaGoalHabitLog?:  {
    __typename: "UserFocusAreaGoalHabitLog",
    id: string,
    userId: string,
    userFocusAreaGoalHabitId: string,
    year: number,
    month: number,
    week: number,
    day: number,
    note?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserFocusAreaGoalHabitLogsQueryVariables = {
  filter?: ModelUserFocusAreaGoalHabitLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalHabitLogsQuery = {
  listUserFocusAreaGoalHabitLogs?:  {
    __typename: "ModelUserFocusAreaGoalHabitLogConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoalHabitLog",
      id: string,
      userId: string,
      userFocusAreaGoalHabitId: string,
      year: number,
      month: number,
      week: number,
      day: number,
      note?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdQueryVariables = {
  userFocusAreaGoalHabitId: string,
  yearWeekMonthDay?: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFocusAreaGoalHabitLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdQuery = {
  listUserFocusAreaGoalHabitLogByUserFocusAreaHabitId?:  {
    __typename: "ModelUserFocusAreaGoalHabitLogConnection",
    items:  Array< {
      __typename: "UserFocusAreaGoalHabitLog",
      id: string,
      userId: string,
      userFocusAreaGoalHabitId: string,
      year: number,
      month: number,
      week: number,
      day: number,
      note?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserAssessmentLogQueryVariables = {
  id: string,
};

export type GetUserAssessmentLogQuery = {
  getUserAssessmentLog?:  {
    __typename: "UserAssessmentLog",
    id: string,
    createdAt: string,
    userId: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    assessment: string,
    score: number,
    maxScore: number,
    userNotified: boolean,
    coachReviewed: BoolEnum,
    updatedAt: string,
  } | null,
};

export type ListUserAssessmentLogsQueryVariables = {
  filter?: ModelUserAssessmentLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserAssessmentLogsQuery = {
  listUserAssessmentLogs?:  {
    __typename: "ModelUserAssessmentLogConnection",
    items:  Array< {
      __typename: "UserAssessmentLog",
      id: string,
      createdAt: string,
      userId: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      assessment: string,
      score: number,
      maxScore: number,
      userNotified: boolean,
      coachReviewed: BoolEnum,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserAssessmentLogByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserAssessmentLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserAssessmentLogByUserIdQuery = {
  listUserAssessmentLogByUserId?:  {
    __typename: "ModelUserAssessmentLogConnection",
    items:  Array< {
      __typename: "UserAssessmentLog",
      id: string,
      createdAt: string,
      userId: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      assessment: string,
      score: number,
      maxScore: number,
      userNotified: boolean,
      coachReviewed: BoolEnum,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserLessonsQueryVariables = {
  id: string,
};

export type GetUserLessonsQuery = {
  getUserLessons?:  {
    __typename: "UserLessons",
    id: string,
    userId: string,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    startTimestamp?: number | null,
    completedTimestamp?: number | null,
    lastViewedTimestamp?: number | null,
    completed: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserLessonsQueryVariables = {
  filter?: ModelUserLessonsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserLessonsQuery = {
  listUserLessons?:  {
    __typename: "ModelUserLessonsConnection",
    items:  Array< {
      __typename: "UserLessons",
      id: string,
      userId: string,
      lessonId: string,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      startTimestamp?: number | null,
      completedTimestamp?: number | null,
      lastViewedTimestamp?: number | null,
      completed: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserLessonsByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserLessonsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserLessonsByUserIdQuery = {
  listUserLessonsByUserId?:  {
    __typename: "ModelUserLessonsConnection",
    items:  Array< {
      __typename: "UserLessons",
      id: string,
      userId: string,
      lessonId: string,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      startTimestamp?: number | null,
      completedTimestamp?: number | null,
      lastViewedTimestamp?: number | null,
      completed: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserLessonsByLessonIdQueryVariables = {
  lessonId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserLessonsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserLessonsByLessonIdQuery = {
  listUserLessonsByLessonId?:  {
    __typename: "ModelUserLessonsConnection",
    items:  Array< {
      __typename: "UserLessons",
      id: string,
      userId: string,
      lessonId: string,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      startTimestamp?: number | null,
      completedTimestamp?: number | null,
      lastViewedTimestamp?: number | null,
      completed: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserLessonsByLessonIdByUserByCreatedAtQueryVariables = {
  lessonId: string,
  userIdCreatedAt?: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserLessonsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserLessonsByLessonIdByUserByCreatedAtQuery = {
  listUserLessonsByLessonIdByUserByCreatedAt?:  {
    __typename: "ModelUserLessonsConnection",
    items:  Array< {
      __typename: "UserLessons",
      id: string,
      userId: string,
      lessonId: string,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      startTimestamp?: number | null,
      completedTimestamp?: number | null,
      lastViewedTimestamp?: number | null,
      completed: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserGrowthPathItemQueryVariables = {
  id: string,
};

export type GetUserGrowthPathItemQuery = {
  getUserGrowthPathItem?:  {
    __typename: "UserGrowthPathItem",
    id: string,
    growthPathItemId: string,
    growthPathItem?:  {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null,
    userId: string,
    order?: number | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    dateTimeAdded: number,
    completed: BoolEnum,
    dismissed: BoolEnum,
    completedTimestamp?: number | null,
    expirationDate?: string | null,
    locked: BoolEnum,
    hidden: BoolEnum,
    isScheduled: BoolEnum,
    visibleDate: string,
    visibleTimestamp?: number | null,
    growthPathJourneyId?: string | null,
    growthPathJourneyStep?: number | null,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    coachId?: string | null,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    source?: UserGrowthPathItemSourceEnum | null,
    lastActivityTimestamp?: number | null,
    dependsOnGrowthPathItems?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserGrowthPathItemsQueryVariables = {
  filter?: ModelUserGrowthPathItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserGrowthPathItemsQuery = {
  listUserGrowthPathItems?:  {
    __typename: "ModelUserGrowthPathItemConnection",
    items:  Array< {
      __typename: "UserGrowthPathItem",
      id: string,
      growthPathItemId: string,
      growthPathItem?:  {
        __typename: "GrowthPathItem",
        id: string,
        type: GrowthPathCardTypeEnum,
        title: string,
        subtitle?: string | null,
        avatarUrl?: string | null,
        description: string,
        categoryName?: string | null,
        categoryId?: string | null,
        estimatedCompletionTimeInMins?: number | null,
        actionTitle: string,
        actionDestination: string,
        actionPayload?: string | null,
        createdAt: string,
        expirationDate?: string | null,
        lessonId?: string | null,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        tags?: Array< string | null > | null,
        isArchived: BoolEnum,
        updatedAt: string,
      } | null,
      userId: string,
      order?: number | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      dateTimeAdded: number,
      completed: BoolEnum,
      dismissed: BoolEnum,
      completedTimestamp?: number | null,
      expirationDate?: string | null,
      locked: BoolEnum,
      hidden: BoolEnum,
      isScheduled: BoolEnum,
      visibleDate: string,
      visibleTimestamp?: number | null,
      growthPathJourneyId?: string | null,
      growthPathJourneyStep?: number | null,
      growthPathJourney?:  {
        __typename: "GrowthPathJourney",
        id: string,
        title: string,
        description?: string | null,
        growthPathItems:  Array< {
          __typename: "GrowthPathJourneyGrowthPathItem",
          step: number,
          growthPathItemId: string,
        } >,
        focusAreaId: string,
        focusArea:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      coachId?: string | null,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      source?: UserGrowthPathItemSourceEnum | null,
      lastActivityTimestamp?: number | null,
      dependsOnGrowthPathItems?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthPathsByUserIdQueryVariables = {
  userId: string,
  dateTimeAdded?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserGrowthPathItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGrowthPathsByUserIdQuery = {
  listGrowthPathsByUserId?:  {
    __typename: "ModelUserGrowthPathItemConnection",
    items:  Array< {
      __typename: "UserGrowthPathItem",
      id: string,
      growthPathItemId: string,
      growthPathItem?:  {
        __typename: "GrowthPathItem",
        id: string,
        type: GrowthPathCardTypeEnum,
        title: string,
        subtitle?: string | null,
        avatarUrl?: string | null,
        description: string,
        categoryName?: string | null,
        categoryId?: string | null,
        estimatedCompletionTimeInMins?: number | null,
        actionTitle: string,
        actionDestination: string,
        actionPayload?: string | null,
        createdAt: string,
        expirationDate?: string | null,
        lessonId?: string | null,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        tags?: Array< string | null > | null,
        isArchived: BoolEnum,
        updatedAt: string,
      } | null,
      userId: string,
      order?: number | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      dateTimeAdded: number,
      completed: BoolEnum,
      dismissed: BoolEnum,
      completedTimestamp?: number | null,
      expirationDate?: string | null,
      locked: BoolEnum,
      hidden: BoolEnum,
      isScheduled: BoolEnum,
      visibleDate: string,
      visibleTimestamp?: number | null,
      growthPathJourneyId?: string | null,
      growthPathJourneyStep?: number | null,
      growthPathJourney?:  {
        __typename: "GrowthPathJourney",
        id: string,
        title: string,
        description?: string | null,
        growthPathItems:  Array< {
          __typename: "GrowthPathJourneyGrowthPathItem",
          step: number,
          growthPathItemId: string,
        } >,
        focusAreaId: string,
        focusArea:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      coachId?: string | null,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      source?: UserGrowthPathItemSourceEnum | null,
      lastActivityTimestamp?: number | null,
      dependsOnGrowthPathItems?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserGrowthPathJourneyQueryVariables = {
  id: string,
};

export type GetUserGrowthPathJourneyQuery = {
  getUserGrowthPathJourney?:  {
    __typename: "UserGrowthPathJourney",
    userId: string,
    growthPathJourneyId: string,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    completionLog?:  Array< {
      __typename: "UserGrowthPathJourneyCompletionLog",
      growthPathItemId: string,
      completionTimestamp: number,
    } > | null,
    lastActivityTimestamp: number,
    active: BoolEnum,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserGrowthPathJourneysQueryVariables = {
  filter?: ModelUserGrowthPathJourneyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserGrowthPathJourneysQuery = {
  listUserGrowthPathJourneys?:  {
    __typename: "ModelUserGrowthPathJourneyConnection",
    items:  Array< {
      __typename: "UserGrowthPathJourney",
      userId: string,
      growthPathJourneyId: string,
      growthPathJourney?:  {
        __typename: "GrowthPathJourney",
        id: string,
        title: string,
        description?: string | null,
        growthPathItems:  Array< {
          __typename: "GrowthPathJourneyGrowthPathItem",
          step: number,
          growthPathItemId: string,
        } >,
        focusAreaId: string,
        focusArea:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      completionLog?:  Array< {
        __typename: "UserGrowthPathJourneyCompletionLog",
        growthPathItemId: string,
        completionTimestamp: number,
      } > | null,
      lastActivityTimestamp: number,
      active: BoolEnum,
      id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetGrowthPathJourneyQueryVariables = {
  id: string,
};

export type GetGrowthPathJourneyQuery = {
  getGrowthPathJourney?:  {
    __typename: "GrowthPathJourney",
    id: string,
    title: string,
    description?: string | null,
    growthPathItems:  Array< {
      __typename: "GrowthPathJourneyGrowthPathItem",
      step: number,
      growthPathItemId: string,
      rules?:  Array< {
        __typename: "GrowthPathItemDependencies",
        ruleType: DependencyTypeEnum,
        dependencyGrowthPathItemId: string,
        scheduleDaysFromNow?: number | null,
      } > | null,
    } >,
    focusAreaId: string,
    focusArea:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListGrowthPathJourneysQueryVariables = {
  filter?: ModelGrowthPathJourneyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGrowthPathJourneysQuery = {
  listGrowthPathJourneys?:  {
    __typename: "ModelGrowthPathJourneyConnection",
    items:  Array< {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthPathJourneyByFocusAreaIdQueryVariables = {
  focusAreaId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGrowthPathJourneyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGrowthPathJourneyByFocusAreaIdQuery = {
  listGrowthPathJourneyByFocusAreaId?:  {
    __typename: "ModelGrowthPathJourneyConnection",
    items:  Array< {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthPathJourneyByFocusAreaByActiveQueryVariables = {
  focusAreaId: string,
  active?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGrowthPathJourneyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGrowthPathJourneyByFocusAreaByActiveQuery = {
  listGrowthPathJourneyByFocusAreaByActive?:  {
    __typename: "ModelGrowthPathJourneyConnection",
    items:  Array< {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserAppointmentsQueryVariables = {
  id: string,
};

export type GetUserAppointmentsQuery = {
  getUserAppointments?:  {
    __typename: "UserAppointments",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointmentStartTime: number,
    appointmentEndTime: number,
    appointmentDurationMins: number,
    appointmentTimezone: string,
    appointmentType: AppointmentTypeEnum,
    cancelled?: BoolEnum | null,
    cancelDate?: number | null,
    cancelReason?: string | null,
    cancelNote?: string | null,
    metadata:  {
      __typename: "UserAppointementMetadata",
      acuityAppointmentId?: string | null,
      acuityAppointmentTypeId?: string | null,
      acuityConfirmationPageUrl?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserAppointmentsQueryVariables = {
  filter?: ModelUserAppointmentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserAppointmentsQuery = {
  listUserAppointments?:  {
    __typename: "ModelUserAppointmentsConnection",
    items:  Array< {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserAppointmentsByUserIdQueryVariables = {
  userId: string,
  appointmentStartTime?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserAppointmentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserAppointmentsByUserIdQuery = {
  listUserAppointmentsByUserId?:  {
    __typename: "ModelUserAppointmentsConnection",
    items:  Array< {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAllUserAppointementsByCoachIdQueryVariables = {
  coachId: string,
  appointmentStartTime?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserAppointmentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAllUserAppointementsByCoachIdQuery = {
  listAllUserAppointementsByCoachId?:  {
    __typename: "ModelUserAppointmentsConnection",
    items:  Array< {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserNotificationQueryVariables = {
  id: string,
};

export type GetUserNotificationQuery = {
  getUserNotification?:  {
    __typename: "UserNotification",
    id: string,
    userId: string,
    notificationType: UserNotificationTypeEnum,
    notificationMessage: string,
    notificationTitle: string,
    notificationExpirationDate?: string | null,
    notificationRead: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserNotificationsQueryVariables = {
  filter?: ModelUserNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserNotificationsQuery = {
  listUserNotifications?:  {
    __typename: "ModelUserNotificationConnection",
    items:  Array< {
      __typename: "UserNotification",
      id: string,
      userId: string,
      notificationType: UserNotificationTypeEnum,
      notificationMessage: string,
      notificationTitle: string,
      notificationExpirationDate?: string | null,
      notificationRead: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserNotificationsByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserNotificationsByUserIdQuery = {
  listUserNotificationsByUserId?:  {
    __typename: "ModelUserNotificationConnection",
    items:  Array< {
      __typename: "UserNotification",
      id: string,
      userId: string,
      notificationType: UserNotificationTypeEnum,
      notificationMessage: string,
      notificationTitle: string,
      notificationExpirationDate?: string | null,
      notificationRead: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserNotificationsByTypeByUserByCreatedAtQueryVariables = {
  notificationType: UserNotificationTypeEnum,
  userIdCreatedAt?: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserNotificationsByTypeByUserByCreatedAtQuery = {
  listUserNotificationsByTypeByUserByCreatedAt?:  {
    __typename: "ModelUserNotificationConnection",
    items:  Array< {
      __typename: "UserNotification",
      id: string,
      userId: string,
      notificationType: UserNotificationTypeEnum,
      notificationMessage: string,
      notificationTitle: string,
      notificationExpirationDate?: string | null,
      notificationRead: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCoachQueryVariables = {
  id: string,
};

export type GetCoachQuery = {
  getCoach?:  {
    __typename: "Coach",
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    title?: string | null,
    coachType?: Array< CoachTypeEnum | null > | null,
    avatarUrl?: string | null,
    description?: string | null,
    metadata?:  {
      __typename: "CoachMetaData",
      introVideoUrl?: string | null,
      gcalId?: string | null,
      calendlyId?: string | null,
      acuityCalendarId?: string | null,
      acuityUserId?: string | null,
      acuityKey?: string | null,
      acuityIssAppointmentId?: string | null,
      acuityRegularAppointmentId?: string | null,
      streamChatId?: string | null,
      slackId?: string | null,
      lastCoachNote?: number | null,
      lastChatMessage?: number | null,
    } | null,
    focusAreas?:  {
      __typename: "ModelCoachFocusAreaConnection",
      items:  Array< {
        __typename: "CoachFocusArea",
        id: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    members?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCoachesQueryVariables = {
  filter?: ModelCoachFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoachesQuery = {
  listCoaches?:  {
    __typename: "ModelCoachConnection",
    items:  Array< {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FindCoachByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCoachFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FindCoachByEmailQuery = {
  findCoachByEmail?:  {
    __typename: "ModelCoachConnection",
    items:  Array< {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserCoachByActiveQueryVariables = {
  active: BoolEnum,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCoachFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCoachByActiveQuery = {
  listUserCoachByActive?:  {
    __typename: "ModelCoachConnection",
    items:  Array< {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCoachFocusAreaQueryVariables = {
  id: string,
};

export type GetCoachFocusAreaQuery = {
  getCoachFocusArea?:  {
    __typename: "CoachFocusArea",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCoachFocusAreasQueryVariables = {
  filter?: ModelCoachFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoachFocusAreasQuery = {
  listCoachFocusAreas?:  {
    __typename: "ModelCoachFocusAreaConnection",
    items:  Array< {
      __typename: "CoachFocusArea",
      id: string,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCoachFocusAreasByCoachIdQueryVariables = {
  coachId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCoachFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoachFocusAreasByCoachIdQuery = {
  listCoachFocusAreasByCoachId?:  {
    __typename: "ModelCoachFocusAreaConnection",
    items:  Array< {
      __typename: "CoachFocusArea",
      id: string,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCoachFocusAreasByFocusAreaIdQueryVariables = {
  focusAreaId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCoachFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoachFocusAreasByFocusAreaIdQuery = {
  listCoachFocusAreasByFocusAreaId?:  {
    __typename: "ModelCoachFocusAreaConnection",
    items:  Array< {
      __typename: "CoachFocusArea",
      id: string,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCoachUserNotificationQueryVariables = {
  id: string,
};

export type GetCoachUserNotificationQuery = {
  getCoachUserNotification?:  {
    __typename: "CoachUserNotification",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    title: string,
    read: BoolEnum,
    readTimestamp?: number | null,
    notificationType: CoachNotificationTypeEnum,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCoachUserNotificationsQueryVariables = {
  filter?: ModelCoachUserNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoachUserNotificationsQuery = {
  listCoachUserNotifications?:  {
    __typename: "ModelCoachUserNotificationConnection",
    items:  Array< {
      __typename: "CoachUserNotification",
      id: string,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      title: string,
      read: BoolEnum,
      readTimestamp?: number | null,
      notificationType: CoachNotificationTypeEnum,
      rawPayload?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCoachUserNotificationsByCoachIdQueryVariables = {
  coachId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCoachUserNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoachUserNotificationsByCoachIdQuery = {
  listCoachUserNotificationsByCoachId?:  {
    __typename: "ModelCoachUserNotificationConnection",
    items:  Array< {
      __typename: "CoachUserNotification",
      id: string,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      title: string,
      read: BoolEnum,
      readTimestamp?: number | null,
      notificationType: CoachNotificationTypeEnum,
      rawPayload?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCoachUserNotificationsByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCoachUserNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoachUserNotificationsByUserIdQuery = {
  listCoachUserNotificationsByUserId?:  {
    __typename: "ModelCoachUserNotificationConnection",
    items:  Array< {
      __typename: "CoachUserNotification",
      id: string,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      title: string,
      read: BoolEnum,
      readTimestamp?: number | null,
      notificationType: CoachNotificationTypeEnum,
      rawPayload?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetGrowthPathItemQueryVariables = {
  id: string,
};

export type GetGrowthPathItemQuery = {
  getGrowthPathItem?:  {
    __typename: "GrowthPathItem",
    id: string,
    type: GrowthPathCardTypeEnum,
    title: string,
    subtitle?: string | null,
    avatarUrl?: string | null,
    description: string,
    categoryName?: string | null,
    categoryId?: string | null,
    estimatedCompletionTimeInMins?: number | null,
    actionTitle: string,
    actionDestination: string,
    actionPayload?: string | null,
    createdAt: string,
    expirationDate?: string | null,
    lessonId?: string | null,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    tags?: Array< string | null > | null,
    isArchived: BoolEnum,
    updatedAt: string,
  } | null,
};

export type ListGrowthPathItemsQueryVariables = {
  filter?: ModelGrowthPathItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGrowthPathItemsQuery = {
  listGrowthPathItems?:  {
    __typename: "ModelGrowthPathItemConnection",
    items:  Array< {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthPathItemByTypeQueryVariables = {
  type: GrowthPathCardTypeEnum,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGrowthPathItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGrowthPathItemByTypeQuery = {
  listGrowthPathItemByType?:  {
    __typename: "ModelGrowthPathItemConnection",
    items:  Array< {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTopicTagsQueryVariables = {
  slug: string,
};

export type GetTopicTagsQuery = {
  getTopicTags?:  {
    __typename: "TopicTags",
    slug: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTopicTagsQueryVariables = {
  slug?: string | null,
  filter?: ModelTopicTagsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTopicTagsQuery = {
  listTopicTags?:  {
    __typename: "ModelTopicTagsConnection",
    items:  Array< {
      __typename: "TopicTags",
      slug: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFocusAreaQueryVariables = {
  id: string,
};

export type GetFocusAreaQuery = {
  getFocusArea?:  {
    __typename: "FocusArea",
    id: string,
    name: string,
    slug: string,
    description?: string | null,
    focusAreaGoals?:  {
      __typename: "ModelFocusAreaGoalConnection",
      items:  Array< {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFocusAreasQueryVariables = {
  filter?: ModelFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFocusAreasQuery = {
  listFocusAreas?:  {
    __typename: "ModelFocusAreaConnection",
    items:  Array< {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFocusAreaGoalQueryVariables = {
  id: string,
};

export type GetFocusAreaGoalQuery = {
  getFocusAreaGoal?:  {
    __typename: "FocusAreaGoal",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabits?:  {
      __typename: "ModelFocusAreaGoalHabitsConnection",
      items:  Array< {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFocusAreaGoalsQueryVariables = {
  filter?: ModelFocusAreaGoalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFocusAreaGoalsQuery = {
  listFocusAreaGoals?:  {
    __typename: "ModelFocusAreaGoalConnection",
    items:  Array< {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFocusAreaGoalsByFocusAreaIdQueryVariables = {
  focusAreaId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFocusAreaGoalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFocusAreaGoalsByFocusAreaIdQuery = {
  listFocusAreaGoalsByFocusAreaId?:  {
    __typename: "ModelFocusAreaGoalConnection",
    items:  Array< {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFocusAreaGoalHabitsQueryVariables = {
  id: string,
};

export type GetFocusAreaGoalHabitsQuery = {
  getFocusAreaGoalHabits?:  {
    __typename: "FocusAreaGoalHabits",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFocusAreaGoalHabitsQueryVariables = {
  filter?: ModelFocusAreaGoalHabitsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFocusAreaGoalHabitsQuery = {
  listFocusAreaGoalHabits?:  {
    __typename: "ModelFocusAreaGoalHabitsConnection",
    items:  Array< {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFocusAreaGoalHabitsByFocusAreaIdQueryVariables = {
  focusAreaId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFocusAreaGoalHabitsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFocusAreaGoalHabitsByFocusAreaIdQuery = {
  listFocusAreaGoalHabitsByFocusAreaId?:  {
    __typename: "ModelFocusAreaGoalHabitsConnection",
    items:  Array< {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFocusAreaGoalHabitsByFocusAreaGoalIdQueryVariables = {
  focusAreaGoalId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFocusAreaGoalHabitsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFocusAreaGoalHabitsByFocusAreaGoalIdQuery = {
  listFocusAreaGoalHabitsByFocusAreaGoalId?:  {
    __typename: "ModelFocusAreaGoalHabitsConnection",
    items:  Array< {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProgramQueryVariables = {
  id: string,
};

export type GetProgramQuery = {
  getProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    level: number,
    lessons?:  {
      __typename: "ModelLessonConnection",
      items:  Array< {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProgramsQueryVariables = {
  filter?: ModelProgramFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProgramsQuery = {
  listPrograms?:  {
    __typename: "ModelProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProgramsByActiveBbyLevelsQueryVariables = {
  active: BoolEnum,
  level?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProgramFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProgramsByActiveBbyLevelsQuery = {
  listProgramsByActiveBbyLevels?:  {
    __typename: "ModelProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLessonQueryVariables = {
  id: string,
};

export type GetLessonQuery = {
  getLesson?:  {
    __typename: "Lesson",
    id: string,
    programId: string,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    order: number,
    durationInMins: number,
    description?: string | null,
    transcript?: string | null,
    focusAreas?:  {
      __typename: "ModelLessonFocusAreaConnection",
      items:  Array< {
        __typename: "LessonFocusArea",
        lessonId: string,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    tags?: Array< string | null > | null,
    lessonType: LessonTypeEnum,
    metadata?:  {
      __typename: "LessonMetadata",
      videoUrl?: string | null,
      videoStreamUrl?: string | null,
      videoExternalId?: string | null,
      videoDistributionPage?: string | null,
      formUrl?: string | null,
      formExternalId?: string | null,
    } | null,
    coverImageUrl?: string | null,
    isPremium: BoolEnum,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLessonsQueryVariables = {
  filter?: ModelLessonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLessonsQuery = {
  listLessons?:  {
    __typename: "ModelLessonConnection",
    items:  Array< {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLessonsByProgramIdByOrderQueryVariables = {
  programId: string,
  order?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLessonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLessonsByProgramIdByOrderQuery = {
  listLessonsByProgramIdByOrder?:  {
    __typename: "ModelLessonConnection",
    items:  Array< {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLessonsByNameQueryVariables = {
  name: string,
  order?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLessonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLessonsByNameQuery = {
  listLessonsByName?:  {
    __typename: "ModelLessonConnection",
    items:  Array< {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLessonsByActiveBbyOrderQueryVariables = {
  active: BoolEnum,
  order?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLessonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLessonsByActiveBbyOrderQuery = {
  listLessonsByActiveBbyOrder?:  {
    __typename: "ModelLessonConnection",
    items:  Array< {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLessonFocusAreaQueryVariables = {
  lessonId: string,
  focusAreaId: string,
};

export type GetLessonFocusAreaQuery = {
  getLessonFocusArea?:  {
    __typename: "LessonFocusArea",
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLessonFocusAreasQueryVariables = {
  lessonId?: string | null,
  focusAreaId?: ModelIDKeyConditionInput | null,
  filter?: ModelLessonFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLessonFocusAreasQuery = {
  listLessonFocusAreas?:  {
    __typename: "ModelLessonFocusAreaConnection",
    items:  Array< {
      __typename: "LessonFocusArea",
      lessonId: string,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLessonFocusAreasByFocusAreaIdQueryVariables = {
  focusAreaId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLessonFocusAreaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLessonFocusAreasByFocusAreaIdQuery = {
  listLessonFocusAreasByFocusAreaId?:  {
    __typename: "ModelLessonFocusAreaConnection",
    items:  Array< {
      __typename: "LessonFocusArea",
      lessonId: string,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPlanGroupQueryVariables = {
  id: string,
};

export type GetPlanGroupQuery = {
  getPlanGroup?:  {
    __typename: "PlanGroup",
    id: string,
    name: string,
    startDate: string,
    endDate: string,
    trialPeriod: number,
    createdAt: string,
    active: BoolEnum,
    plans?:  {
      __typename: "ModelPlanConnection",
      items:  Array< {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListPlanGroupsQueryVariables = {
  filter?: ModelPlanGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlanGroupsQuery = {
  listPlanGroups?:  {
    __typename: "ModelPlanGroupConnection",
    items:  Array< {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPlanGroupsByActiveByEndDateQueryVariables = {
  active: BoolEnum,
  endDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPlanGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlanGroupsByActiveByEndDateQuery = {
  listPlanGroupsByActiveByEndDate?:  {
    __typename: "ModelPlanGroupConnection",
    items:  Array< {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPlanQueryVariables = {
  id: string,
};

export type GetPlanQuery = {
  getPlan?:  {
    __typename: "Plan",
    id: string,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    name: string,
    description?: string | null,
    active: BoolEnum,
    defaultPrice: number,
    defaultPlanPriceId?: string | null,
    discountsAllowed?: boolean | null,
    display?: boolean | null,
    isTrial?: boolean | null,
    upgradeable?: boolean | null,
    downgradeable?: boolean | null,
    features: Array< string >,
    createdAt: string,
    level: number,
    pricing?:  {
      __typename: "ModelPlanPricingConnection",
      items:  Array< {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata?:  {
      __typename: "PlanMetadata",
      coachingSessionsAllocated: number,
      stripeProductId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListPlansQueryVariables = {
  filter?: ModelPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlansQuery = {
  listPlans?:  {
    __typename: "ModelPlanConnection",
    items:  Array< {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPlansByGroupIdByLevelQueryVariables = {
  planGroupId: string,
  level?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlansByGroupIdByLevelQuery = {
  listPlansByGroupIdByLevel?:  {
    __typename: "ModelPlanConnection",
    items:  Array< {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPlanPricingQueryVariables = {
  planId: string,
  slug: string,
};

export type GetPlanPricingQuery = {
  getPlanPricing?:  {
    __typename: "PlanPricing",
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    slug: string,
    default: boolean,
    activationCodes?: Array< string | null > | null,
    downgradePricingIds?: Array< string | null > | null,
    upgradePricingIds?: Array< string | null > | null,
    price: number,
    metadata?:  {
      __typename: "PlanPricingMetada",
      stripePriceId?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPlanPricingsQueryVariables = {
  planId?: string | null,
  slug?: ModelStringKeyConditionInput | null,
  filter?: ModelPlanPricingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPlanPricingsQuery = {
  listPlanPricings?:  {
    __typename: "ModelPlanPricingConnection",
    items:  Array< {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventQueryVariables = {
  id: string,
};

export type GetEventQuery = {
  getEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventTimeConnection",
      items:  Array< {
        __typename: "EventTime",
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        metadata?:  {
          __typename: "EventTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
      activeCampaignTagId?: number | null,
      totalSessions?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventsQueryVariables = {
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsQuery = {
  listEvents?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEventsByStartDateQueryVariables = {
  startDate: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsByStartDateQuery = {
  listEventsByStartDate?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEventsByEventTypeQueryVariables = {
  eventType: EventTypeEnum,
  startDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsByEventTypeQuery = {
  listEventsByEventType?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventTimeQueryVariables = {
  eventId: string,
  startDate: string,
};

export type GetEventTimeQuery = {
  getEventTime?:  {
    __typename: "EventTime",
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    metadata?:  {
      __typename: "EventTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventTimesQueryVariables = {
  eventId?: string | null,
  startDate?: ModelStringKeyConditionInput | null,
  filter?: ModelEventTimeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEventTimesQuery = {
  listEventTimes?:  {
    __typename: "ModelEventTimeConnection",
    items:  Array< {
      __typename: "EventTime",
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      title: string,
      type: EventTimeTypeEnum,
      description?: string | null,
      startDate: string,
      endDate: string,
      timezone?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      metadata?:  {
        __typename: "EventTimeMetadata",
        acuityCalendarId?: string | null,
        acuityAppointmentTypeId?: string | null,
        meetingLinkVideo?: string | null,
        meetingLinkAudio?: string | null,
        recordingLink?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventSessionQueryVariables = {
  id: string,
};

export type GetEventSessionQuery = {
  getEventSession?:  {
    __typename: "EventSession",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sessionTitle?: string | null,
    sessionDescription?: string | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    isRecurring: BoolEnum,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    attendeeLimit: number,
    facilitators?:  {
      __typename: "ModelEventSessionFacilitatorConnection",
      items:  Array< {
        __typename: "EventSessionFacilitator",
        eventSessionId: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionAttendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventSessionTimeConnection",
      items:  Array< {
        __typename: "EventSessionTime",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        metadata?:  {
          __typename: "EventSessionTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionFocusAreaId?: string | null,
    eventSessionFocusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventSessionMetadata",
      chatChannelId?: string | null,
      eventSessionLandingPageUrl?: string | null,
      eventSessionMeetingLink?: string | null,
      actuityAppointmentTypeId?: string | null,
      acuityCalendarId?: string | null,
      activeCampaignTagId?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventSessionsQueryVariables = {
  filter?: ModelEventSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventSessionsQuery = {
  listEventSessions?:  {
    __typename: "ModelEventSessionConnection",
    items:  Array< {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventSessionTimeQueryVariables = {
  eventSessionId: string,
  startDate: string,
};

export type GetEventSessionTimeQuery = {
  getEventSessionTime?:  {
    __typename: "EventSessionTime",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    metadata?:  {
      __typename: "EventSessionTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventSessionTimesQueryVariables = {
  eventSessionId?: string | null,
  startDate?: ModelStringKeyConditionInput | null,
  filter?: ModelEventSessionTimeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEventSessionTimesQuery = {
  listEventSessionTimes?:  {
    __typename: "ModelEventSessionTimeConnection",
    items:  Array< {
      __typename: "EventSessionTime",
      eventSessionId: string,
      eventSession?:  {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      title: string,
      type: EventTimeTypeEnum,
      description?: string | null,
      startDate: string,
      endDate: string,
      timezone?: string | null,
      metadata?:  {
        __typename: "EventSessionTimeMetadata",
        acuityCalendarId?: string | null,
        acuityAppointmentTypeId?: string | null,
        meetingLinkVideo?: string | null,
        meetingLinkAudio?: string | null,
        recordingLink?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventSessionFacilitatorQueryVariables = {
  eventSessionId: string,
  coachId: string,
};

export type GetEventSessionFacilitatorQuery = {
  getEventSessionFacilitator?:  {
    __typename: "EventSessionFacilitator",
    eventSessionId: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventSessionFacilitatorsQueryVariables = {
  eventSessionId?: string | null,
  coachId?: ModelIDKeyConditionInput | null,
  filter?: ModelEventSessionFacilitatorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEventSessionFacilitatorsQuery = {
  listEventSessionFacilitators?:  {
    __typename: "ModelEventSessionFacilitatorConnection",
    items:  Array< {
      __typename: "EventSessionFacilitator",
      eventSessionId: string,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventSessionAttendeesQueryVariables = {
  eventSessionId: string,
  userId: string,
};

export type GetEventSessionAttendeesQuery = {
  getEventSessionAttendees?:  {
    __typename: "EventSessionAttendees",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    confirmed: BoolEnum,
    confirmationTimestamp?: number | null,
    metadata?:  {
      __typename: "EventSessionAttendeeMetadata",
      paymentTimestamp?: number | null,
      stripeInvoiceId?: string | null,
      rawPaymentLog?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventSessionAttendeesQueryVariables = {
  eventSessionId?: string | null,
  userId?: ModelIDKeyConditionInput | null,
  filter?: ModelEventSessionAttendeesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEventSessionAttendeesQuery = {
  listEventSessionAttendees?:  {
    __typename: "ModelEventSessionAttendeesConnection",
    items:  Array< {
      __typename: "EventSessionAttendees",
      eventSessionId: string,
      eventSession?:  {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      confirmed: BoolEnum,
      confirmationTimestamp?: number | null,
      metadata?:  {
        __typename: "EventSessionAttendeeMetadata",
        paymentTimestamp?: number | null,
        stripeInvoiceId?: string | null,
        rawPaymentLog?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventAttendeeByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEventSessionAttendeesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetEventAttendeeByUserIdQuery = {
  getEventAttendeeByUserId?:  {
    __typename: "ModelEventSessionAttendeesConnection",
    items:  Array< {
      __typename: "EventSessionAttendees",
      eventSessionId: string,
      eventSession?:  {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      confirmed: BoolEnum,
      confirmationTimestamp?: number | null,
      metadata?:  {
        __typename: "EventSessionAttendeeMetadata",
        paymentTimestamp?: number | null,
        stripeInvoiceId?: string | null,
        rawPaymentLog?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEventSessionAttendeesByEventIdQueryVariables = {
  eventId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEventSessionAttendeesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventSessionAttendeesByEventIdQuery = {
  listEventSessionAttendeesByEventId?:  {
    __typename: "ModelEventSessionAttendeesConnection",
    items:  Array< {
      __typename: "EventSessionAttendees",
      eventSessionId: string,
      eventSession?:  {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      confirmed: BoolEnum,
      confirmationTimestamp?: number | null,
      metadata?:  {
        __typename: "EventSessionAttendeeMetadata",
        paymentTimestamp?: number | null,
        stripeInvoiceId?: string | null,
        rawPaymentLog?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    lastSeen?: number | null,
    referralSource: string,
    roles: Array< RolesEnum >,
    stage?: FunnelStageEnum | null,
    plans?:  {
      __typename: "ModelUserPlanConnection",
      items:  Array< {
        __typename: "UserPlan",
        id: string,
        userId: string,
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        planPricingSlug: string,
        planPricing?:  {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate: string,
        endDate?: string | null,
        cancelled?: BoolEnum | null,
        cancellationReason?: string | null,
        createdAt: string,
        active: BoolEnum,
        metadata?:  {
          __typename: "UserPlanMetadata",
          stripeSubscriptionId?: string | null,
          stripeCustomerId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelUserAppointmentsConnection",
      items:  Array< {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    coaches?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    growthPaths?:  {
      __typename: "ModelUserGrowthPathItemConnection",
      items:  Array< {
        __typename: "UserGrowthPathItem",
        id: string,
        growthPathItemId: string,
        growthPathItem?:  {
          __typename: "GrowthPathItem",
          id: string,
          type: GrowthPathCardTypeEnum,
          title: string,
          subtitle?: string | null,
          avatarUrl?: string | null,
          description: string,
          categoryName?: string | null,
          categoryId?: string | null,
          estimatedCompletionTimeInMins?: number | null,
          actionTitle: string,
          actionDestination: string,
          actionPayload?: string | null,
          createdAt: string,
          expirationDate?: string | null,
          lessonId?: string | null,
          tags?: Array< string | null > | null,
          isArchived: BoolEnum,
          updatedAt: string,
        } | null,
        userId: string,
        order?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        dateTimeAdded: number,
        completed: BoolEnum,
        dismissed: BoolEnum,
        completedTimestamp?: number | null,
        expirationDate?: string | null,
        locked: BoolEnum,
        hidden: BoolEnum,
        isScheduled: BoolEnum,
        visibleDate: string,
        visibleTimestamp?: number | null,
        growthPathJourneyId?: string | null,
        growthPathJourneyStep?: number | null,
        growthPathJourney?:  {
          __typename: "GrowthPathJourney",
          id: string,
          title: string,
          description?: string | null,
          focusAreaId: string,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        coachId?: string | null,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        source?: UserGrowthPathItemSourceEnum | null,
        lastActivityTimestamp?: number | null,
        dependsOnGrowthPathItems?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    lastSeen?: number | null,
    referralSource: string,
    roles: Array< RolesEnum >,
    stage?: FunnelStageEnum | null,
    plans?:  {
      __typename: "ModelUserPlanConnection",
      items:  Array< {
        __typename: "UserPlan",
        id: string,
        userId: string,
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        planPricingSlug: string,
        planPricing?:  {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate: string,
        endDate?: string | null,
        cancelled?: BoolEnum | null,
        cancellationReason?: string | null,
        createdAt: string,
        active: BoolEnum,
        metadata?:  {
          __typename: "UserPlanMetadata",
          stripeSubscriptionId?: string | null,
          stripeCustomerId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelUserAppointmentsConnection",
      items:  Array< {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    coaches?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    growthPaths?:  {
      __typename: "ModelUserGrowthPathItemConnection",
      items:  Array< {
        __typename: "UserGrowthPathItem",
        id: string,
        growthPathItemId: string,
        growthPathItem?:  {
          __typename: "GrowthPathItem",
          id: string,
          type: GrowthPathCardTypeEnum,
          title: string,
          subtitle?: string | null,
          avatarUrl?: string | null,
          description: string,
          categoryName?: string | null,
          categoryId?: string | null,
          estimatedCompletionTimeInMins?: number | null,
          actionTitle: string,
          actionDestination: string,
          actionPayload?: string | null,
          createdAt: string,
          expirationDate?: string | null,
          lessonId?: string | null,
          tags?: Array< string | null > | null,
          isArchived: BoolEnum,
          updatedAt: string,
        } | null,
        userId: string,
        order?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        dateTimeAdded: number,
        completed: BoolEnum,
        dismissed: BoolEnum,
        completedTimestamp?: number | null,
        expirationDate?: string | null,
        locked: BoolEnum,
        hidden: BoolEnum,
        isScheduled: BoolEnum,
        visibleDate: string,
        visibleTimestamp?: number | null,
        growthPathJourneyId?: string | null,
        growthPathJourneyStep?: number | null,
        growthPathJourney?:  {
          __typename: "GrowthPathJourney",
          id: string,
          title: string,
          description?: string | null,
          focusAreaId: string,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        coachId?: string | null,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        source?: UserGrowthPathItemSourceEnum | null,
        lastActivityTimestamp?: number | null,
        dependsOnGrowthPathItems?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      houseNumber?: string | null,
      street?: string | null,
      streetType?: string | null,
      address1: string,
      address2?: string | null,
      address3?: string | null,
      city: string,
      state: string,
      postalCode: string,
      county?: string | null,
      country?: string | null,
      latLng?:  {
        __typename: "LocationPoint",
        lat?: number | null,
        lon?: number | null,
      } | null,
    } | null,
    avatar?: string | null,
    userBio?: string | null,
    age?: number | null,
    dateOfBirth?: string | null,
    genderId?: string | null,
    createdAt: string,
    status: UserStatusEnum,
    lastSeen?: number | null,
    referralSource: string,
    roles: Array< RolesEnum >,
    stage?: FunnelStageEnum | null,
    plans?:  {
      __typename: "ModelUserPlanConnection",
      items:  Array< {
        __typename: "UserPlan",
        id: string,
        userId: string,
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        planPricingSlug: string,
        planPricing?:  {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate: string,
        endDate?: string | null,
        cancelled?: BoolEnum | null,
        cancellationReason?: string | null,
        createdAt: string,
        active: BoolEnum,
        metadata?:  {
          __typename: "UserPlanMetadata",
          stripeSubscriptionId?: string | null,
          stripeCustomerId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelUserAppointmentsConnection",
      items:  Array< {
        __typename: "UserAppointments",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointmentStartTime: number,
        appointmentEndTime: number,
        appointmentDurationMins: number,
        appointmentTimezone: string,
        appointmentType: AppointmentTypeEnum,
        cancelled?: BoolEnum | null,
        cancelDate?: number | null,
        cancelReason?: string | null,
        cancelNote?: string | null,
        metadata:  {
          __typename: "UserAppointementMetadata",
          acuityAppointmentId?: string | null,
          acuityAppointmentTypeId?: string | null,
          acuityConfirmationPageUrl?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    coaches?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    growthPaths?:  {
      __typename: "ModelUserGrowthPathItemConnection",
      items:  Array< {
        __typename: "UserGrowthPathItem",
        id: string,
        growthPathItemId: string,
        growthPathItem?:  {
          __typename: "GrowthPathItem",
          id: string,
          type: GrowthPathCardTypeEnum,
          title: string,
          subtitle?: string | null,
          avatarUrl?: string | null,
          description: string,
          categoryName?: string | null,
          categoryId?: string | null,
          estimatedCompletionTimeInMins?: number | null,
          actionTitle: string,
          actionDestination: string,
          actionPayload?: string | null,
          createdAt: string,
          expirationDate?: string | null,
          lessonId?: string | null,
          tags?: Array< string | null > | null,
          isArchived: BoolEnum,
          updatedAt: string,
        } | null,
        userId: string,
        order?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        dateTimeAdded: number,
        completed: BoolEnum,
        dismissed: BoolEnum,
        completedTimestamp?: number | null,
        expirationDate?: string | null,
        locked: BoolEnum,
        hidden: BoolEnum,
        isScheduled: BoolEnum,
        visibleDate: string,
        visibleTimestamp?: number | null,
        growthPathJourneyId?: string | null,
        growthPathJourneyStep?: number | null,
        growthPathJourney?:  {
          __typename: "GrowthPathJourney",
          id: string,
          title: string,
          description?: string | null,
          focusAreaId: string,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        coachId?: string | null,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        source?: UserGrowthPathItemSourceEnum | null,
        lastActivityTimestamp?: number | null,
        dependsOnGrowthPathItems?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata:  {
      __typename: "UserMetadata",
      lastLogin: number,
      trialStartDate?: string | null,
      trialEndDate?: string | null,
      subscriptionStatus?: SubscriptionStatusEnum | null,
      deviceId?: string | null,
      deviceOS?: string | null,
      deviceOSVersion?: string | null,
      allowAccountNotifications?: boolean | null,
      allowMarketingNotifications?: boolean | null,
      allowCoachingNotifications?: boolean | null,
      initialAssessmentCompletedDate?: string | null,
      lastWeeklyCheckinDate?: string | null,
      lastGrowthStageAssessmentDate?: string | null,
      primaryFocusCategoryId?: string | null,
      primaryFocusGoalId?: string | null,
      secondaryFocusCategoryId?: string | null,
      secondaryFocusGoalId?: string | null,
      tertiaryFocusCategoryId?: string | null,
      tertiaryFocusGoalId?: string | null,
      preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
      preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
      primaryCoachId?: string | null,
      userIPAddress?: string | null,
      intakeCompleted?: BoolEnum | null,
      onboardingCompleted?: BoolEnum | null,
      issCompleted?: BoolEnum | null,
      stipeCustomerId?: string | null,
      lastActive?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type OnCreateUserCoachSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachFilterInput | null,
};

export type OnCreateUserCoachSubscription = {
  onCreateUserCoach?:  {
    __typename: "UserCoach",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPrimary: BoolEnum,
    active: BoolEnum,
    coachingStartDate: string,
    coachingEndDate?: string | null,
    ratings?:  {
      __typename: "ModelUserCoachRatingConnection",
      items:  Array< {
        __typename: "UserCoachRating",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        rating: number,
        comment?: string | null,
        ratingTimestamp: number,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserCoachSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachFilterInput | null,
};

export type OnUpdateUserCoachSubscription = {
  onUpdateUserCoach?:  {
    __typename: "UserCoach",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPrimary: BoolEnum,
    active: BoolEnum,
    coachingStartDate: string,
    coachingEndDate?: string | null,
    ratings?:  {
      __typename: "ModelUserCoachRatingConnection",
      items:  Array< {
        __typename: "UserCoachRating",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        rating: number,
        comment?: string | null,
        ratingTimestamp: number,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserCoachSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachFilterInput | null,
};

export type OnDeleteUserCoachSubscription = {
  onDeleteUserCoach?:  {
    __typename: "UserCoach",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPrimary: BoolEnum,
    active: BoolEnum,
    coachingStartDate: string,
    coachingEndDate?: string | null,
    ratings?:  {
      __typename: "ModelUserCoachRatingConnection",
      items:  Array< {
        __typename: "UserCoachRating",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        rating: number,
        comment?: string | null,
        ratingTimestamp: number,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserCoachRatingSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachRatingFilterInput | null,
};

export type OnCreateUserCoachRatingSubscription = {
  onCreateUserCoachRating?:  {
    __typename: "UserCoachRating",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    rating: number,
    comment?: string | null,
    ratingTimestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserCoachRatingSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachRatingFilterInput | null,
};

export type OnUpdateUserCoachRatingSubscription = {
  onUpdateUserCoachRating?:  {
    __typename: "UserCoachRating",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    rating: number,
    comment?: string | null,
    ratingTimestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserCoachRatingSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachRatingFilterInput | null,
};

export type OnDeleteUserCoachRatingSubscription = {
  onDeleteUserCoachRating?:  {
    __typename: "UserCoachRating",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    rating: number,
    comment?: string | null,
    ratingTimestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserCoachingNoteSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingNoteFilterInput | null,
};

export type OnCreateUserCoachingNoteSubscription = {
  onCreateUserCoachingNote?:  {
    __typename: "UserCoachingNote",
    id: string,
    userId: string,
    coachId: string,
    appointmentId?: string | null,
    appointment?:  {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null,
    note: string,
    visibleToUser: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserCoachingNoteSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingNoteFilterInput | null,
};

export type OnUpdateUserCoachingNoteSubscription = {
  onUpdateUserCoachingNote?:  {
    __typename: "UserCoachingNote",
    id: string,
    userId: string,
    coachId: string,
    appointmentId?: string | null,
    appointment?:  {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null,
    note: string,
    visibleToUser: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserCoachingNoteSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingNoteFilterInput | null,
};

export type OnDeleteUserCoachingNoteSubscription = {
  onDeleteUserCoachingNote?:  {
    __typename: "UserCoachingNote",
    id: string,
    userId: string,
    coachId: string,
    appointmentId?: string | null,
    appointment?:  {
      __typename: "UserAppointments",
      id: string,
      userId: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        address?:  {
          __typename: "Address",
          houseNumber?: string | null,
          street?: string | null,
          streetType?: string | null,
          address1: string,
          address2?: string | null,
          address3?: string | null,
          city: string,
          state: string,
          postalCode: string,
          county?: string | null,
          country?: string | null,
        } | null,
        avatar?: string | null,
        userBio?: string | null,
        age?: number | null,
        dateOfBirth?: string | null,
        genderId?: string | null,
        createdAt: string,
        status: UserStatusEnum,
        lastSeen?: number | null,
        referralSource: string,
        roles: Array< RolesEnum >,
        stage?: FunnelStageEnum | null,
        plans?:  {
          __typename: "ModelUserPlanConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelUserAppointmentsConnection",
          nextToken?: string | null,
        } | null,
        coaches?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        growthPaths?:  {
          __typename: "ModelUserGrowthPathItemConnection",
          nextToken?: string | null,
        } | null,
        metadata:  {
          __typename: "UserMetadata",
          lastLogin: number,
          trialStartDate?: string | null,
          trialEndDate?: string | null,
          subscriptionStatus?: SubscriptionStatusEnum | null,
          deviceId?: string | null,
          deviceOS?: string | null,
          deviceOSVersion?: string | null,
          allowAccountNotifications?: boolean | null,
          allowMarketingNotifications?: boolean | null,
          allowCoachingNotifications?: boolean | null,
          initialAssessmentCompletedDate?: string | null,
          lastWeeklyCheckinDate?: string | null,
          lastGrowthStageAssessmentDate?: string | null,
          primaryFocusCategoryId?: string | null,
          primaryFocusGoalId?: string | null,
          secondaryFocusCategoryId?: string | null,
          secondaryFocusGoalId?: string | null,
          tertiaryFocusCategoryId?: string | null,
          tertiaryFocusGoalId?: string | null,
          preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
          preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
          primaryCoachId?: string | null,
          userIPAddress?: string | null,
          intakeCompleted?: BoolEnum | null,
          onboardingCompleted?: BoolEnum | null,
          issCompleted?: BoolEnum | null,
          stipeCustomerId?: string | null,
          lastActive?: number | null,
        },
        updatedAt: string,
      } | null,
      coachId: string,
      coach?:  {
        __typename: "Coach",
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        title?: string | null,
        coachType?: Array< CoachTypeEnum | null > | null,
        avatarUrl?: string | null,
        description?: string | null,
        metadata?:  {
          __typename: "CoachMetaData",
          introVideoUrl?: string | null,
          gcalId?: string | null,
          calendlyId?: string | null,
          acuityCalendarId?: string | null,
          acuityUserId?: string | null,
          acuityKey?: string | null,
          acuityIssAppointmentId?: string | null,
          acuityRegularAppointmentId?: string | null,
          streamChatId?: string | null,
          slackId?: string | null,
          lastCoachNote?: number | null,
          lastChatMessage?: number | null,
        } | null,
        focusAreas?:  {
          __typename: "ModelCoachFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        members?:  {
          __typename: "ModelUserCoachConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointmentStartTime: number,
      appointmentEndTime: number,
      appointmentDurationMins: number,
      appointmentTimezone: string,
      appointmentType: AppointmentTypeEnum,
      cancelled?: BoolEnum | null,
      cancelDate?: number | null,
      cancelReason?: string | null,
      cancelNote?: string | null,
      metadata:  {
        __typename: "UserAppointementMetadata",
        acuityAppointmentId?: string | null,
        acuityAppointmentTypeId?: string | null,
        acuityConfirmationPageUrl?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null,
    note: string,
    visibleToUser: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserStatsSubscriptionVariables = {
  filter?: ModelSubscriptionUserStatsFilterInput | null,
};

export type OnCreateUserStatsSubscription = {
  onCreateUserStats?:  {
    __typename: "UserStats",
    userId: string,
    totalHabitLogged?: number | null,
    totalAppointmentsScheduled?: number | null,
    totalLessonsWatched?: number | null,
    totalLogins?: number | null,
    totalMessages?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserStatsSubscriptionVariables = {
  filter?: ModelSubscriptionUserStatsFilterInput | null,
};

export type OnUpdateUserStatsSubscription = {
  onUpdateUserStats?:  {
    __typename: "UserStats",
    userId: string,
    totalHabitLogged?: number | null,
    totalAppointmentsScheduled?: number | null,
    totalLessonsWatched?: number | null,
    totalLogins?: number | null,
    totalMessages?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserStatsSubscriptionVariables = {
  filter?: ModelSubscriptionUserStatsFilterInput | null,
};

export type OnDeleteUserStatsSubscription = {
  onDeleteUserStats?:  {
    __typename: "UserStats",
    userId: string,
    totalHabitLogged?: number | null,
    totalAppointmentsScheduled?: number | null,
    totalLessonsWatched?: number | null,
    totalLogins?: number | null,
    totalMessages?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserActivityLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserActivityLogFilterInput | null,
};

export type OnCreateUserActivityLogSubscription = {
  onCreateUserActivityLog?:  {
    __typename: "UserActivityLog",
    id: string,
    type: UserActivitiesEnum,
    source: ActivitySourceEnum,
    payload?: string | null,
    timestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserActivityLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserActivityLogFilterInput | null,
};

export type OnUpdateUserActivityLogSubscription = {
  onUpdateUserActivityLog?:  {
    __typename: "UserActivityLog",
    id: string,
    type: UserActivitiesEnum,
    source: ActivitySourceEnum,
    payload?: string | null,
    timestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserActivityLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserActivityLogFilterInput | null,
};

export type OnDeleteUserActivityLogSubscription = {
  onDeleteUserActivityLog?:  {
    __typename: "UserActivityLog",
    id: string,
    type: UserActivitiesEnum,
    source: ActivitySourceEnum,
    payload?: string | null,
    timestamp: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateJournalEntryTemplatesSubscriptionVariables = {
  filter?: ModelSubscriptionJournalEntryTemplatesFilterInput | null,
};

export type OnCreateJournalEntryTemplatesSubscription = {
  onCreateJournalEntryTemplates?:  {
    __typename: "JournalEntryTemplates",
    id: string,
    name: string,
    description?: string | null,
    templateText: string,
    templateBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateJournalEntryTemplatesSubscriptionVariables = {
  filter?: ModelSubscriptionJournalEntryTemplatesFilterInput | null,
};

export type OnUpdateJournalEntryTemplatesSubscription = {
  onUpdateJournalEntryTemplates?:  {
    __typename: "JournalEntryTemplates",
    id: string,
    name: string,
    description?: string | null,
    templateText: string,
    templateBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteJournalEntryTemplatesSubscriptionVariables = {
  filter?: ModelSubscriptionJournalEntryTemplatesFilterInput | null,
};

export type OnDeleteJournalEntryTemplatesSubscription = {
  onDeleteJournalEntryTemplates?:  {
    __typename: "JournalEntryTemplates",
    id: string,
    name: string,
    description?: string | null,
    templateText: string,
    templateBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserJournalEntryLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserJournalEntryLogFilterInput | null,
};

export type OnCreateUserJournalEntryLogSubscription = {
  onCreateUserJournalEntryLog?:  {
    __typename: "UserJournalEntryLog",
    userId: string,
    entryTitle: string,
    entryLogType: JournalEntryLogTypeEnum,
    entryLogTags?:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } > | null,
    isVisibleToCoach: BoolEnum,
    isVisibleToPublic: BoolEnum,
    entryText: string,
    entryBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    journalEntryTemplateId?: string | null,
    rawEntry?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserJournalEntryLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserJournalEntryLogFilterInput | null,
};

export type OnUpdateUserJournalEntryLogSubscription = {
  onUpdateUserJournalEntryLog?:  {
    __typename: "UserJournalEntryLog",
    userId: string,
    entryTitle: string,
    entryLogType: JournalEntryLogTypeEnum,
    entryLogTags?:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } > | null,
    isVisibleToCoach: BoolEnum,
    isVisibleToPublic: BoolEnum,
    entryText: string,
    entryBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    journalEntryTemplateId?: string | null,
    rawEntry?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserJournalEntryLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserJournalEntryLogFilterInput | null,
};

export type OnDeleteUserJournalEntryLogSubscription = {
  onDeleteUserJournalEntryLog?:  {
    __typename: "UserJournalEntryLog",
    userId: string,
    entryTitle: string,
    entryLogType: JournalEntryLogTypeEnum,
    entryLogTags?:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } > | null,
    isVisibleToCoach: BoolEnum,
    isVisibleToPublic: BoolEnum,
    entryText: string,
    entryBlocks:  Array< {
      __typename: "LabelValueOptionType",
      label: string,
      value: string,
    } >,
    journalEntryTemplateId?: string | null,
    rawEntry?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserPlanSubscriptionVariables = {
  filter?: ModelSubscriptionUserPlanFilterInput | null,
  userId?: string | null,
};

export type OnCreateUserPlanSubscription = {
  onCreateUserPlan?:  {
    __typename: "UserPlan",
    id: string,
    userId: string,
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planPricingSlug: string,
    planPricing?:  {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    cancelled?: BoolEnum | null,
    cancellationReason?: string | null,
    createdAt: string,
    active: BoolEnum,
    metadata?:  {
      __typename: "UserPlanMetadata",
      stripeSubscriptionId?: string | null,
      stripeCustomerId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserPlanSubscriptionVariables = {
  filter?: ModelSubscriptionUserPlanFilterInput | null,
  userId?: string | null,
};

export type OnUpdateUserPlanSubscription = {
  onUpdateUserPlan?:  {
    __typename: "UserPlan",
    id: string,
    userId: string,
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planPricingSlug: string,
    planPricing?:  {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    cancelled?: BoolEnum | null,
    cancellationReason?: string | null,
    createdAt: string,
    active: BoolEnum,
    metadata?:  {
      __typename: "UserPlanMetadata",
      stripeSubscriptionId?: string | null,
      stripeCustomerId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserPlanSubscriptionVariables = {
  filter?: ModelSubscriptionUserPlanFilterInput | null,
  userId?: string | null,
};

export type OnDeleteUserPlanSubscription = {
  onDeleteUserPlan?:  {
    __typename: "UserPlan",
    id: string,
    userId: string,
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    planPricingSlug: string,
    planPricing?:  {
      __typename: "PlanPricing",
      planId: string,
      plan?:  {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      slug: string,
      default: boolean,
      activationCodes?: Array< string | null > | null,
      downgradePricingIds?: Array< string | null > | null,
      upgradePricingIds?: Array< string | null > | null,
      price: number,
      metadata?:  {
        __typename: "PlanPricingMetada",
        stripePriceId?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    cancelled?: BoolEnum | null,
    cancellationReason?: string | null,
    createdAt: string,
    active: BoolEnum,
    metadata?:  {
      __typename: "UserPlanMetadata",
      stripeSubscriptionId?: string | null,
      stripeCustomerId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnCreateUserCoachingCreditsSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingCreditsFilterInput | null,
};

export type OnCreateUserCoachingCreditsSubscription = {
  onCreateUserCoachingCredits?:  {
    __typename: "UserCoachingCredits",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    yearMonth: number,
    creditsAwarded: number,
    creditsRemaining: number,
    lastUsedTimestamp?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserCoachingCreditsSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingCreditsFilterInput | null,
};

export type OnUpdateUserCoachingCreditsSubscription = {
  onUpdateUserCoachingCredits?:  {
    __typename: "UserCoachingCredits",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    yearMonth: number,
    creditsAwarded: number,
    creditsRemaining: number,
    lastUsedTimestamp?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserCoachingCreditsSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingCreditsFilterInput | null,
};

export type OnDeleteUserCoachingCreditsSubscription = {
  onDeleteUserCoachingCredits?:  {
    __typename: "UserCoachingCredits",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    yearMonth: number,
    creditsAwarded: number,
    creditsRemaining: number,
    lastUsedTimestamp?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserCoachingCreditUsageLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingCreditUsageLogFilterInput | null,
};

export type OnCreateUserCoachingCreditUsageLogSubscription = {
  onCreateUserCoachingCreditUsageLog?:  {
    __typename: "UserCoachingCreditUsageLog",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    memo: string,
    timestamp: number,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserCoachingCreditUsageLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingCreditUsageLogFilterInput | null,
};

export type OnUpdateUserCoachingCreditUsageLogSubscription = {
  onUpdateUserCoachingCreditUsageLog?:  {
    __typename: "UserCoachingCreditUsageLog",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    memo: string,
    timestamp: number,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserCoachingCreditUsageLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserCoachingCreditUsageLogFilterInput | null,
};

export type OnDeleteUserCoachingCreditUsageLogSubscription = {
  onDeleteUserCoachingCreditUsageLog?:  {
    __typename: "UserCoachingCreditUsageLog",
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    memo: string,
    timestamp: number,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaFilterInput | null,
};

export type OnCreateUserFocusAreaSubscription = {
  onCreateUserFocusArea?:  {
    __typename: "UserFocusArea",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    completed: BoolEnum,
    dateCompleted?: number | null,
    userFocusAreaGoals?:  {
      __typename: "ModelUserFocusAreaGoalsConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoals",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userFocusAreaGoalHabits?:  {
          __typename: "ModelUserFocusAreaGoalHabitConnection",
          nextToken?: string | null,
        } | null,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaFilterInput | null,
};

export type OnUpdateUserFocusAreaSubscription = {
  onUpdateUserFocusArea?:  {
    __typename: "UserFocusArea",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    completed: BoolEnum,
    dateCompleted?: number | null,
    userFocusAreaGoals?:  {
      __typename: "ModelUserFocusAreaGoalsConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoals",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userFocusAreaGoalHabits?:  {
          __typename: "ModelUserFocusAreaGoalHabitConnection",
          nextToken?: string | null,
        } | null,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaFilterInput | null,
};

export type OnDeleteUserFocusAreaSubscription = {
  onDeleteUserFocusArea?:  {
    __typename: "UserFocusArea",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate: string,
    endDate?: string | null,
    completed: BoolEnum,
    dateCompleted?: number | null,
    userFocusAreaGoals?:  {
      __typename: "ModelUserFocusAreaGoalsConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoals",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userFocusAreaGoalHabits?:  {
          __typename: "ModelUserFocusAreaGoalHabitConnection",
          nextToken?: string | null,
        } | null,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserFocusAreaGoalsSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalsFilterInput | null,
};

export type OnCreateUserFocusAreaGoalsSubscription = {
  onCreateUserFocusAreaGoals?:  {
    __typename: "UserFocusAreaGoals",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userFocusAreaGoalHabits?:  {
      __typename: "ModelUserFocusAreaGoalHabitConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabit",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitId: string,
        focusAreaGoalHabit?:  {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitLog?:  {
          __typename: "ModelUserFocusAreaGoalHabitLogConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserFocusAreaGoalsSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalsFilterInput | null,
};

export type OnUpdateUserFocusAreaGoalsSubscription = {
  onUpdateUserFocusAreaGoals?:  {
    __typename: "UserFocusAreaGoals",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userFocusAreaGoalHabits?:  {
      __typename: "ModelUserFocusAreaGoalHabitConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabit",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitId: string,
        focusAreaGoalHabit?:  {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitLog?:  {
          __typename: "ModelUserFocusAreaGoalHabitLogConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserFocusAreaGoalsSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalsFilterInput | null,
};

export type OnDeleteUserFocusAreaGoalsSubscription = {
  onDeleteUserFocusAreaGoals?:  {
    __typename: "UserFocusAreaGoals",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userFocusAreaGoalHabits?:  {
      __typename: "ModelUserFocusAreaGoalHabitConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabit",
        id: string,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitId: string,
        focusAreaGoalHabit?:  {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabitLog?:  {
          __typename: "ModelUserFocusAreaGoalHabitLogConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        completed?: BoolEnum | null,
        dateCompleted?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserFocusAreaGoalHabitSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalHabitFilterInput | null,
};

export type OnCreateUserFocusAreaGoalHabitSubscription = {
  onCreateUserFocusAreaGoalHabit?:  {
    __typename: "UserFocusAreaGoalHabit",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitId: string,
    focusAreaGoalHabit?:  {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitLog?:  {
      __typename: "ModelUserFocusAreaGoalHabitLogConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabitLog",
        id: string,
        userId: string,
        userFocusAreaGoalHabitId: string,
        year: number,
        month: number,
        week: number,
        day: number,
        note?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserFocusAreaGoalHabitSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalHabitFilterInput | null,
};

export type OnUpdateUserFocusAreaGoalHabitSubscription = {
  onUpdateUserFocusAreaGoalHabit?:  {
    __typename: "UserFocusAreaGoalHabit",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitId: string,
    focusAreaGoalHabit?:  {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitLog?:  {
      __typename: "ModelUserFocusAreaGoalHabitLogConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabitLog",
        id: string,
        userId: string,
        userFocusAreaGoalHabitId: string,
        year: number,
        month: number,
        week: number,
        day: number,
        note?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserFocusAreaGoalHabitSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalHabitFilterInput | null,
};

export type OnDeleteUserFocusAreaGoalHabitSubscription = {
  onDeleteUserFocusAreaGoalHabit?:  {
    __typename: "UserFocusAreaGoalHabit",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitId: string,
    focusAreaGoalHabit?:  {
      __typename: "FocusAreaGoalHabits",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalId: string,
      focusAreaGoal?:  {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabitLog?:  {
      __typename: "ModelUserFocusAreaGoalHabitLogConnection",
      items:  Array< {
        __typename: "UserFocusAreaGoalHabitLog",
        id: string,
        userId: string,
        userFocusAreaGoalHabitId: string,
        year: number,
        month: number,
        week: number,
        day: number,
        note?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    completed?: BoolEnum | null,
    dateCompleted?: number | null,
    updatedAt: string,
  } | null,
};

export type OnCreateUserFocusAreaGoalHabitLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalHabitLogFilterInput | null,
};

export type OnCreateUserFocusAreaGoalHabitLogSubscription = {
  onCreateUserFocusAreaGoalHabitLog?:  {
    __typename: "UserFocusAreaGoalHabitLog",
    id: string,
    userId: string,
    userFocusAreaGoalHabitId: string,
    year: number,
    month: number,
    week: number,
    day: number,
    note?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserFocusAreaGoalHabitLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalHabitLogFilterInput | null,
};

export type OnUpdateUserFocusAreaGoalHabitLogSubscription = {
  onUpdateUserFocusAreaGoalHabitLog?:  {
    __typename: "UserFocusAreaGoalHabitLog",
    id: string,
    userId: string,
    userFocusAreaGoalHabitId: string,
    year: number,
    month: number,
    week: number,
    day: number,
    note?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserFocusAreaGoalHabitLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserFocusAreaGoalHabitLogFilterInput | null,
};

export type OnDeleteUserFocusAreaGoalHabitLogSubscription = {
  onDeleteUserFocusAreaGoalHabitLog?:  {
    __typename: "UserFocusAreaGoalHabitLog",
    id: string,
    userId: string,
    userFocusAreaGoalHabitId: string,
    year: number,
    month: number,
    week: number,
    day: number,
    note?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserAssessmentLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserAssessmentLogFilterInput | null,
};

export type OnCreateUserAssessmentLogSubscription = {
  onCreateUserAssessmentLog?:  {
    __typename: "UserAssessmentLog",
    id: string,
    createdAt: string,
    userId: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    assessment: string,
    score: number,
    maxScore: number,
    userNotified: boolean,
    coachReviewed: BoolEnum,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserAssessmentLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserAssessmentLogFilterInput | null,
};

export type OnUpdateUserAssessmentLogSubscription = {
  onUpdateUserAssessmentLog?:  {
    __typename: "UserAssessmentLog",
    id: string,
    createdAt: string,
    userId: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    assessment: string,
    score: number,
    maxScore: number,
    userNotified: boolean,
    coachReviewed: BoolEnum,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserAssessmentLogSubscriptionVariables = {
  filter?: ModelSubscriptionUserAssessmentLogFilterInput | null,
};

export type OnDeleteUserAssessmentLogSubscription = {
  onDeleteUserAssessmentLog?:  {
    __typename: "UserAssessmentLog",
    id: string,
    createdAt: string,
    userId: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    assessment: string,
    score: number,
    maxScore: number,
    userNotified: boolean,
    coachReviewed: BoolEnum,
    updatedAt: string,
  } | null,
};

export type OnCreateUserLessonsSubscriptionVariables = {
  filter?: ModelSubscriptionUserLessonsFilterInput | null,
};

export type OnCreateUserLessonsSubscription = {
  onCreateUserLessons?:  {
    __typename: "UserLessons",
    id: string,
    userId: string,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    startTimestamp?: number | null,
    completedTimestamp?: number | null,
    lastViewedTimestamp?: number | null,
    completed: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserLessonsSubscriptionVariables = {
  filter?: ModelSubscriptionUserLessonsFilterInput | null,
};

export type OnUpdateUserLessonsSubscription = {
  onUpdateUserLessons?:  {
    __typename: "UserLessons",
    id: string,
    userId: string,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    startTimestamp?: number | null,
    completedTimestamp?: number | null,
    lastViewedTimestamp?: number | null,
    completed: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserLessonsSubscriptionVariables = {
  filter?: ModelSubscriptionUserLessonsFilterInput | null,
};

export type OnDeleteUserLessonsSubscription = {
  onDeleteUserLessons?:  {
    __typename: "UserLessons",
    id: string,
    userId: string,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    startTimestamp?: number | null,
    completedTimestamp?: number | null,
    lastViewedTimestamp?: number | null,
    completed: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserGrowthPathItemSubscriptionVariables = {
  filter?: ModelSubscriptionUserGrowthPathItemFilterInput | null,
};

export type OnCreateUserGrowthPathItemSubscription = {
  onCreateUserGrowthPathItem?:  {
    __typename: "UserGrowthPathItem",
    id: string,
    growthPathItemId: string,
    growthPathItem?:  {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null,
    userId: string,
    order?: number | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    dateTimeAdded: number,
    completed: BoolEnum,
    dismissed: BoolEnum,
    completedTimestamp?: number | null,
    expirationDate?: string | null,
    locked: BoolEnum,
    hidden: BoolEnum,
    isScheduled: BoolEnum,
    visibleDate: string,
    visibleTimestamp?: number | null,
    growthPathJourneyId?: string | null,
    growthPathJourneyStep?: number | null,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    coachId?: string | null,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    source?: UserGrowthPathItemSourceEnum | null,
    lastActivityTimestamp?: number | null,
    dependsOnGrowthPathItems?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserGrowthPathItemSubscriptionVariables = {
  filter?: ModelSubscriptionUserGrowthPathItemFilterInput | null,
};

export type OnUpdateUserGrowthPathItemSubscription = {
  onUpdateUserGrowthPathItem?:  {
    __typename: "UserGrowthPathItem",
    id: string,
    growthPathItemId: string,
    growthPathItem?:  {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null,
    userId: string,
    order?: number | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    dateTimeAdded: number,
    completed: BoolEnum,
    dismissed: BoolEnum,
    completedTimestamp?: number | null,
    expirationDate?: string | null,
    locked: BoolEnum,
    hidden: BoolEnum,
    isScheduled: BoolEnum,
    visibleDate: string,
    visibleTimestamp?: number | null,
    growthPathJourneyId?: string | null,
    growthPathJourneyStep?: number | null,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    coachId?: string | null,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    source?: UserGrowthPathItemSourceEnum | null,
    lastActivityTimestamp?: number | null,
    dependsOnGrowthPathItems?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserGrowthPathItemSubscriptionVariables = {
  filter?: ModelSubscriptionUserGrowthPathItemFilterInput | null,
};

export type OnDeleteUserGrowthPathItemSubscription = {
  onDeleteUserGrowthPathItem?:  {
    __typename: "UserGrowthPathItem",
    id: string,
    growthPathItemId: string,
    growthPathItem?:  {
      __typename: "GrowthPathItem",
      id: string,
      type: GrowthPathCardTypeEnum,
      title: string,
      subtitle?: string | null,
      avatarUrl?: string | null,
      description: string,
      categoryName?: string | null,
      categoryId?: string | null,
      estimatedCompletionTimeInMins?: number | null,
      actionTitle: string,
      actionDestination: string,
      actionPayload?: string | null,
      createdAt: string,
      expirationDate?: string | null,
      lessonId?: string | null,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      tags?: Array< string | null > | null,
      isArchived: BoolEnum,
      updatedAt: string,
    } | null,
    userId: string,
    order?: number | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    dateTimeAdded: number,
    completed: BoolEnum,
    dismissed: BoolEnum,
    completedTimestamp?: number | null,
    expirationDate?: string | null,
    locked: BoolEnum,
    hidden: BoolEnum,
    isScheduled: BoolEnum,
    visibleDate: string,
    visibleTimestamp?: number | null,
    growthPathJourneyId?: string | null,
    growthPathJourneyStep?: number | null,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    coachId?: string | null,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    source?: UserGrowthPathItemSourceEnum | null,
    lastActivityTimestamp?: number | null,
    dependsOnGrowthPathItems?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserGrowthPathJourneySubscriptionVariables = {
  filter?: ModelSubscriptionUserGrowthPathJourneyFilterInput | null,
};

export type OnCreateUserGrowthPathJourneySubscription = {
  onCreateUserGrowthPathJourney?:  {
    __typename: "UserGrowthPathJourney",
    userId: string,
    growthPathJourneyId: string,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    completionLog?:  Array< {
      __typename: "UserGrowthPathJourneyCompletionLog",
      growthPathItemId: string,
      completionTimestamp: number,
    } > | null,
    lastActivityTimestamp: number,
    active: BoolEnum,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserGrowthPathJourneySubscriptionVariables = {
  filter?: ModelSubscriptionUserGrowthPathJourneyFilterInput | null,
};

export type OnUpdateUserGrowthPathJourneySubscription = {
  onUpdateUserGrowthPathJourney?:  {
    __typename: "UserGrowthPathJourney",
    userId: string,
    growthPathJourneyId: string,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    completionLog?:  Array< {
      __typename: "UserGrowthPathJourneyCompletionLog",
      growthPathItemId: string,
      completionTimestamp: number,
    } > | null,
    lastActivityTimestamp: number,
    active: BoolEnum,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserGrowthPathJourneySubscriptionVariables = {
  filter?: ModelSubscriptionUserGrowthPathJourneyFilterInput | null,
};

export type OnDeleteUserGrowthPathJourneySubscription = {
  onDeleteUserGrowthPathJourney?:  {
    __typename: "UserGrowthPathJourney",
    userId: string,
    growthPathJourneyId: string,
    growthPathJourney?:  {
      __typename: "GrowthPathJourney",
      id: string,
      title: string,
      description?: string | null,
      growthPathItems:  Array< {
        __typename: "GrowthPathJourneyGrowthPathItem",
        step: number,
        growthPathItemId: string,
        rules?:  Array< {
          __typename: "GrowthPathItemDependencies",
          ruleType: DependencyTypeEnum,
          dependencyGrowthPathItemId: string,
          scheduleDaysFromNow?: number | null,
        } > | null,
      } >,
      focusAreaId: string,
      focusArea:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    completionLog?:  Array< {
      __typename: "UserGrowthPathJourneyCompletionLog",
      growthPathItemId: string,
      completionTimestamp: number,
    } > | null,
    lastActivityTimestamp: number,
    active: BoolEnum,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateGrowthPathJourneySubscriptionVariables = {
  filter?: ModelSubscriptionGrowthPathJourneyFilterInput | null,
};

export type OnCreateGrowthPathJourneySubscription = {
  onCreateGrowthPathJourney?:  {
    __typename: "GrowthPathJourney",
    id: string,
    title: string,
    description?: string | null,
    growthPathItems:  Array< {
      __typename: "GrowthPathJourneyGrowthPathItem",
      step: number,
      growthPathItemId: string,
      rules?:  Array< {
        __typename: "GrowthPathItemDependencies",
        ruleType: DependencyTypeEnum,
        dependencyGrowthPathItemId: string,
        scheduleDaysFromNow?: number | null,
      } > | null,
    } >,
    focusAreaId: string,
    focusArea:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateGrowthPathJourneySubscriptionVariables = {
  filter?: ModelSubscriptionGrowthPathJourneyFilterInput | null,
};

export type OnUpdateGrowthPathJourneySubscription = {
  onUpdateGrowthPathJourney?:  {
    __typename: "GrowthPathJourney",
    id: string,
    title: string,
    description?: string | null,
    growthPathItems:  Array< {
      __typename: "GrowthPathJourneyGrowthPathItem",
      step: number,
      growthPathItemId: string,
      rules?:  Array< {
        __typename: "GrowthPathItemDependencies",
        ruleType: DependencyTypeEnum,
        dependencyGrowthPathItemId: string,
        scheduleDaysFromNow?: number | null,
      } > | null,
    } >,
    focusAreaId: string,
    focusArea:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteGrowthPathJourneySubscriptionVariables = {
  filter?: ModelSubscriptionGrowthPathJourneyFilterInput | null,
};

export type OnDeleteGrowthPathJourneySubscription = {
  onDeleteGrowthPathJourney?:  {
    __typename: "GrowthPathJourney",
    id: string,
    title: string,
    description?: string | null,
    growthPathItems:  Array< {
      __typename: "GrowthPathJourneyGrowthPathItem",
      step: number,
      growthPathItemId: string,
      rules?:  Array< {
        __typename: "GrowthPathItemDependencies",
        ruleType: DependencyTypeEnum,
        dependencyGrowthPathItemId: string,
        scheduleDaysFromNow?: number | null,
      } > | null,
    } >,
    focusAreaId: string,
    focusArea:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserAppointmentsSubscriptionVariables = {
  filter?: ModelSubscriptionUserAppointmentsFilterInput | null,
};

export type OnCreateUserAppointmentsSubscription = {
  onCreateUserAppointments?:  {
    __typename: "UserAppointments",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointmentStartTime: number,
    appointmentEndTime: number,
    appointmentDurationMins: number,
    appointmentTimezone: string,
    appointmentType: AppointmentTypeEnum,
    cancelled?: BoolEnum | null,
    cancelDate?: number | null,
    cancelReason?: string | null,
    cancelNote?: string | null,
    metadata:  {
      __typename: "UserAppointementMetadata",
      acuityAppointmentId?: string | null,
      acuityAppointmentTypeId?: string | null,
      acuityConfirmationPageUrl?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserAppointmentsSubscriptionVariables = {
  filter?: ModelSubscriptionUserAppointmentsFilterInput | null,
};

export type OnUpdateUserAppointmentsSubscription = {
  onUpdateUserAppointments?:  {
    __typename: "UserAppointments",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointmentStartTime: number,
    appointmentEndTime: number,
    appointmentDurationMins: number,
    appointmentTimezone: string,
    appointmentType: AppointmentTypeEnum,
    cancelled?: BoolEnum | null,
    cancelDate?: number | null,
    cancelReason?: string | null,
    cancelNote?: string | null,
    metadata:  {
      __typename: "UserAppointementMetadata",
      acuityAppointmentId?: string | null,
      acuityAppointmentTypeId?: string | null,
      acuityConfirmationPageUrl?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserAppointmentsSubscriptionVariables = {
  filter?: ModelSubscriptionUserAppointmentsFilterInput | null,
};

export type OnDeleteUserAppointmentsSubscription = {
  onDeleteUserAppointments?:  {
    __typename: "UserAppointments",
    id: string,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointmentStartTime: number,
    appointmentEndTime: number,
    appointmentDurationMins: number,
    appointmentTimezone: string,
    appointmentType: AppointmentTypeEnum,
    cancelled?: BoolEnum | null,
    cancelDate?: number | null,
    cancelReason?: string | null,
    cancelNote?: string | null,
    metadata:  {
      __typename: "UserAppointementMetadata",
      acuityAppointmentId?: string | null,
      acuityAppointmentTypeId?: string | null,
      acuityConfirmationPageUrl?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionUserNotificationFilterInput | null,
};

export type OnCreateUserNotificationSubscription = {
  onCreateUserNotification?:  {
    __typename: "UserNotification",
    id: string,
    userId: string,
    notificationType: UserNotificationTypeEnum,
    notificationMessage: string,
    notificationTitle: string,
    notificationExpirationDate?: string | null,
    notificationRead: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionUserNotificationFilterInput | null,
};

export type OnUpdateUserNotificationSubscription = {
  onUpdateUserNotification?:  {
    __typename: "UserNotification",
    id: string,
    userId: string,
    notificationType: UserNotificationTypeEnum,
    notificationMessage: string,
    notificationTitle: string,
    notificationExpirationDate?: string | null,
    notificationRead: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionUserNotificationFilterInput | null,
};

export type OnDeleteUserNotificationSubscription = {
  onDeleteUserNotification?:  {
    __typename: "UserNotification",
    id: string,
    userId: string,
    notificationType: UserNotificationTypeEnum,
    notificationMessage: string,
    notificationTitle: string,
    notificationExpirationDate?: string | null,
    notificationRead: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCoachSubscriptionVariables = {
  filter?: ModelSubscriptionCoachFilterInput | null,
};

export type OnCreateCoachSubscription = {
  onCreateCoach?:  {
    __typename: "Coach",
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    title?: string | null,
    coachType?: Array< CoachTypeEnum | null > | null,
    avatarUrl?: string | null,
    description?: string | null,
    metadata?:  {
      __typename: "CoachMetaData",
      introVideoUrl?: string | null,
      gcalId?: string | null,
      calendlyId?: string | null,
      acuityCalendarId?: string | null,
      acuityUserId?: string | null,
      acuityKey?: string | null,
      acuityIssAppointmentId?: string | null,
      acuityRegularAppointmentId?: string | null,
      streamChatId?: string | null,
      slackId?: string | null,
      lastCoachNote?: number | null,
      lastChatMessage?: number | null,
    } | null,
    focusAreas?:  {
      __typename: "ModelCoachFocusAreaConnection",
      items:  Array< {
        __typename: "CoachFocusArea",
        id: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    members?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCoachSubscriptionVariables = {
  filter?: ModelSubscriptionCoachFilterInput | null,
};

export type OnUpdateCoachSubscription = {
  onUpdateCoach?:  {
    __typename: "Coach",
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    title?: string | null,
    coachType?: Array< CoachTypeEnum | null > | null,
    avatarUrl?: string | null,
    description?: string | null,
    metadata?:  {
      __typename: "CoachMetaData",
      introVideoUrl?: string | null,
      gcalId?: string | null,
      calendlyId?: string | null,
      acuityCalendarId?: string | null,
      acuityUserId?: string | null,
      acuityKey?: string | null,
      acuityIssAppointmentId?: string | null,
      acuityRegularAppointmentId?: string | null,
      streamChatId?: string | null,
      slackId?: string | null,
      lastCoachNote?: number | null,
      lastChatMessage?: number | null,
    } | null,
    focusAreas?:  {
      __typename: "ModelCoachFocusAreaConnection",
      items:  Array< {
        __typename: "CoachFocusArea",
        id: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    members?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCoachSubscriptionVariables = {
  filter?: ModelSubscriptionCoachFilterInput | null,
};

export type OnDeleteCoachSubscription = {
  onDeleteCoach?:  {
    __typename: "Coach",
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    title?: string | null,
    coachType?: Array< CoachTypeEnum | null > | null,
    avatarUrl?: string | null,
    description?: string | null,
    metadata?:  {
      __typename: "CoachMetaData",
      introVideoUrl?: string | null,
      gcalId?: string | null,
      calendlyId?: string | null,
      acuityCalendarId?: string | null,
      acuityUserId?: string | null,
      acuityKey?: string | null,
      acuityIssAppointmentId?: string | null,
      acuityRegularAppointmentId?: string | null,
      streamChatId?: string | null,
      slackId?: string | null,
      lastCoachNote?: number | null,
      lastChatMessage?: number | null,
    } | null,
    focusAreas?:  {
      __typename: "ModelCoachFocusAreaConnection",
      items:  Array< {
        __typename: "CoachFocusArea",
        id: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    members?:  {
      __typename: "ModelUserCoachConnection",
      items:  Array< {
        __typename: "UserCoach",
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        isPrimary: BoolEnum,
        active: BoolEnum,
        coachingStartDate: string,
        coachingEndDate?: string | null,
        ratings?:  {
          __typename: "ModelUserCoachRatingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCoachFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionCoachFocusAreaFilterInput | null,
};

export type OnCreateCoachFocusAreaSubscription = {
  onCreateCoachFocusArea?:  {
    __typename: "CoachFocusArea",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCoachFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionCoachFocusAreaFilterInput | null,
};

export type OnUpdateCoachFocusAreaSubscription = {
  onUpdateCoachFocusArea?:  {
    __typename: "CoachFocusArea",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCoachFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionCoachFocusAreaFilterInput | null,
};

export type OnDeleteCoachFocusAreaSubscription = {
  onDeleteCoachFocusArea?:  {
    __typename: "CoachFocusArea",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCoachUserNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionCoachUserNotificationFilterInput | null,
};

export type OnCreateCoachUserNotificationSubscription = {
  onCreateCoachUserNotification?:  {
    __typename: "CoachUserNotification",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    title: string,
    read: BoolEnum,
    readTimestamp?: number | null,
    notificationType: CoachNotificationTypeEnum,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCoachUserNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionCoachUserNotificationFilterInput | null,
};

export type OnUpdateCoachUserNotificationSubscription = {
  onUpdateCoachUserNotification?:  {
    __typename: "CoachUserNotification",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    title: string,
    read: BoolEnum,
    readTimestamp?: number | null,
    notificationType: CoachNotificationTypeEnum,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCoachUserNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionCoachUserNotificationFilterInput | null,
};

export type OnDeleteCoachUserNotificationSubscription = {
  onDeleteCoachUserNotification?:  {
    __typename: "CoachUserNotification",
    id: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    title: string,
    read: BoolEnum,
    readTimestamp?: number | null,
    notificationType: CoachNotificationTypeEnum,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateGrowthPathItemSubscriptionVariables = {
  filter?: ModelSubscriptionGrowthPathItemFilterInput | null,
};

export type OnCreateGrowthPathItemSubscription = {
  onCreateGrowthPathItem?:  {
    __typename: "GrowthPathItem",
    id: string,
    type: GrowthPathCardTypeEnum,
    title: string,
    subtitle?: string | null,
    avatarUrl?: string | null,
    description: string,
    categoryName?: string | null,
    categoryId?: string | null,
    estimatedCompletionTimeInMins?: number | null,
    actionTitle: string,
    actionDestination: string,
    actionPayload?: string | null,
    createdAt: string,
    expirationDate?: string | null,
    lessonId?: string | null,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    tags?: Array< string | null > | null,
    isArchived: BoolEnum,
    updatedAt: string,
  } | null,
};

export type OnUpdateGrowthPathItemSubscriptionVariables = {
  filter?: ModelSubscriptionGrowthPathItemFilterInput | null,
};

export type OnUpdateGrowthPathItemSubscription = {
  onUpdateGrowthPathItem?:  {
    __typename: "GrowthPathItem",
    id: string,
    type: GrowthPathCardTypeEnum,
    title: string,
    subtitle?: string | null,
    avatarUrl?: string | null,
    description: string,
    categoryName?: string | null,
    categoryId?: string | null,
    estimatedCompletionTimeInMins?: number | null,
    actionTitle: string,
    actionDestination: string,
    actionPayload?: string | null,
    createdAt: string,
    expirationDate?: string | null,
    lessonId?: string | null,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    tags?: Array< string | null > | null,
    isArchived: BoolEnum,
    updatedAt: string,
  } | null,
};

export type OnDeleteGrowthPathItemSubscriptionVariables = {
  filter?: ModelSubscriptionGrowthPathItemFilterInput | null,
};

export type OnDeleteGrowthPathItemSubscription = {
  onDeleteGrowthPathItem?:  {
    __typename: "GrowthPathItem",
    id: string,
    type: GrowthPathCardTypeEnum,
    title: string,
    subtitle?: string | null,
    avatarUrl?: string | null,
    description: string,
    categoryName?: string | null,
    categoryId?: string | null,
    estimatedCompletionTimeInMins?: number | null,
    actionTitle: string,
    actionDestination: string,
    actionPayload?: string | null,
    createdAt: string,
    expirationDate?: string | null,
    lessonId?: string | null,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    tags?: Array< string | null > | null,
    isArchived: BoolEnum,
    updatedAt: string,
  } | null,
};

export type OnCreateTopicTagsSubscriptionVariables = {
  filter?: ModelSubscriptionTopicTagsFilterInput | null,
};

export type OnCreateTopicTagsSubscription = {
  onCreateTopicTags?:  {
    __typename: "TopicTags",
    slug: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTopicTagsSubscriptionVariables = {
  filter?: ModelSubscriptionTopicTagsFilterInput | null,
};

export type OnUpdateTopicTagsSubscription = {
  onUpdateTopicTags?:  {
    __typename: "TopicTags",
    slug: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTopicTagsSubscriptionVariables = {
  filter?: ModelSubscriptionTopicTagsFilterInput | null,
};

export type OnDeleteTopicTagsSubscription = {
  onDeleteTopicTags?:  {
    __typename: "TopicTags",
    slug: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaFilterInput | null,
};

export type OnCreateFocusAreaSubscription = {
  onCreateFocusArea?:  {
    __typename: "FocusArea",
    id: string,
    name: string,
    slug: string,
    description?: string | null,
    focusAreaGoals?:  {
      __typename: "ModelFocusAreaGoalConnection",
      items:  Array< {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaFilterInput | null,
};

export type OnUpdateFocusAreaSubscription = {
  onUpdateFocusArea?:  {
    __typename: "FocusArea",
    id: string,
    name: string,
    slug: string,
    description?: string | null,
    focusAreaGoals?:  {
      __typename: "ModelFocusAreaGoalConnection",
      items:  Array< {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaFilterInput | null,
};

export type OnDeleteFocusAreaSubscription = {
  onDeleteFocusArea?:  {
    __typename: "FocusArea",
    id: string,
    name: string,
    slug: string,
    description?: string | null,
    focusAreaGoals?:  {
      __typename: "ModelFocusAreaGoalConnection",
      items:  Array< {
        __typename: "FocusAreaGoal",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalHabits?:  {
          __typename: "ModelFocusAreaGoalHabitsConnection",
          nextToken?: string | null,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFocusAreaGoalSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaGoalFilterInput | null,
};

export type OnCreateFocusAreaGoalSubscription = {
  onCreateFocusAreaGoal?:  {
    __typename: "FocusAreaGoal",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabits?:  {
      __typename: "ModelFocusAreaGoalHabitsConnection",
      items:  Array< {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFocusAreaGoalSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaGoalFilterInput | null,
};

export type OnUpdateFocusAreaGoalSubscription = {
  onUpdateFocusAreaGoal?:  {
    __typename: "FocusAreaGoal",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabits?:  {
      __typename: "ModelFocusAreaGoalHabitsConnection",
      items:  Array< {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFocusAreaGoalSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaGoalFilterInput | null,
};

export type OnDeleteFocusAreaGoalSubscription = {
  onDeleteFocusAreaGoal?:  {
    __typename: "FocusAreaGoal",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalHabits?:  {
      __typename: "ModelFocusAreaGoalHabitsConnection",
      items:  Array< {
        __typename: "FocusAreaGoalHabits",
        id: string,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaGoalId: string,
        focusAreaGoal?:  {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        slug: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFocusAreaGoalHabitsSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaGoalHabitsFilterInput | null,
};

export type OnCreateFocusAreaGoalHabitsSubscription = {
  onCreateFocusAreaGoalHabits?:  {
    __typename: "FocusAreaGoalHabits",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFocusAreaGoalHabitsSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaGoalHabitsFilterInput | null,
};

export type OnUpdateFocusAreaGoalHabitsSubscription = {
  onUpdateFocusAreaGoalHabits?:  {
    __typename: "FocusAreaGoalHabits",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFocusAreaGoalHabitsSubscriptionVariables = {
  filter?: ModelSubscriptionFocusAreaGoalHabitsFilterInput | null,
};

export type OnDeleteFocusAreaGoalHabitsSubscription = {
  onDeleteFocusAreaGoalHabits?:  {
    __typename: "FocusAreaGoalHabits",
    id: string,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaGoalId: string,
    focusAreaGoal?:  {
      __typename: "FocusAreaGoal",
      id: string,
      focusAreaId: string,
      focusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      focusAreaGoalHabits?:  {
        __typename: "ModelFocusAreaGoalHabitsConnection",
        items:  Array< {
          __typename: "FocusAreaGoalHabits",
          id: string,
          focusAreaId: string,
          focusAreaGoalId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      name: string,
      slug: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    slug: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProgramSubscriptionVariables = {
  filter?: ModelSubscriptionProgramFilterInput | null,
};

export type OnCreateProgramSubscription = {
  onCreateProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    level: number,
    lessons?:  {
      __typename: "ModelLessonConnection",
      items:  Array< {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProgramSubscriptionVariables = {
  filter?: ModelSubscriptionProgramFilterInput | null,
};

export type OnUpdateProgramSubscription = {
  onUpdateProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    level: number,
    lessons?:  {
      __typename: "ModelLessonConnection",
      items:  Array< {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProgramSubscriptionVariables = {
  filter?: ModelSubscriptionProgramFilterInput | null,
};

export type OnDeleteProgramSubscription = {
  onDeleteProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    level: number,
    lessons?:  {
      __typename: "ModelLessonConnection",
      items:  Array< {
        __typename: "Lesson",
        id: string,
        programId: string,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          level: number,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        order: number,
        durationInMins: number,
        description?: string | null,
        transcript?: string | null,
        focusAreas?:  {
          __typename: "ModelLessonFocusAreaConnection",
          nextToken?: string | null,
        } | null,
        tags?: Array< string | null > | null,
        lessonType: LessonTypeEnum,
        metadata?:  {
          __typename: "LessonMetadata",
          videoUrl?: string | null,
          videoStreamUrl?: string | null,
          videoExternalId?: string | null,
          videoDistributionPage?: string | null,
          formUrl?: string | null,
          formExternalId?: string | null,
        } | null,
        coverImageUrl?: string | null,
        isPremium: BoolEnum,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLessonSubscriptionVariables = {
  filter?: ModelSubscriptionLessonFilterInput | null,
};

export type OnCreateLessonSubscription = {
  onCreateLesson?:  {
    __typename: "Lesson",
    id: string,
    programId: string,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    order: number,
    durationInMins: number,
    description?: string | null,
    transcript?: string | null,
    focusAreas?:  {
      __typename: "ModelLessonFocusAreaConnection",
      items:  Array< {
        __typename: "LessonFocusArea",
        lessonId: string,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    tags?: Array< string | null > | null,
    lessonType: LessonTypeEnum,
    metadata?:  {
      __typename: "LessonMetadata",
      videoUrl?: string | null,
      videoStreamUrl?: string | null,
      videoExternalId?: string | null,
      videoDistributionPage?: string | null,
      formUrl?: string | null,
      formExternalId?: string | null,
    } | null,
    coverImageUrl?: string | null,
    isPremium: BoolEnum,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLessonSubscriptionVariables = {
  filter?: ModelSubscriptionLessonFilterInput | null,
};

export type OnUpdateLessonSubscription = {
  onUpdateLesson?:  {
    __typename: "Lesson",
    id: string,
    programId: string,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    order: number,
    durationInMins: number,
    description?: string | null,
    transcript?: string | null,
    focusAreas?:  {
      __typename: "ModelLessonFocusAreaConnection",
      items:  Array< {
        __typename: "LessonFocusArea",
        lessonId: string,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    tags?: Array< string | null > | null,
    lessonType: LessonTypeEnum,
    metadata?:  {
      __typename: "LessonMetadata",
      videoUrl?: string | null,
      videoStreamUrl?: string | null,
      videoExternalId?: string | null,
      videoDistributionPage?: string | null,
      formUrl?: string | null,
      formExternalId?: string | null,
    } | null,
    coverImageUrl?: string | null,
    isPremium: BoolEnum,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLessonSubscriptionVariables = {
  filter?: ModelSubscriptionLessonFilterInput | null,
};

export type OnDeleteLessonSubscription = {
  onDeleteLesson?:  {
    __typename: "Lesson",
    id: string,
    programId: string,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      level: number,
      lessons?:  {
        __typename: "ModelLessonConnection",
        items:  Array< {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    order: number,
    durationInMins: number,
    description?: string | null,
    transcript?: string | null,
    focusAreas?:  {
      __typename: "ModelLessonFocusAreaConnection",
      items:  Array< {
        __typename: "LessonFocusArea",
        lessonId: string,
        lesson?:  {
          __typename: "Lesson",
          id: string,
          programId: string,
          name: string,
          order: number,
          durationInMins: number,
          description?: string | null,
          transcript?: string | null,
          tags?: Array< string | null > | null,
          lessonType: LessonTypeEnum,
          coverImageUrl?: string | null,
          isPremium: BoolEnum,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        focusAreaId: string,
        focusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    tags?: Array< string | null > | null,
    lessonType: LessonTypeEnum,
    metadata?:  {
      __typename: "LessonMetadata",
      videoUrl?: string | null,
      videoStreamUrl?: string | null,
      videoExternalId?: string | null,
      videoDistributionPage?: string | null,
      formUrl?: string | null,
      formExternalId?: string | null,
    } | null,
    coverImageUrl?: string | null,
    isPremium: BoolEnum,
    active: BoolEnum,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLessonFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionLessonFocusAreaFilterInput | null,
};

export type OnCreateLessonFocusAreaSubscription = {
  onCreateLessonFocusArea?:  {
    __typename: "LessonFocusArea",
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLessonFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionLessonFocusAreaFilterInput | null,
};

export type OnUpdateLessonFocusAreaSubscription = {
  onUpdateLessonFocusArea?:  {
    __typename: "LessonFocusArea",
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLessonFocusAreaSubscriptionVariables = {
  filter?: ModelSubscriptionLessonFocusAreaFilterInput | null,
};

export type OnDeleteLessonFocusAreaSubscription = {
  onDeleteLessonFocusArea?:  {
    __typename: "LessonFocusArea",
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      programId: string,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        level: number,
        lessons?:  {
          __typename: "ModelLessonConnection",
          nextToken?: string | null,
        } | null,
        active: BoolEnum,
        createdAt: string,
        updatedAt: string,
      } | null,
      name: string,
      order: number,
      durationInMins: number,
      description?: string | null,
      transcript?: string | null,
      focusAreas?:  {
        __typename: "ModelLessonFocusAreaConnection",
        items:  Array< {
          __typename: "LessonFocusArea",
          lessonId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      tags?: Array< string | null > | null,
      lessonType: LessonTypeEnum,
      metadata?:  {
        __typename: "LessonMetadata",
        videoUrl?: string | null,
        videoStreamUrl?: string | null,
        videoExternalId?: string | null,
        videoDistributionPage?: string | null,
        formUrl?: string | null,
        formExternalId?: string | null,
      } | null,
      coverImageUrl?: string | null,
      isPremium: BoolEnum,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    focusAreaId: string,
    focusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePlanGroupSubscriptionVariables = {
  filter?: ModelSubscriptionPlanGroupFilterInput | null,
};

export type OnCreatePlanGroupSubscription = {
  onCreatePlanGroup?:  {
    __typename: "PlanGroup",
    id: string,
    name: string,
    startDate: string,
    endDate: string,
    trialPeriod: number,
    createdAt: string,
    active: BoolEnum,
    plans?:  {
      __typename: "ModelPlanConnection",
      items:  Array< {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePlanGroupSubscriptionVariables = {
  filter?: ModelSubscriptionPlanGroupFilterInput | null,
};

export type OnUpdatePlanGroupSubscription = {
  onUpdatePlanGroup?:  {
    __typename: "PlanGroup",
    id: string,
    name: string,
    startDate: string,
    endDate: string,
    trialPeriod: number,
    createdAt: string,
    active: BoolEnum,
    plans?:  {
      __typename: "ModelPlanConnection",
      items:  Array< {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePlanGroupSubscriptionVariables = {
  filter?: ModelSubscriptionPlanGroupFilterInput | null,
};

export type OnDeletePlanGroupSubscription = {
  onDeletePlanGroup?:  {
    __typename: "PlanGroup",
    id: string,
    name: string,
    startDate: string,
    endDate: string,
    trialPeriod: number,
    createdAt: string,
    active: BoolEnum,
    plans?:  {
      __typename: "ModelPlanConnection",
      items:  Array< {
        __typename: "Plan",
        id: string,
        planGroupId: string,
        planGroup?:  {
          __typename: "PlanGroup",
          id: string,
          name: string,
          startDate: string,
          endDate: string,
          trialPeriod: number,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null,
        name: string,
        description?: string | null,
        active: BoolEnum,
        defaultPrice: number,
        defaultPlanPriceId?: string | null,
        discountsAllowed?: boolean | null,
        display?: boolean | null,
        isTrial?: boolean | null,
        upgradeable?: boolean | null,
        downgradeable?: boolean | null,
        features: Array< string >,
        createdAt: string,
        level: number,
        pricing?:  {
          __typename: "ModelPlanPricingConnection",
          nextToken?: string | null,
        } | null,
        metadata?:  {
          __typename: "PlanMetadata",
          coachingSessionsAllocated: number,
          stripeProductId?: string | null,
        } | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
};

export type OnCreatePlanSubscription = {
  onCreatePlan?:  {
    __typename: "Plan",
    id: string,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    name: string,
    description?: string | null,
    active: BoolEnum,
    defaultPrice: number,
    defaultPlanPriceId?: string | null,
    discountsAllowed?: boolean | null,
    display?: boolean | null,
    isTrial?: boolean | null,
    upgradeable?: boolean | null,
    downgradeable?: boolean | null,
    features: Array< string >,
    createdAt: string,
    level: number,
    pricing?:  {
      __typename: "ModelPlanPricingConnection",
      items:  Array< {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata?:  {
      __typename: "PlanMetadata",
      coachingSessionsAllocated: number,
      stripeProductId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
};

export type OnUpdatePlanSubscription = {
  onUpdatePlan?:  {
    __typename: "Plan",
    id: string,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    name: string,
    description?: string | null,
    active: BoolEnum,
    defaultPrice: number,
    defaultPlanPriceId?: string | null,
    discountsAllowed?: boolean | null,
    display?: boolean | null,
    isTrial?: boolean | null,
    upgradeable?: boolean | null,
    downgradeable?: boolean | null,
    features: Array< string >,
    createdAt: string,
    level: number,
    pricing?:  {
      __typename: "ModelPlanPricingConnection",
      items:  Array< {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata?:  {
      __typename: "PlanMetadata",
      coachingSessionsAllocated: number,
      stripeProductId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
};

export type OnDeletePlanSubscription = {
  onDeletePlan?:  {
    __typename: "Plan",
    id: string,
    planGroupId: string,
    planGroup?:  {
      __typename: "PlanGroup",
      id: string,
      name: string,
      startDate: string,
      endDate: string,
      trialPeriod: number,
      createdAt: string,
      active: BoolEnum,
      plans?:  {
        __typename: "ModelPlanConnection",
        items:  Array< {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    name: string,
    description?: string | null,
    active: BoolEnum,
    defaultPrice: number,
    defaultPlanPriceId?: string | null,
    discountsAllowed?: boolean | null,
    display?: boolean | null,
    isTrial?: boolean | null,
    upgradeable?: boolean | null,
    downgradeable?: boolean | null,
    features: Array< string >,
    createdAt: string,
    level: number,
    pricing?:  {
      __typename: "ModelPlanPricingConnection",
      items:  Array< {
        __typename: "PlanPricing",
        planId: string,
        plan?:  {
          __typename: "Plan",
          id: string,
          planGroupId: string,
          name: string,
          description?: string | null,
          active: BoolEnum,
          defaultPrice: number,
          defaultPlanPriceId?: string | null,
          discountsAllowed?: boolean | null,
          display?: boolean | null,
          isTrial?: boolean | null,
          upgradeable?: boolean | null,
          downgradeable?: boolean | null,
          features: Array< string >,
          createdAt: string,
          level: number,
          updatedAt: string,
        } | null,
        slug: string,
        default: boolean,
        activationCodes?: Array< string | null > | null,
        downgradePricingIds?: Array< string | null > | null,
        upgradePricingIds?: Array< string | null > | null,
        price: number,
        metadata?:  {
          __typename: "PlanPricingMetada",
          stripePriceId?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    metadata?:  {
      __typename: "PlanMetadata",
      coachingSessionsAllocated: number,
      stripeProductId?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePlanPricingSubscriptionVariables = {
  filter?: ModelSubscriptionPlanPricingFilterInput | null,
};

export type OnCreatePlanPricingSubscription = {
  onCreatePlanPricing?:  {
    __typename: "PlanPricing",
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    slug: string,
    default: boolean,
    activationCodes?: Array< string | null > | null,
    downgradePricingIds?: Array< string | null > | null,
    upgradePricingIds?: Array< string | null > | null,
    price: number,
    metadata?:  {
      __typename: "PlanPricingMetada",
      stripePriceId?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePlanPricingSubscriptionVariables = {
  filter?: ModelSubscriptionPlanPricingFilterInput | null,
};

export type OnUpdatePlanPricingSubscription = {
  onUpdatePlanPricing?:  {
    __typename: "PlanPricing",
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    slug: string,
    default: boolean,
    activationCodes?: Array< string | null > | null,
    downgradePricingIds?: Array< string | null > | null,
    upgradePricingIds?: Array< string | null > | null,
    price: number,
    metadata?:  {
      __typename: "PlanPricingMetada",
      stripePriceId?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePlanPricingSubscriptionVariables = {
  filter?: ModelSubscriptionPlanPricingFilterInput | null,
};

export type OnDeletePlanPricingSubscription = {
  onDeletePlanPricing?:  {
    __typename: "PlanPricing",
    planId: string,
    plan?:  {
      __typename: "Plan",
      id: string,
      planGroupId: string,
      planGroup?:  {
        __typename: "PlanGroup",
        id: string,
        name: string,
        startDate: string,
        endDate: string,
        trialPeriod: number,
        createdAt: string,
        active: BoolEnum,
        plans?:  {
          __typename: "ModelPlanConnection",
          nextToken?: string | null,
        } | null,
        updatedAt: string,
      } | null,
      name: string,
      description?: string | null,
      active: BoolEnum,
      defaultPrice: number,
      defaultPlanPriceId?: string | null,
      discountsAllowed?: boolean | null,
      display?: boolean | null,
      isTrial?: boolean | null,
      upgradeable?: boolean | null,
      downgradeable?: boolean | null,
      features: Array< string >,
      createdAt: string,
      level: number,
      pricing?:  {
        __typename: "ModelPlanPricingConnection",
        items:  Array< {
          __typename: "PlanPricing",
          planId: string,
          slug: string,
          default: boolean,
          activationCodes?: Array< string | null > | null,
          downgradePricingIds?: Array< string | null > | null,
          upgradePricingIds?: Array< string | null > | null,
          price: number,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata?:  {
        __typename: "PlanMetadata",
        coachingSessionsAllocated: number,
        stripeProductId?: string | null,
      } | null,
      updatedAt: string,
    } | null,
    slug: string,
    default: boolean,
    activationCodes?: Array< string | null > | null,
    downgradePricingIds?: Array< string | null > | null,
    upgradePricingIds?: Array< string | null > | null,
    price: number,
    metadata?:  {
      __typename: "PlanPricingMetada",
      stripePriceId?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnCreateEventSubscription = {
  onCreateEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventTimeConnection",
      items:  Array< {
        __typename: "EventTime",
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        metadata?:  {
          __typename: "EventTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
      activeCampaignTagId?: number | null,
      totalSessions?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventTimeConnection",
      items:  Array< {
        __typename: "EventTime",
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        metadata?:  {
          __typename: "EventTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
      activeCampaignTagId?: number | null,
      totalSessions?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    title: string,
    description?: string | null,
    features?:  Array< {
      __typename: "EventFeature",
      title: string,
      description?: string | null,
    } > | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    hostFirstName: string,
    hostLastName: string,
    hostEmail?: string | null,
    hostWebsite?: string | null,
    hostAvatar?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    eventType: EventTypeEnum,
    attendeeLimit: number,
    attendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventTimeConnection",
      items:  Array< {
        __typename: "EventTime",
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        metadata?:  {
          __typename: "EventTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sessions?:  {
      __typename: "ModelEventSessionConnection",
      items:  Array< {
        __typename: "EventSession",
        id: string,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sessionTitle?: string | null,
        sessionDescription?: string | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        isRecurring: BoolEnum,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        attendeeLimit: number,
        facilitators?:  {
          __typename: "ModelEventSessionFacilitatorConnection",
          nextToken?: string | null,
        } | null,
        eventSessionAttendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventSessionTimeConnection",
          nextToken?: string | null,
        } | null,
        eventSessionFocusAreaId?: string | null,
        eventSessionFocusArea?:  {
          __typename: "FocusArea",
          id: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventSessionMetadata",
          chatChannelId?: string | null,
          eventSessionLandingPageUrl?: string | null,
          eventSessionMeetingLink?: string | null,
          actuityAppointmentTypeId?: string | null,
          acuityCalendarId?: string | null,
          activeCampaignTagId?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    price: number,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventMetadata",
      stripeProductId?: string | null,
      stripePriceId?: string | null,
      eventLandingPageUrl?: string | null,
      eventMeetingLink?: string | null,
      activeCampaignTagId?: number | null,
      totalSessions?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventTimeSubscriptionVariables = {
  filter?: ModelSubscriptionEventTimeFilterInput | null,
};

export type OnCreateEventTimeSubscription = {
  onCreateEventTime?:  {
    __typename: "EventTime",
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    metadata?:  {
      __typename: "EventTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventTimeSubscriptionVariables = {
  filter?: ModelSubscriptionEventTimeFilterInput | null,
};

export type OnUpdateEventTimeSubscription = {
  onUpdateEventTime?:  {
    __typename: "EventTime",
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    metadata?:  {
      __typename: "EventTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventTimeSubscriptionVariables = {
  filter?: ModelSubscriptionEventTimeFilterInput | null,
};

export type OnDeleteEventTimeSubscription = {
  onDeleteEventTime?:  {
    __typename: "EventTime",
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    metadata?:  {
      __typename: "EventTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventSessionSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionFilterInput | null,
};

export type OnCreateEventSessionSubscription = {
  onCreateEventSession?:  {
    __typename: "EventSession",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sessionTitle?: string | null,
    sessionDescription?: string | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    isRecurring: BoolEnum,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    attendeeLimit: number,
    facilitators?:  {
      __typename: "ModelEventSessionFacilitatorConnection",
      items:  Array< {
        __typename: "EventSessionFacilitator",
        eventSessionId: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionAttendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventSessionTimeConnection",
      items:  Array< {
        __typename: "EventSessionTime",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        metadata?:  {
          __typename: "EventSessionTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionFocusAreaId?: string | null,
    eventSessionFocusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventSessionMetadata",
      chatChannelId?: string | null,
      eventSessionLandingPageUrl?: string | null,
      eventSessionMeetingLink?: string | null,
      actuityAppointmentTypeId?: string | null,
      acuityCalendarId?: string | null,
      activeCampaignTagId?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventSessionSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionFilterInput | null,
};

export type OnUpdateEventSessionSubscription = {
  onUpdateEventSession?:  {
    __typename: "EventSession",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sessionTitle?: string | null,
    sessionDescription?: string | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    isRecurring: BoolEnum,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    attendeeLimit: number,
    facilitators?:  {
      __typename: "ModelEventSessionFacilitatorConnection",
      items:  Array< {
        __typename: "EventSessionFacilitator",
        eventSessionId: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionAttendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventSessionTimeConnection",
      items:  Array< {
        __typename: "EventSessionTime",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        metadata?:  {
          __typename: "EventSessionTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionFocusAreaId?: string | null,
    eventSessionFocusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventSessionMetadata",
      chatChannelId?: string | null,
      eventSessionLandingPageUrl?: string | null,
      eventSessionMeetingLink?: string | null,
      actuityAppointmentTypeId?: string | null,
      acuityCalendarId?: string | null,
      activeCampaignTagId?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventSessionSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionFilterInput | null,
};

export type OnDeleteEventSessionSubscription = {
  onDeleteEventSession?:  {
    __typename: "EventSession",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sessionTitle?: string | null,
    sessionDescription?: string | null,
    startDate: string,
    endDate: string,
    startTimestamp: number,
    endTimestamp: number,
    timezone: string,
    isRecurring: BoolEnum,
    allowFreeMembers: BoolEnum,
    allowSprout: BoolEnum,
    allowBloom: BoolEnum,
    attendeeLimit: number,
    facilitators?:  {
      __typename: "ModelEventSessionFacilitatorConnection",
      items:  Array< {
        __typename: "EventSessionFacilitator",
        eventSessionId: string,
        coachId: string,
        coach?:  {
          __typename: "Coach",
          id: string,
          firstName: string,
          lastName: string,
          email: string,
          title?: string | null,
          coachType?: Array< CoachTypeEnum | null > | null,
          avatarUrl?: string | null,
          description?: string | null,
          active: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionAttendees?:  {
      __typename: "ModelEventSessionAttendeesConnection",
      items:  Array< {
        __typename: "EventSessionAttendees",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        userId: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          phone?: string | null,
          avatar?: string | null,
          userBio?: string | null,
          age?: number | null,
          dateOfBirth?: string | null,
          genderId?: string | null,
          createdAt: string,
          status: UserStatusEnum,
          lastSeen?: number | null,
          referralSource: string,
          roles: Array< RolesEnum >,
          stage?: FunnelStageEnum | null,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        confirmed: BoolEnum,
        confirmationTimestamp?: number | null,
        metadata?:  {
          __typename: "EventSessionAttendeeMetadata",
          paymentTimestamp?: number | null,
          stripeInvoiceId?: string | null,
          rawPaymentLog?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    times?:  {
      __typename: "ModelEventSessionTimeConnection",
      items:  Array< {
        __typename: "EventSessionTime",
        eventSessionId: string,
        eventSession?:  {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        eventId: string,
        event?:  {
          __typename: "Event",
          id: string,
          name: string,
          title: string,
          description?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          hostFirstName: string,
          hostLastName: string,
          hostEmail?: string | null,
          hostWebsite?: string | null,
          hostAvatar?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          eventType: EventTypeEnum,
          attendeeLimit: number,
          price: number,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        name: string,
        title: string,
        type: EventTimeTypeEnum,
        description?: string | null,
        startDate: string,
        endDate: string,
        timezone?: string | null,
        metadata?:  {
          __typename: "EventSessionTimeMetadata",
          acuityCalendarId?: string | null,
          acuityAppointmentTypeId?: string | null,
          meetingLinkVideo?: string | null,
          meetingLinkAudio?: string | null,
          recordingLink?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    eventSessionFocusAreaId?: string | null,
    eventSessionFocusArea?:  {
      __typename: "FocusArea",
      id: string,
      name: string,
      slug: string,
      description?: string | null,
      focusAreaGoals?:  {
        __typename: "ModelFocusAreaGoalConnection",
        items:  Array< {
          __typename: "FocusAreaGoal",
          id: string,
          focusAreaId: string,
          name: string,
          slug: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    featureImageUrl?: string | null,
    metadata?:  {
      __typename: "EventSessionMetadata",
      chatChannelId?: string | null,
      eventSessionLandingPageUrl?: string | null,
      eventSessionMeetingLink?: string | null,
      actuityAppointmentTypeId?: string | null,
      acuityCalendarId?: string | null,
      activeCampaignTagId?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventSessionTimeSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionTimeFilterInput | null,
};

export type OnCreateEventSessionTimeSubscription = {
  onCreateEventSessionTime?:  {
    __typename: "EventSessionTime",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    metadata?:  {
      __typename: "EventSessionTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventSessionTimeSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionTimeFilterInput | null,
};

export type OnUpdateEventSessionTimeSubscription = {
  onUpdateEventSessionTime?:  {
    __typename: "EventSessionTime",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    metadata?:  {
      __typename: "EventSessionTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventSessionTimeSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionTimeFilterInput | null,
};

export type OnDeleteEventSessionTimeSubscription = {
  onDeleteEventSessionTime?:  {
    __typename: "EventSessionTime",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    name: string,
    title: string,
    type: EventTimeTypeEnum,
    description?: string | null,
    startDate: string,
    endDate: string,
    timezone?: string | null,
    metadata?:  {
      __typename: "EventSessionTimeMetadata",
      acuityCalendarId?: string | null,
      acuityAppointmentTypeId?: string | null,
      meetingLinkVideo?: string | null,
      meetingLinkAudio?: string | null,
      recordingLink?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventSessionFacilitatorSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionFacilitatorFilterInput | null,
};

export type OnCreateEventSessionFacilitatorSubscription = {
  onCreateEventSessionFacilitator?:  {
    __typename: "EventSessionFacilitator",
    eventSessionId: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventSessionFacilitatorSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionFacilitatorFilterInput | null,
};

export type OnUpdateEventSessionFacilitatorSubscription = {
  onUpdateEventSessionFacilitator?:  {
    __typename: "EventSessionFacilitator",
    eventSessionId: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventSessionFacilitatorSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionFacilitatorFilterInput | null,
};

export type OnDeleteEventSessionFacilitatorSubscription = {
  onDeleteEventSessionFacilitator?:  {
    __typename: "EventSessionFacilitator",
    eventSessionId: string,
    coachId: string,
    coach?:  {
      __typename: "Coach",
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      title?: string | null,
      coachType?: Array< CoachTypeEnum | null > | null,
      avatarUrl?: string | null,
      description?: string | null,
      metadata?:  {
        __typename: "CoachMetaData",
        introVideoUrl?: string | null,
        gcalId?: string | null,
        calendlyId?: string | null,
        acuityCalendarId?: string | null,
        acuityUserId?: string | null,
        acuityKey?: string | null,
        acuityIssAppointmentId?: string | null,
        acuityRegularAppointmentId?: string | null,
        streamChatId?: string | null,
        slackId?: string | null,
        lastCoachNote?: number | null,
        lastChatMessage?: number | null,
      } | null,
      focusAreas?:  {
        __typename: "ModelCoachFocusAreaConnection",
        items:  Array< {
          __typename: "CoachFocusArea",
          id: string,
          coachId: string,
          focusAreaId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      members?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      active: BoolEnum,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventSessionAttendeesSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionAttendeesFilterInput | null,
};

export type OnCreateEventSessionAttendeesSubscription = {
  onCreateEventSessionAttendees?:  {
    __typename: "EventSessionAttendees",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    confirmed: BoolEnum,
    confirmationTimestamp?: number | null,
    metadata?:  {
      __typename: "EventSessionAttendeeMetadata",
      paymentTimestamp?: number | null,
      stripeInvoiceId?: string | null,
      rawPaymentLog?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventSessionAttendeesSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionAttendeesFilterInput | null,
};

export type OnUpdateEventSessionAttendeesSubscription = {
  onUpdateEventSessionAttendees?:  {
    __typename: "EventSessionAttendees",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    confirmed: BoolEnum,
    confirmationTimestamp?: number | null,
    metadata?:  {
      __typename: "EventSessionAttendeeMetadata",
      paymentTimestamp?: number | null,
      stripeInvoiceId?: string | null,
      rawPaymentLog?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventSessionAttendeesSubscriptionVariables = {
  filter?: ModelSubscriptionEventSessionAttendeesFilterInput | null,
};

export type OnDeleteEventSessionAttendeesSubscription = {
  onDeleteEventSessionAttendees?:  {
    __typename: "EventSessionAttendees",
    eventSessionId: string,
    eventSession?:  {
      __typename: "EventSession",
      id: string,
      eventId: string,
      event?:  {
        __typename: "Event",
        id: string,
        name: string,
        title: string,
        description?: string | null,
        features?:  Array< {
          __typename: "EventFeature",
          title: string,
          description?: string | null,
        } > | null,
        startDate: string,
        endDate: string,
        startTimestamp: number,
        endTimestamp: number,
        timezone: string,
        hostFirstName: string,
        hostLastName: string,
        hostEmail?: string | null,
        hostWebsite?: string | null,
        hostAvatar?: string | null,
        allowFreeMembers: BoolEnum,
        allowSprout: BoolEnum,
        allowBloom: BoolEnum,
        eventType: EventTypeEnum,
        attendeeLimit: number,
        attendees?:  {
          __typename: "ModelEventSessionAttendeesConnection",
          nextToken?: string | null,
        } | null,
        times?:  {
          __typename: "ModelEventTimeConnection",
          nextToken?: string | null,
        } | null,
        sessions?:  {
          __typename: "ModelEventSessionConnection",
          nextToken?: string | null,
        } | null,
        price: number,
        featureImageUrl?: string | null,
        metadata?:  {
          __typename: "EventMetadata",
          stripeProductId?: string | null,
          stripePriceId?: string | null,
          eventLandingPageUrl?: string | null,
          eventMeetingLink?: string | null,
          activeCampaignTagId?: number | null,
          totalSessions?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sessionTitle?: string | null,
      sessionDescription?: string | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      isRecurring: BoolEnum,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      attendeeLimit: number,
      facilitators?:  {
        __typename: "ModelEventSessionFacilitatorConnection",
        items:  Array< {
          __typename: "EventSessionFacilitator",
          eventSessionId: string,
          coachId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionAttendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventSessionTimeConnection",
        items:  Array< {
          __typename: "EventSessionTime",
          eventSessionId: string,
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      eventSessionFocusAreaId?: string | null,
      eventSessionFocusArea?:  {
        __typename: "FocusArea",
        id: string,
        name: string,
        slug: string,
        description?: string | null,
        focusAreaGoals?:  {
          __typename: "ModelFocusAreaGoalConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventSessionMetadata",
        chatChannelId?: string | null,
        eventSessionLandingPageUrl?: string | null,
        eventSessionMeetingLink?: string | null,
        actuityAppointmentTypeId?: string | null,
        acuityCalendarId?: string | null,
        activeCampaignTagId?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      address?:  {
        __typename: "Address",
        houseNumber?: string | null,
        street?: string | null,
        streetType?: string | null,
        address1: string,
        address2?: string | null,
        address3?: string | null,
        city: string,
        state: string,
        postalCode: string,
        county?: string | null,
        country?: string | null,
        latLng?:  {
          __typename: "LocationPoint",
          lat?: number | null,
          lon?: number | null,
        } | null,
      } | null,
      avatar?: string | null,
      userBio?: string | null,
      age?: number | null,
      dateOfBirth?: string | null,
      genderId?: string | null,
      createdAt: string,
      status: UserStatusEnum,
      lastSeen?: number | null,
      referralSource: string,
      roles: Array< RolesEnum >,
      stage?: FunnelStageEnum | null,
      plans?:  {
        __typename: "ModelUserPlanConnection",
        items:  Array< {
          __typename: "UserPlan",
          id: string,
          userId: string,
          planId: string,
          planGroupId: string,
          planPricingSlug: string,
          startDate: string,
          endDate?: string | null,
          cancelled?: BoolEnum | null,
          cancellationReason?: string | null,
          createdAt: string,
          active: BoolEnum,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelUserAppointmentsConnection",
        items:  Array< {
          __typename: "UserAppointments",
          id: string,
          userId: string,
          coachId: string,
          appointmentStartTime: number,
          appointmentEndTime: number,
          appointmentDurationMins: number,
          appointmentTimezone: string,
          appointmentType: AppointmentTypeEnum,
          cancelled?: BoolEnum | null,
          cancelDate?: number | null,
          cancelReason?: string | null,
          cancelNote?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      coaches?:  {
        __typename: "ModelUserCoachConnection",
        items:  Array< {
          __typename: "UserCoach",
          userId: string,
          coachId: string,
          isPrimary: BoolEnum,
          active: BoolEnum,
          coachingStartDate: string,
          coachingEndDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      growthPaths?:  {
        __typename: "ModelUserGrowthPathItemConnection",
        items:  Array< {
          __typename: "UserGrowthPathItem",
          id: string,
          growthPathItemId: string,
          userId: string,
          order?: number | null,
          dateTimeAdded: number,
          completed: BoolEnum,
          dismissed: BoolEnum,
          completedTimestamp?: number | null,
          expirationDate?: string | null,
          locked: BoolEnum,
          hidden: BoolEnum,
          isScheduled: BoolEnum,
          visibleDate: string,
          visibleTimestamp?: number | null,
          growthPathJourneyId?: string | null,
          growthPathJourneyStep?: number | null,
          coachId?: string | null,
          source?: UserGrowthPathItemSourceEnum | null,
          lastActivityTimestamp?: number | null,
          dependsOnGrowthPathItems?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      metadata:  {
        __typename: "UserMetadata",
        lastLogin: number,
        trialStartDate?: string | null,
        trialEndDate?: string | null,
        subscriptionStatus?: SubscriptionStatusEnum | null,
        deviceId?: string | null,
        deviceOS?: string | null,
        deviceOSVersion?: string | null,
        allowAccountNotifications?: boolean | null,
        allowMarketingNotifications?: boolean | null,
        allowCoachingNotifications?: boolean | null,
        initialAssessmentCompletedDate?: string | null,
        lastWeeklyCheckinDate?: string | null,
        lastGrowthStageAssessmentDate?: string | null,
        primaryFocusCategoryId?: string | null,
        primaryFocusGoalId?: string | null,
        secondaryFocusCategoryId?: string | null,
        secondaryFocusGoalId?: string | null,
        tertiaryFocusCategoryId?: string | null,
        tertiaryFocusGoalId?: string | null,
        preferredCoachingTimeOfDay?: TimeOfDayEnum | null,
        preferredCoachingDaysOfWeek?: Array< DaysOfWeekEnum | null > | null,
        primaryCoachId?: string | null,
        userIPAddress?: string | null,
        intakeCompleted?: BoolEnum | null,
        onboardingCompleted?: BoolEnum | null,
        issCompleted?: BoolEnum | null,
        stipeCustomerId?: string | null,
        lastActive?: number | null,
      },
      updatedAt: string,
    } | null,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      title: string,
      description?: string | null,
      features?:  Array< {
        __typename: "EventFeature",
        title: string,
        description?: string | null,
      } > | null,
      startDate: string,
      endDate: string,
      startTimestamp: number,
      endTimestamp: number,
      timezone: string,
      hostFirstName: string,
      hostLastName: string,
      hostEmail?: string | null,
      hostWebsite?: string | null,
      hostAvatar?: string | null,
      allowFreeMembers: BoolEnum,
      allowSprout: BoolEnum,
      allowBloom: BoolEnum,
      eventType: EventTypeEnum,
      attendeeLimit: number,
      attendees?:  {
        __typename: "ModelEventSessionAttendeesConnection",
        items:  Array< {
          __typename: "EventSessionAttendees",
          eventSessionId: string,
          userId: string,
          eventId: string,
          confirmed: BoolEnum,
          confirmationTimestamp?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      times?:  {
        __typename: "ModelEventTimeConnection",
        items:  Array< {
          __typename: "EventTime",
          eventId: string,
          name: string,
          title: string,
          type: EventTimeTypeEnum,
          description?: string | null,
          startDate: string,
          endDate: string,
          timezone?: string | null,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sessions?:  {
        __typename: "ModelEventSessionConnection",
        items:  Array< {
          __typename: "EventSession",
          id: string,
          eventId: string,
          sessionTitle?: string | null,
          sessionDescription?: string | null,
          startDate: string,
          endDate: string,
          startTimestamp: number,
          endTimestamp: number,
          timezone: string,
          isRecurring: BoolEnum,
          allowFreeMembers: BoolEnum,
          allowSprout: BoolEnum,
          allowBloom: BoolEnum,
          attendeeLimit: number,
          eventSessionFocusAreaId?: string | null,
          featureImageUrl?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      price: number,
      featureImageUrl?: string | null,
      metadata?:  {
        __typename: "EventMetadata",
        stripeProductId?: string | null,
        stripePriceId?: string | null,
        eventLandingPageUrl?: string | null,
        eventMeetingLink?: string | null,
        activeCampaignTagId?: number | null,
        totalSessions?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    confirmed: BoolEnum,
    confirmationTimestamp?: number | null,
    metadata?:  {
      __typename: "EventSessionAttendeeMetadata",
      paymentTimestamp?: number | null,
      stripeInvoiceId?: string | null,
      rawPaymentLog?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};
